import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import { useRemoteMutation, useRemoteLazyQuery, useRemoteQuery, } from "@vividtheory/vt-remote-apollo";
const defaultOptions = {};
export class AccessKey {
}
export class AccessKeyCustomerInput {
}
export var AccessKeyStatus;
(function (AccessKeyStatus) {
    AccessKeyStatus["Active"] = "Active";
    AccessKeyStatus["Expired"] = "Expired";
    AccessKeyStatus["Revoked"] = "Revoked";
})(AccessKeyStatus || (AccessKeyStatus = {}));
export class ActiveDataSourceExtended {
}
export class ActiveDataSourcesCountConnection {
}
export class AddJourneyStep {
}
export class AddJourneyStepResponse {
}
export var Applications;
(function (Applications) {
    Applications["datalab"] = "datalab";
    Applications["datascape"] = "datascape";
    Applications["marketplace"] = "marketplace";
    Applications["studio"] = "studio";
})(Applications || (Applications = {}));
export class Area {
}
export class AreaExtended {
}
export class AssignOrganizationOwnersInput {
}
export class AssignOwnerInput {
}
export class AuthenticatedOrganizationUser {
}
export class AuthenticatedProductUser {
}
export class AuthenticatedUser {
}
export class AwsConnectionInfo {
}
export class AwsCredential {
}
export var AwsCredentialType;
(function (AwsCredentialType) {
    AwsCredentialType["IAM"] = "IAM";
    AwsCredentialType["PURL"] = "PURL";
})(AwsCredentialType || (AwsCredentialType = {}));
export class AwsIamCredential {
}
export class AwsPurlCredential {
}
export class AwsStorage {
}
export class AwsStorageInfo {
}
export class AzureAadCredential {
}
export class AzureConnectionInfo {
}
export class AzureCredential {
}
export var AzureCredentialType;
(function (AzureCredentialType) {
    AzureCredentialType["AAD"] = "AAD";
    AzureCredentialType["SAS"] = "SAS";
})(AzureCredentialType || (AzureCredentialType = {}));
export class AzureDataProviderEntity {
}
export class AzureEntitlementEntity {
}
export class AzureMarketplaceDatasetEntity {
}
export class AzureSasCredential {
}
export class AzureStorage {
}
export class AzureStorageInfo {
}
export class BgLong {
}
export class BillingPortalSession {
}
export class BoundarySetTableCountConnection {
}
export class Bounds {
}
export class ClientOnboardingCta {
}
export class ClientOnboardingStep {
}
export var CloudConnectionErrorType;
(function (CloudConnectionErrorType) {
    CloudConnectionErrorType["Authentication"] = "Authentication";
    CloudConnectionErrorType["Connection"] = "Connection";
    CloudConnectionErrorType["NotFound"] = "NotFound";
    CloudConnectionErrorType["Timeout"] = "Timeout";
})(CloudConnectionErrorType || (CloudConnectionErrorType = {}));
export class CloudFileDetail {
}
export var CloudStorageType;
(function (CloudStorageType) {
    CloudStorageType["Aws"] = "Aws";
    CloudStorageType["Azure"] = "Azure";
    CloudStorageType["Gcp"] = "Gcp";
    CloudStorageType["GoogleDrive"] = "GoogleDrive";
    CloudStorageType["Sf"] = "Sf";
    CloudStorageType["Upload"] = "Upload";
})(CloudStorageType || (CloudStorageType = {}));
export class ColorSwatch {
}
export class ColumnAttributes {
}
export class ComputeChanges {
}
export var ComputeStatus;
(function (ComputeStatus) {
    ComputeStatus["cold"] = "cold";
    ComputeStatus["hot"] = "hot";
    ComputeStatus["loading"] = "loading";
    ComputeStatus["unloading"] = "unloading";
    ComputeStatus["warm"] = "warm";
})(ComputeStatus || (ComputeStatus = {}));
export var ConditionSide;
(function (ConditionSide) {
    ConditionSide["False"] = "False";
    ConditionSide["True"] = "True";
})(ConditionSide || (ConditionSide = {}));
export var ConnectionType;
(function (ConnectionType) {
    ConnectionType["organization"] = "organization";
    ConnectionType["product"] = "product";
    ConnectionType["team"] = "team";
    ConnectionType["userInvite"] = "userInvite";
})(ConnectionType || (ConnectionType = {}));
export var ContainerBasePath;
(function (ContainerBasePath) {
    ContainerBasePath["datasets"] = "datasets";
})(ContainerBasePath || (ContainerBasePath = {}));
export var Continent;
(function (Continent) {
    Continent["africa"] = "africa";
    Continent["asia"] = "asia";
    Continent["centralAmerica"] = "centralAmerica";
    Continent["europe"] = "europe";
    Continent["northAmerica"] = "northAmerica";
    Continent["oceania"] = "oceania";
    Continent["southAmerica"] = "southAmerica";
})(Continent || (Continent = {}));
export var Country;
(function (Country) {
    Country["Afghanistan"] = "Afghanistan";
    Country["Albania"] = "Albania";
    Country["Algeria"] = "Algeria";
    Country["Andorra"] = "Andorra";
    Country["Angola"] = "Angola";
    Country["AntiguaAndBarbuda"] = "AntiguaAndBarbuda";
    Country["Argentina"] = "Argentina";
    Country["Armenia"] = "Armenia";
    Country["Australia"] = "Australia";
    Country["Austria"] = "Austria";
    Country["Azerbaijan"] = "Azerbaijan";
    Country["Bahamas"] = "Bahamas";
    Country["Bahrain"] = "Bahrain";
    Country["Bangladesh"] = "Bangladesh";
    Country["Barbados"] = "Barbados";
    Country["Belarus"] = "Belarus";
    Country["Belgium"] = "Belgium";
    Country["Belize"] = "Belize";
    Country["Benin"] = "Benin";
    Country["Bhutan"] = "Bhutan";
    Country["Bolivia"] = "Bolivia";
    Country["BosniaAndHerzegovina"] = "BosniaAndHerzegovina";
    Country["Botswana"] = "Botswana";
    Country["Brazil"] = "Brazil";
    Country["Brunei"] = "Brunei";
    Country["Bulgaria"] = "Bulgaria";
    Country["BurkinaFaso"] = "BurkinaFaso";
    Country["Burundi"] = "Burundi";
    Country["CaboVerde"] = "CaboVerde";
    Country["Cambodia"] = "Cambodia";
    Country["Cameroon"] = "Cameroon";
    Country["Canada"] = "Canada";
    Country["CentralAfricanRepublic"] = "CentralAfricanRepublic";
    Country["Chad"] = "Chad";
    Country["Chile"] = "Chile";
    Country["China"] = "China";
    Country["Colombia"] = "Colombia";
    Country["Comoros"] = "Comoros";
    Country["CostaRica"] = "CostaRica";
    Country["Croatia"] = "Croatia";
    Country["Cuba"] = "Cuba";
    Country["Cyprus"] = "Cyprus";
    Country["CzechRepublic"] = "CzechRepublic";
    Country["DemocraticRepublicOfTheCongo"] = "DemocraticRepublicOfTheCongo";
    Country["Denmark"] = "Denmark";
    Country["Djibouti"] = "Djibouti";
    Country["Dominica"] = "Dominica";
    Country["DominicanRepublic"] = "DominicanRepublic";
    Country["Ecuador"] = "Ecuador";
    Country["Egypt"] = "Egypt";
    Country["ElSalvador"] = "ElSalvador";
    Country["EquatorialGuinea"] = "EquatorialGuinea";
    Country["Eritrea"] = "Eritrea";
    Country["Estonia"] = "Estonia";
    Country["Eswatini"] = "Eswatini";
    Country["Ethiopia"] = "Ethiopia";
    Country["FederatedStatesOfMicronesia"] = "FederatedStatesOfMicronesia";
    Country["Fiji"] = "Fiji";
    Country["Finland"] = "Finland";
    Country["France"] = "France";
    Country["Gabon"] = "Gabon";
    Country["Gambia"] = "Gambia";
    Country["Georgia"] = "Georgia";
    Country["Germany"] = "Germany";
    Country["Ghana"] = "Ghana";
    Country["Greece"] = "Greece";
    Country["Grenada"] = "Grenada";
    Country["Guatemala"] = "Guatemala";
    Country["Guinea"] = "Guinea";
    Country["GuineaBissau"] = "GuineaBissau";
    Country["Guyana"] = "Guyana";
    Country["Haiti"] = "Haiti";
    Country["Honduras"] = "Honduras";
    Country["Hungary"] = "Hungary";
    Country["Iceland"] = "Iceland";
    Country["India"] = "India";
    Country["Indonesia"] = "Indonesia";
    Country["Iran"] = "Iran";
    Country["Iraq"] = "Iraq";
    Country["Ireland"] = "Ireland";
    Country["Israel"] = "Israel";
    Country["Italy"] = "Italy";
    Country["IvoryCoast"] = "IvoryCoast";
    Country["Jamaica"] = "Jamaica";
    Country["Japan"] = "Japan";
    Country["Jordan"] = "Jordan";
    Country["Kazakhstan"] = "Kazakhstan";
    Country["Kenya"] = "Kenya";
    Country["Kiribati"] = "Kiribati";
    Country["Kosovo"] = "Kosovo";
    Country["Kuwait"] = "Kuwait";
    Country["Kyrgyzstan"] = "Kyrgyzstan";
    Country["Laos"] = "Laos";
    Country["Latvia"] = "Latvia";
    Country["Lebanon"] = "Lebanon";
    Country["Lesotho"] = "Lesotho";
    Country["Liberia"] = "Liberia";
    Country["Libya"] = "Libya";
    Country["Liechtenstein"] = "Liechtenstein";
    Country["Lithuania"] = "Lithuania";
    Country["Luxembourg"] = "Luxembourg";
    Country["Madagascar"] = "Madagascar";
    Country["Malawi"] = "Malawi";
    Country["Malaysia"] = "Malaysia";
    Country["Maldives"] = "Maldives";
    Country["Mali"] = "Mali";
    Country["Malta"] = "Malta";
    Country["MarshallIslands"] = "MarshallIslands";
    Country["Mauritania"] = "Mauritania";
    Country["Mauritius"] = "Mauritius";
    Country["Mexico"] = "Mexico";
    Country["Moldova"] = "Moldova";
    Country["Monaco"] = "Monaco";
    Country["Mongolia"] = "Mongolia";
    Country["Montenegro"] = "Montenegro";
    Country["Morocco"] = "Morocco";
    Country["Mozambique"] = "Mozambique";
    Country["Myanmar"] = "Myanmar";
    Country["Namibia"] = "Namibia";
    Country["Nauru"] = "Nauru";
    Country["Nepal"] = "Nepal";
    Country["Netherlands"] = "Netherlands";
    Country["NewZealand"] = "NewZealand";
    Country["Nicaragua"] = "Nicaragua";
    Country["Niger"] = "Niger";
    Country["Nigeria"] = "Nigeria";
    Country["NorthMacedonia"] = "NorthMacedonia";
    Country["Norway"] = "Norway";
    Country["Oman"] = "Oman";
    Country["Pakistan"] = "Pakistan";
    Country["Palau"] = "Palau";
    Country["Panama"] = "Panama";
    Country["PapuaNewGuinea"] = "PapuaNewGuinea";
    Country["Paraguay"] = "Paraguay";
    Country["Peru"] = "Peru";
    Country["Philippines"] = "Philippines";
    Country["Poland"] = "Poland";
    Country["Portugal"] = "Portugal";
    Country["PuertoRico"] = "PuertoRico";
    Country["Qatar"] = "Qatar";
    Country["RepublicOfTheCongo"] = "RepublicOfTheCongo";
    Country["Romania"] = "Romania";
    Country["Russia"] = "Russia";
    Country["Rwanda"] = "Rwanda";
    Country["SaintKittsAndNevis"] = "SaintKittsAndNevis";
    Country["SaintLucia"] = "SaintLucia";
    Country["SaintVincentAndTheGrenadines"] = "SaintVincentAndTheGrenadines";
    Country["Samoa"] = "Samoa";
    Country["SanMarino"] = "SanMarino";
    Country["SaoTomeAndPrincipe"] = "SaoTomeAndPrincipe";
    Country["SaudiArabia"] = "SaudiArabia";
    Country["Senegal"] = "Senegal";
    Country["Serbia"] = "Serbia";
    Country["Seychelles"] = "Seychelles";
    Country["SierraLeone"] = "SierraLeone";
    Country["Singapore"] = "Singapore";
    Country["Slovakia"] = "Slovakia";
    Country["Slovenia"] = "Slovenia";
    Country["SolomonIslands"] = "SolomonIslands";
    Country["Somalia"] = "Somalia";
    Country["SouthAfrica"] = "SouthAfrica";
    Country["SouthKorea"] = "SouthKorea";
    Country["SouthSudan"] = "SouthSudan";
    Country["Spain"] = "Spain";
    Country["SriLanka"] = "SriLanka";
    Country["Sudan"] = "Sudan";
    Country["Suriname"] = "Suriname";
    Country["Sweden"] = "Sweden";
    Country["Switzerland"] = "Switzerland";
    Country["Syria"] = "Syria";
    Country["Taiwan"] = "Taiwan";
    Country["Tajikistan"] = "Tajikistan";
    Country["Tanzania"] = "Tanzania";
    Country["Thailand"] = "Thailand";
    Country["TimorLeste"] = "TimorLeste";
    Country["Togo"] = "Togo";
    Country["Tonga"] = "Tonga";
    Country["TrinidadAndTobago"] = "TrinidadAndTobago";
    Country["Tunisia"] = "Tunisia";
    Country["Turkey"] = "Turkey";
    Country["Turkmenistan"] = "Turkmenistan";
    Country["Tuvalu"] = "Tuvalu";
    Country["USA"] = "USA";
    Country["Uganda"] = "Uganda";
    Country["Ukraine"] = "Ukraine";
    Country["UnitedArabEmirates"] = "UnitedArabEmirates";
    Country["UnitedKingdom"] = "UnitedKingdom";
    Country["Uruguay"] = "Uruguay";
    Country["Uzbekistan"] = "Uzbekistan";
    Country["Vanuatu"] = "Vanuatu";
    Country["VaticanCity"] = "VaticanCity";
    Country["Venezuela"] = "Venezuela";
    Country["Vietnam"] = "Vietnam";
    Country["Yemen"] = "Yemen";
    Country["Zambia"] = "Zambia";
    Country["Zimbabwe"] = "Zimbabwe";
})(Country || (Country = {}));
export class CreateAdminPlatformNotification {
}
export class CreateAzureDataProvider {
}
export class CreateAzureMarketplace {
}
export class CreateDatasetSampleRequest {
}
export class CreateDemoInstanceInput {
}
export class CreateEditTeamForm {
}
export class CreateEditUserSegmentInput {
}
export class CreateJourney {
}
export class CreateMarketplaceDataset {
}
export class CreateOrganizationInput {
}
export class CreateOrganizationUserInput {
}
export class CreatePlatformNotification {
}
export class CreateProductUser {
}
export class CreateTeamForm {
}
export class CreateUserInvite {
}
export class CredentialsInput {
}
export var CronInterval;
(function (CronInterval) {
    CronInterval["Daily"] = "Daily";
    CronInterval["Monthly"] = "Monthly";
    CronInterval["Never"] = "Never";
    CronInterval["Weekly"] = "Weekly";
})(CronInterval || (CronInterval = {}));
export var CronJobName;
(function (CronJobName) {
    CronJobName["DeleteExpiredGeneratedFile"] = "DeleteExpiredGeneratedFile";
    CronJobName["RefreshEtlDatasetLocation"] = "RefreshEtlDatasetLocation";
})(CronJobName || (CronJobName = {}));
export class CronJobType {
}
export var CronTaskTrigger;
(function (CronTaskTrigger) {
    CronTaskTrigger["NewlyAdded"] = "NewlyAdded";
    CronTaskTrigger["Updated"] = "Updated";
})(CronTaskTrigger || (CronTaskTrigger = {}));
export class Customer {
}
export class CustomerExtended {
}
export var CustomerType;
(function (CustomerType) {
    CustomerType["customer"] = "customer";
    CustomerType["lead"] = "lead";
})(CustomerType || (CustomerType = {}));
export class DataGridFetchInput {
}
export var DataOrigin;
(function (DataOrigin) {
    DataOrigin["aerialSurveys"] = "aerialSurveys";
    DataOrigin["crowdsourcedData"] = "crowdsourcedData";
    DataOrigin["enterpriseDatabases"] = "enterpriseDatabases";
    DataOrigin["governmentOpenData"] = "governmentOpenData";
    DataOrigin["iotSensors"] = "iotSensors";
    DataOrigin["mobileGpsData"] = "mobileGpsData";
    DataOrigin["other"] = "other";
    DataOrigin["satelliteImagery"] = "satelliteImagery";
    DataOrigin["scientificResearch"] = "scientificResearch";
    DataOrigin["thirdParty"] = "thirdParty";
    DataOrigin["webScraping"] = "webScraping";
})(DataOrigin || (DataOrigin = {}));
export class DataProduct {
}
export class DataProductExtended {
}
export class DataProductVariantBoundaryPricesConnection {
}
export class DataProductVariantBoundarySetPrice {
}
export class DataProductVariantsConnection {
}
export class DataProductVariantsCountConnection {
}
export class DataProductsTable {
}
export class DataProductsTableCountConnection {
}
export class DataSourceComputeStatusConnection {
}
export class DataSourceConfiguration {
}
export class DataSourceEtlLocation {
}
export class DataSourceNumVariantsConnection {
}
export class DataSourcePermission {
}
export class DataSourcePermissionUserConnection {
}
export class DataSourcePrice {
}
export class DataSourcePriceAccessControls {
}
export class DataSourcePriceActiveSubscriptionConnection {
}
export class DataSourcePriceActiveSubscriptionDataSourceConnection {
}
export class DataSourcePriceCountConnection {
}
export var DataSourcePriceCoverage;
(function (DataSourcePriceCoverage) {
    DataSourcePriceCoverage["full"] = "full";
    DataSourcePriceCoverage["partial"] = "partial";
})(DataSourcePriceCoverage || (DataSourcePriceCoverage = {}));
export class DataSourcePriceDelivery {
}
export class DataSourcePriceExtended {
}
export class DataSourcePriceExtendedCountConnection {
}
export class DataSourcePriceFeatures {
}
export class DataSourcePriceLicensing {
}
export class DataSourcePricePriceFrequencyConnection {
}
export class DataSourcePricePublishedConnection {
}
export class DataSourcePricePublishedCountConnection {
}
export class DataSourcePriceWithDataSourceCountConnection {
}
export var DataSourcePricesSubscriptionFrequency;
(function (DataSourcePricesSubscriptionFrequency) {
    DataSourcePricesSubscriptionFrequency["daily"] = "daily";
    DataSourcePricesSubscriptionFrequency["free"] = "free";
    DataSourcePricesSubscriptionFrequency["monthly"] = "monthly";
    DataSourcePricesSubscriptionFrequency["oneTime"] = "oneTime";
    DataSourcePricesSubscriptionFrequency["weekly"] = "weekly";
    DataSourcePricesSubscriptionFrequency["yearly"] = "yearly";
})(DataSourcePricesSubscriptionFrequency || (DataSourcePricesSubscriptionFrequency = {}));
export var DataSourcePricesUsage;
(function (DataSourcePricesUsage) {
    DataSourcePricesUsage["current"] = "current";
    DataSourcePricesUsage["recurring"] = "recurring";
})(DataSourcePricesUsage || (DataSourcePricesUsage = {}));
export class DataSourcePricingOptionsConnection {
}
export class DataSourcePricingOptionsCountConnection {
}
export class DataSourceStudio {
}
export class DataSourceWithConfigAndEtlConnection {
}
export class DataSourceWithConfigAndEtlExtended {
}
export class DataSourceWithConfiguration {
}
export class DataSourceWithEtlDetails {
}
export class DataSourceWithSlimOrganization {
}
export var DatabaseType;
(function (DatabaseType) {
    DatabaseType["point"] = "point";
    DatabaseType["polygon"] = "polygon";
})(DatabaseType || (DatabaseType = {}));
export class DatalabAdminOrganization {
}
export class DatalabAdminOrganizationsConnection {
}
export class DatalabEntitlement {
}
export var DatalabFeature;
(function (DatalabFeature) {
    DatalabFeature["datalab_access_keys_credits"] = "datalab_access_keys_credits";
    DatalabFeature["datalab_compute_unit_limit"] = "datalab_compute_unit_limit";
    DatalabFeature["datalab_data_share_credits"] = "datalab_data_share_credits";
    DatalabFeature["datalab_dataset_storage_limit"] = "datalab_dataset_storage_limit";
    DatalabFeature["datalab_dynamic_sampling"] = "datalab_dynamic_sampling";
    DatalabFeature["datalab_listings_assign_datasource"] = "datalab_listings_assign_datasource";
    DatalabFeature["datalab_listings_basic"] = "datalab_listings_basic";
    DatalabFeature["datalab_listings_buy_now"] = "datalab_listings_buy_now";
    DatalabFeature["datalab_paid_tier"] = "datalab_paid_tier";
    DatalabFeature["datalab_team_members"] = "datalab_team_members";
})(DatalabFeature || (DatalabFeature = {}));
export class DatalabFeatureAccess {
}
export class DatalabFeatureAccessCheck {
}
export class DatalabFeatureAccessCount {
}
export class DatalabFeatureAccessResult {
}
export class DatalabFeatureAccessWithTier {
}
export var DatalabPaywallPaymentType;
(function (DatalabPaywallPaymentType) {
    DatalabPaywallPaymentType["manual"] = "manual";
    DatalabPaywallPaymentType["stripe"] = "stripe";
})(DatalabPaywallPaymentType || (DatalabPaywallPaymentType = {}));
export var DatalabPaywallTier;
(function (DatalabPaywallTier) {
    DatalabPaywallTier["datalab_tier_0"] = "datalab_tier_0";
    DatalabPaywallTier["datalab_tier_a"] = "datalab_tier_a";
    DatalabPaywallTier["datalab_tier_b"] = "datalab_tier_b";
    DatalabPaywallTier["datalab_tier_c"] = "datalab_tier_c";
    DatalabPaywallTier["datalab_tier_d"] = "datalab_tier_d";
})(DatalabPaywallTier || (DatalabPaywallTier = {}));
export class DatalabProcessMeter {
}
export class DatalabPurchaseResult {
}
export class DatalabSellerAccount {
}
export class DatalabSellerAccountConnection {
}
export class DatalabSellerAccountSession {
}
export var DatalabSellerAccountStatus;
(function (DatalabSellerAccountStatus) {
    DatalabSellerAccountStatus["active"] = "active";
    DatalabSellerAccountStatus["inactive"] = "inactive";
    DatalabSellerAccountStatus["pending"] = "pending";
})(DatalabSellerAccountStatus || (DatalabSellerAccountStatus = {}));
export var DatalabSellerAccountType;
(function (DatalabSellerAccountType) {
    DatalabSellerAccountType["manual"] = "manual";
    DatalabSellerAccountType["stripe"] = "stripe";
})(DatalabSellerAccountType || (DatalabSellerAccountType = {}));
export class DatalabStorageStats {
}
export class DatalabSubscription {
}
export class DatalabSubscriptionConnection {
}
export class DatalabTierDetails {
}
export class DatalabTierDetailsInput {
}
export class DatasetConfiguration {
}
export class DatasetDataAggregation {
}
export class DatasetDataAggregationHeatmap {
}
export class DatasetGeometryPoint {
}
export class DatasetInquiry {
}
export class DatasetInquiryExtended {
}
export var DatasetInquiryStatus;
(function (DatasetInquiryStatus) {
    DatasetInquiryStatus["active"] = "active";
    DatasetInquiryStatus["pending"] = "pending";
})(DatasetInquiryStatus || (DatasetInquiryStatus = {}));
export var DatasetMode;
(function (DatasetMode) {
    DatasetMode["AllSubitemsAsOne"] = "AllSubitemsAsOne";
    DatasetMode["EachSubitemAsOne"] = "EachSubitemAsOne";
})(DatasetMode || (DatasetMode = {}));
export class DatasetSampleRequest {
}
export class DatasetStatus {
}
export var DatasetStatusType;
(function (DatasetStatusType) {
    DatasetStatusType["Error"] = "Error";
    DatasetStatusType["LoadedInRam"] = "LoadedInRam";
    DatasetStatusType["LoadedOnDisk"] = "LoadedOnDisk";
    DatasetStatusType["LoadingFromAzure"] = "LoadingFromAzure";
    DatasetStatusType["LoadingToRam"] = "LoadingToRam";
    DatasetStatusType["NotLoaded"] = "NotLoaded";
    DatasetStatusType["UnloadingFromHot"] = "UnloadingFromHot";
    DatasetStatusType["UnloadingFromWarm"] = "UnloadingFromWarm";
    DatasetStatusType["Unrecognized"] = "Unrecognized";
})(DatasetStatusType || (DatasetStatusType = {}));
export var DatasetStyleType;
(function (DatasetStyleType) {
    DatasetStyleType["customMarker"] = "customMarker";
    DatasetStyleType["dataAggregation"] = "dataAggregation";
    DatasetStyleType["fill"] = "fill";
    DatasetStyleType["shape"] = "shape";
    DatasetStyleType["stroke"] = "stroke";
})(DatasetStyleType || (DatasetStyleType = {}));
export class DatasetStyles {
}
export class DateFilter {
}
export class DeleteEtlInstanceOrError {
}
export class DeleteJourneyStepResponse {
}
export class DeleteSampleFile {
}
export class DeleteStep {
}
export class DeleteTeamForm {
}
export class DeletedStorageBlob {
}
export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["amazonS3Bucket"] = "amazonS3Bucket";
    DeliveryMethod["azureBlobStorage"] = "azureBlobStorage";
    DeliveryMethod["datascape"] = "datascape";
    DeliveryMethod["download"] = "download";
    DeliveryMethod["email"] = "email";
    DeliveryMethod["feedApi"] = "feedApi";
    DeliveryMethod["googleCloudStorage"] = "googleCloudStorage";
    DeliveryMethod["other"] = "other";
    DeliveryMethod["restApi"] = "restApi";
    DeliveryMethod["sftp"] = "sftp";
    DeliveryMethod["soapApi"] = "soapApi";
    DeliveryMethod["streamingApi"] = "streamingApi";
})(DeliveryMethod || (DeliveryMethod = {}));
export class DemoInstances {
}
export var DiscountType;
(function (DiscountType) {
    DiscountType["amount"] = "amount";
    DiscountType["percentage"] = "percentage";
})(DiscountType || (DiscountType = {}));
export var DownloadType;
(function (DownloadType) {
    DownloadType["files"] = "files";
    DownloadType["folders"] = "folders";
})(DownloadType || (DownloadType = {}));
export var DuckDbFileType;
(function (DuckDbFileType) {
    DuckDbFileType["csv"] = "csv";
    DuckDbFileType["parquet"] = "parquet";
    DuckDbFileType["shp"] = "shp";
    DuckDbFileType["zip"] = "zip";
})(DuckDbFileType || (DuckDbFileType = {}));
export var DuckdbErrorType;
(function (DuckdbErrorType) {
    DuckdbErrorType["Convert"] = "Convert";
    DuckdbErrorType["Copy"] = "Copy";
    DuckdbErrorType["General"] = "General";
    DuckdbErrorType["ReturnEmpty"] = "ReturnEmpty";
    DuckdbErrorType["Type"] = "Type";
})(DuckdbErrorType || (DuckdbErrorType = {}));
export class EditActiveJourney {
}
export class EditJourney {
}
export class EditJourneyEventMeta {
}
export class EditJourneyStep {
}
export class EditMarketplaceDataset {
}
export class EditOrganizationUserForm {
}
export class EditTeamForm {
}
export class EgressInput {
}
export class EgressSubscriptionReturn {
}
export var EmailTypes;
(function (EmailTypes) {
    EmailTypes["bg_studio_loginTokenEmail"] = "bg_studio_loginTokenEmail";
    EmailTypes["bg_studio_sendCustomerAccessKey"] = "bg_studio_sendCustomerAccessKey";
    EmailTypes["bg_studio_sendDatasetInquiry"] = "bg_studio_sendDatasetInquiry";
    EmailTypes["bg_studio_teamMemberInvite"] = "bg_studio_teamMemberInvite";
    EmailTypes["testEmail"] = "testEmail";
})(EmailTypes || (EmailTypes = {}));
export class EmailVerifyResponse {
}
export var EnterpriseStatus;
(function (EnterpriseStatus) {
    EnterpriseStatus["subscribed"] = "subscribed";
    EnterpriseStatus["unsubscribed"] = "unsubscribed";
})(EnterpriseStatus || (EnterpriseStatus = {}));
export class Entitlement {
}
export var EntitlementType;
(function (EntitlementType) {
    EntitlementType["Dataset"] = "Dataset";
    EntitlementType["Provider"] = "Provider";
    EntitlementType["Velocity"] = "Velocity";
})(EntitlementType || (EntitlementType = {}));
export class EtlCronInfo {
}
export class EtlDatasetLocation {
}
export class EtlDatasetLocationConnection {
}
export class EtlDatasetLocationDetail {
}
export class EtlDatasetLocationDetailConnection {
}
export class EtlError {
}
export var EtlErrorCriticality;
(function (EtlErrorCriticality) {
    EtlErrorCriticality["Critical"] = "Critical";
    EtlErrorCriticality["High"] = "High";
    EtlErrorCriticality["Low"] = "Low";
    EtlErrorCriticality["Medium"] = "Medium";
})(EtlErrorCriticality || (EtlErrorCriticality = {}));
export var EtlErrorType;
(function (EtlErrorType) {
    EtlErrorType["CloudConnectionError"] = "CloudConnectionError";
    EtlErrorType["DatabaseError"] = "DatabaseError";
    EtlErrorType["DownloadError"] = "DownloadError";
    EtlErrorType["DuckdbError"] = "DuckdbError";
    EtlErrorType["FileSystemError"] = "FileSystemError";
    EtlErrorType["InitializationError"] = "InitializationError";
    EtlErrorType["InsufficientDiskSpaceError"] = "InsufficientDiskSpaceError";
    EtlErrorType["NetworkError"] = "NetworkError";
    EtlErrorType["NotFoundError"] = "NotFoundError";
    EtlErrorType["ParseError"] = "ParseError";
    EtlErrorType["ValidationError"] = "ValidationError";
})(EtlErrorType || (EtlErrorType = {}));
export class EtlInstance {
}
export var EtlInstanceStatus;
(function (EtlInstanceStatus) {
    EtlInstanceStatus["Completed"] = "Completed";
    EtlInstanceStatus["Failed"] = "Failed";
    EtlInstanceStatus["Initialized"] = "Initialized";
    EtlInstanceStatus["Processing"] = "Processing";
})(EtlInstanceStatus || (EtlInstanceStatus = {}));
export var EtlInstanceType;
(function (EtlInstanceType) {
    EtlInstanceType["FilesAcquisition"] = "FilesAcquisition";
    EtlInstanceType["ICantBelieveItsNotParquet"] = "ICantBelieveItsNotParquet";
    EtlInstanceType["IndexDataset"] = "IndexDataset";
})(EtlInstanceType || (EtlInstanceType = {}));
export class EtlOriginalSourcesProcess {
}
export var EtlOriginalSourcesStatus;
(function (EtlOriginalSourcesStatus) {
    EtlOriginalSourcesStatus["Completed"] = "Completed";
    EtlOriginalSourcesStatus["Downloading"] = "Downloading";
    EtlOriginalSourcesStatus["Failed"] = "Failed";
    EtlOriginalSourcesStatus["Initialized"] = "Initialized";
    EtlOriginalSourcesStatus["Uploading"] = "Uploading";
})(EtlOriginalSourcesStatus || (EtlOriginalSourcesStatus = {}));
export class EtlProcess {
}
export class Export {
}
export var ExportFileType;
(function (ExportFileType) {
    ExportFileType["csv"] = "csv";
    ExportFileType["parquet"] = "parquet";
})(ExportFileType || (ExportFileType = {}));
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["completed"] = "completed";
    ExportStatus["failed"] = "failed";
    ExportStatus["queued"] = "queued";
    ExportStatus["running"] = "running";
})(ExportStatus || (ExportStatus = {}));
export class ExternalCredential {
}
export class ExternalCredentialExtended {
}
export class ExternalCredentials {
}
export class ExtraGoogleOAuthParams {
}
export class FetchDataSource {
}
export class FetchDataSources {
}
export class FetchMarketplaceDatasets {
}
export class FetchOneMarketplaceDataset {
}
export class FetchOneTeamInput {
}
export class FetchTeamMembersByTeamInput {
}
export var FileFormat;
(function (FileFormat) {
    FileFormat["biggeoIndex"] = "biggeoIndex";
    FileFormat["binFile"] = "binFile";
    FileFormat["csv"] = "csv";
    FileFormat["excel"] = "excel";
    FileFormat["json"] = "json";
    FileFormat["other"] = "other";
    FileFormat["parquet"] = "parquet";
    FileFormat["sql"] = "sql";
    FileFormat["txt"] = "txt";
    FileFormat["xml"] = "xml";
})(FileFormat || (FileFormat = {}));
export class FileGeneration {
}
export class FileGenerationConnection {
}
export class FileGenerationExtended {
}
export var FileSource;
(function (FileSource) {
    FileSource["bigGeo"] = "bigGeo";
})(FileSource || (FileSource = {}));
export var FileType;
(function (FileType) {
    FileType["csv"] = "csv";
    FileType["geojson"] = "geojson";
    FileType["geoparquet"] = "geoparquet";
    FileType["gpkg"] = "gpkg";
    FileType["json"] = "json";
    FileType["odf"] = "odf";
    FileType["ods"] = "ods";
    FileType["odt"] = "odt";
    FileType["parquet"] = "parquet";
    FileType["shp"] = "shp";
    FileType["unsupported"] = "unsupported";
    FileType["xls"] = "xls";
    FileType["xlsb"] = "xlsb";
    FileType["xlsm"] = "xlsm";
    FileType["xlsx"] = "xlsx";
    FileType["zip"] = "zip";
})(FileType || (FileType = {}));
export var FileUnit;
(function (FileUnit) {
    FileUnit["B"] = "B";
    FileUnit["EB"] = "EB";
    FileUnit["GB"] = "GB";
    FileUnit["KB"] = "KB";
    FileUnit["MB"] = "MB";
    FileUnit["PB"] = "PB";
    FileUnit["TB"] = "TB";
    FileUnit["YB"] = "YB";
    FileUnit["ZB"] = "ZB";
})(FileUnit || (FileUnit = {}));
export class FilterData {
}
export class FilterItem {
}
export class FilterObject {
}
export var FilterType;
(function (FilterType) {
    FilterType["BooleanType"] = "BooleanType";
    FilterType["DateType"] = "DateType";
    FilterType["NumberType"] = "NumberType";
    FilterType["StringType"] = "StringType";
})(FilterType || (FilterType = {}));
export class FindBoundaryInput {
}
export class FindBoundarySetInput {
}
export class FolderSubitemInfo {
}
export var Frequency;
(function (Frequency) {
    Frequency["annual"] = "annual";
    Frequency["daily"] = "daily";
    Frequency["hourly"] = "hourly";
    Frequency["minutely"] = "minutely";
    Frequency["monthly"] = "monthly";
    Frequency["never"] = "never";
    Frequency["onDemand"] = "onDemand";
    Frequency["quarterly"] = "quarterly";
    Frequency["realTime"] = "realTime";
    Frequency["secondly"] = "secondly";
    Frequency["weekly"] = "weekly";
})(Frequency || (Frequency = {}));
export class GcpConnectionInfo {
}
export class GcpCredential {
}
export var GcpCredentialType;
(function (GcpCredentialType) {
    GcpCredentialType["OAUTH"] = "OAUTH";
    GcpCredentialType["PKEY"] = "PKEY";
})(GcpCredentialType || (GcpCredentialType = {}));
export class GcpOAuthCredential {
}
export class GcpPKeyCredential {
}
export class GcpStorage {
}
export class GcpStorageInfo {
}
export class GeneratedFile {
}
export class GeneratedFileExtended {
}
export var GeneratedFileStatus;
(function (GeneratedFileStatus) {
    GeneratedFileStatus["completed"] = "completed";
    GeneratedFileStatus["expired"] = "expired";
    GeneratedFileStatus["failed"] = "failed";
    GeneratedFileStatus["queued"] = "queued";
    GeneratedFileStatus["running"] = "running";
})(GeneratedFileStatus || (GeneratedFileStatus = {}));
export var GeographyType;
(function (GeographyType) {
    GeographyType["GEOMETRY"] = "GEOMETRY";
    GeographyType["GeoJSON"] = "GeoJSON";
    GeographyType["JSON"] = "JSON";
    GeographyType["LonLat"] = "LonLat";
    GeographyType["WKB"] = "WKB";
    GeographyType["WKT"] = "WKT";
})(GeographyType || (GeographyType = {}));
export class GeometryCollection {
}
export var GeometryCollectionType;
(function (GeometryCollectionType) {
    GeometryCollectionType["GeometryCollection"] = "GeometryCollection";
})(GeometryCollectionType || (GeometryCollectionType = {}));
export class GeometryId {
}
export class GeometryLineStrip {
}
export class GeometryMultiPolygon {
}
export class GeometryPoint {
}
export class GeometryPolygon {
}
export var GeometryType;
(function (GeometryType) {
    GeometryType["Polygon"] = "Polygon";
})(GeometryType || (GeometryType = {}));
export class GetAllBoundarySetsResponse {
}
export class GetBoundariesGeoJsonInput {
}
export class GetBoundariesGeoJsonResponse {
}
export class GoogleDriveConnectionInfo {
}
export class GoogleDriveCredential {
}
export var GoogleDriveCredentialType;
(function (GoogleDriveCredentialType) {
    GoogleDriveCredentialType["OAUTH"] = "OAUTH";
    GoogleDriveCredentialType["URL"] = "URL";
})(GoogleDriveCredentialType || (GoogleDriveCredentialType = {}));
export class GoogleDriveOAuthCredential {
}
export class GoogleDriveStorage {
}
export class GoogleDriveStorageInfo {
}
export class GoogleDriveUrlCredential {
}
export class ICantBelieveItsNotParquet {
}
export class IFetchUserSegmentUsersInput {
}
export class IJourneyRunParams {
}
export class ITestJourneyEvent {
}
export var Industry;
(function (Industry) {
    Industry["CommerceAndIndustry"] = "CommerceAndIndustry";
    Industry["EnergyAndUtility"] = "EnergyAndUtility";
    Industry["EnvironmentalAndLandManagement"] = "EnvironmentalAndLandManagement";
    Industry["HealthcareAndInsurance"] = "HealthcareAndInsurance";
    Industry["InfrastructureAndConstruction"] = "InfrastructureAndConstruction";
    Industry["PublicSectorAndGovernment"] = "PublicSectorAndGovernment";
    Industry["TechnologyAndSecurity"] = "TechnologyAndSecurity";
    Industry["TourismAndTravel"] = "TourismAndTravel";
    Industry["WeatherAndClimate"] = "WeatherAndClimate";
})(Industry || (Industry = {}));
export class InputAccessKeyDatasources {
}
export class InputArea {
}
export class InputAreaExtended {
}
export class InputAwsCredential {
}
export class InputAwsStorage {
}
export class InputAzureSecretCredential {
}
export class InputAzureStorage {
}
export class InputBgLong {
}
export class InputBounds {
}
export class InputCancelPurchasedDataSource {
}
export class InputCloudStorageConnection {
}
export class InputCloudStorageCredential {
}
export class InputCloudStorageInfo {
}
export class InputColorSwatch {
}
export class InputColumnDetailAndSchemaFromBigGeoAzure {
}
export class InputCreateArea {
}
export class InputCreateBillingPortalSession {
}
export class InputCreateCustomer {
}
export class InputCreateDataListing {
}
export class InputCreateDataSourceConfig {
}
export class InputCreateDataSourceStudio {
}
export class InputCreateDatalabEntitlement {
}
export class InputCreateDatasetInquiry {
}
export class InputCreateEditBoundarySetPrice {
}
export class InputCreateEditDataSourcePrice {
}
export class InputCreateEntitlement {
}
export class InputCreateEtlDatasetLocation {
}
export class InputCreateEtlDatasetLocationExtended {
}
export class InputCreateEtlError {
}
export class InputCreateEtlInstance {
}
export class InputCreateExternalCredential {
}
export class InputCreateInstantOffer {
}
export class InputCreateMapTemplate {
}
export class InputCreateMapTemplateDataset {
}
export class InputCreateOnboardingStepCompletion {
}
export class InputCreateOrUpdateMapTemplateDataset {
}
export class InputCreateProduct {
}
export class InputCreateQuote {
}
export class InputCreateQuoteCustomer {
}
export class InputCreateSavedArea {
}
export class InputCreateSavedAreaGroup {
}
export class InputCreateSavedView {
}
export class InputCreateUserConnection {
}
export class InputCreateUserDataSource {
}
export class InputCronEtlDatasetLocation {
}
export class InputCustomer {
}
export class InputDataProductVariant {
}
export class InputDataProductVariantBoundarySetPrice {
}
export class InputDataProvider {
}
export class InputDataSourceConfig {
}
export class InputDataSourcePermission {
}
export class InputDataSourcePriceAccessControls {
}
export class InputDataSourcePriceDelivery {
}
export class InputDataSourcePriceFeatures {
}
export class InputDataSourcePriceLicensing {
}
export class InputDataSourceStudio {
}
export class InputDatalabEntitlement {
}
export class InputDatascapeDataSource {
}
export class InputDatasetConfiguration {
}
export class InputDatasetDataAggregation {
}
export class InputDatasetDataAggregationHeatmap {
}
export class InputDatasetGeometryPoint {
}
export class InputDatasetInquiry {
}
export class InputDatasetSampleRequest {
}
export class InputDatasetStyles {
}
export class InputDeleteProduct {
}
export class InputEditProduct {
}
export class InputFeatureAccess {
}
export class InputFetchActiveDataSourcePermission {
}
export class InputFetchActiveDataSourcePermissions {
}
export class InputFetchActivePurchasedDataSourceById {
}
export class InputFetchActivePurchasedDataSourceByListingId {
}
export class InputFetchActivePurchasedDataSources {
}
export class InputFetchAllDemoInstances {
}
export class InputFetchAllEtlErrors {
}
export class InputFetchAllEtlInstances {
}
export class InputFetchAllLabAccessKeyExtended {
}
export class InputFetchBoundarySetTable {
}
export class InputFetchCustomerPurchasedDataSources {
}
export class InputFetchCustomers {
}
export class InputFetchDataProduct {
}
export class InputFetchDataSourcePrice {
}
export class InputFetchDataSourcePricePublishedConnections {
}
export class InputFetchDataSourcePrices {
}
export class InputFetchDataSourcePricingOptionsConnections {
}
export class InputFetchDatalabOrganizations {
}
export class InputFetchDatasourcesWithConfigAndEtl {
}
export class InputFetchEtlInstancesByDatasetLocationId {
}
export class InputFetchMarketplaceDatasetDraftDataSourceConnection {
}
export class InputFetchOneProduct {
}
export class InputFetchOrgOwners {
}
export class InputFetchOrgUser {
}
export class InputFetchOrganizationUsers {
}
export class InputFetchOrganizationsWithProduct {
}
export class InputFetchOrgsByUserId {
}
export class InputFetchProducts {
}
export class InputFetchPublishedDataSourcePrice {
}
export class InputFetchSampleFileContents {
}
export class InputFetchUserByOrgUserId {
}
export class InputFetchUserConnection {
}
export class InputFetchUserInvites {
}
export class InputFileGeneration {
}
export class InputFileGenerationConnection {
}
export class InputFilterData {
}
export class InputFilterItem {
}
export class InputFilterObject {
}
export class InputFolderSubitemInfo {
}
export class InputGcpCredential {
}
export class InputGcpStorage {
}
export class InputGenerateAccessKey {
}
export class InputGenerateDatasetsApiKey {
}
export class InputGeneratedFile {
}
export class InputGeometryCollection {
}
export class InputGeometryId {
}
export class InputGetSample {
}
export class InputGoogleDriveCredential {
}
export class InputGoogleDriveStorageInfo {
}
export class InputGoogleLogin {
}
export class InputListingCategoriesDetails {
}
export class InputListingCategoryCountDetails {
}
export class InputListingDataAttributes {
}
export class InputListingDataVolume {
}
export class InputListingTimeline {
}
export class InputMapTemplate {
}
export class InputMapTemplateDataset {
}
export class InputMarketplaceDatasetColumn {
}
export class InputMarketplaceDatasetDraft {
}
export class InputMarketplaceDatasetOptions {
}
export class InputMarketplaceMapPreviewDetails {
}
export class InputMarketplaceSearchOptions {
}
export class InputOriginalSourcesInfo {
}
export class InputParsedSchema {
}
export class InputPlatformNotification {
}
export class InputPoint {
}
export class InputPolygon {
}
export class InputPolygonGeometry {
}
export class InputPolygonProperties {
}
export class InputProduct {
}
export class InputProductUser {
}
export class InputPublishAllDataSourcePrices {
}
export class InputPublishDataSourcePrices {
}
export class InputPurchaseDataSource {
}
export class InputPurchaseInstantOffer {
}
export class InputPurchaseQuote {
}
export class InputPurchaseVariantBoundaries {
}
export class InputPurchasedVariantBoundary {
}
export class InputQuoteBoundary {
}
export class InputQuoteLink {
}
export class InputRequestOptions {
}
export class InputResumePausedCustomerDataSourcePermission {
}
export class InputRevokeCustomerDataSourcePermission {
}
export class InputRing {
}
export class InputSampleFileContents {
}
export class InputSampleSettings {
}
export class InputSavedArea {
}
export class InputSavedAreaExtended {
}
export class InputSavedAreaGroup {
}
export class InputSavedAreaGroupExtended {
}
export class InputSavedView {
}
export class InputSavedViewDataset {
}
export class InputSendAccessKeyEmail {
}
export class InputSendDatasetInquiry {
}
export class InputSendUserInvite {
}
export class InputSfCredential {
}
export class InputSfStorage {
}
export class InputShapeColor {
}
export class InputSignUpOrgUser {
}
export class InputSlimFilterObject {
}
export class InputSortModel {
}
export class InputSpaceTeamMember {
}
export class InputUpdateArea {
}
export class InputUpdateAzureMarketplaceDatasetEntity {
}
export class InputUpdateCustomer {
}
export class InputUpdateDataSourceStudio {
}
export class InputUpdateDatalabEntitlement {
}
export class InputUpdateDatasetApiKey {
}
export class InputUpdateDatasetInquiries {
}
export class InputUpdateDatasetInquiry {
}
export class InputUpdateDatasetStyles {
}
export class InputUpdateEntitleMent {
}
export class InputUpdateEtlDatasetLocation {
}
export class InputUpdateEtlError {
}
export class InputUpdateEtlInstance {
}
export class InputUpdateMapTemplate {
}
export class InputUpdateMapTemplateDataset {
}
export class InputUpdateQuote {
}
export class InputUpdateSavedArea {
}
export class InputUpdateSavedAreaGroup {
}
export class InputUpdateSavedView {
}
export class InputUpdateSavedViewArea {
}
export class InputUpdateUserDataSource {
}
export class InputUploadCredential {
}
export class InputUploadStorage {
}
export class InputUserDataSource {
}
export class InputViewBox {
}
export class InputViewport {
}
export class InstantOffer {
}
export class InstantOfferCustomerVariantConnection {
}
export class InstantOfferExtended {
}
export class InviteCredentialsInput {
}
export var JobStatus;
(function (JobStatus) {
    JobStatus["cancelled"] = "cancelled";
    JobStatus["completed"] = "completed";
    JobStatus["failed"] = "failed";
    JobStatus["queued"] = "queued";
    JobStatus["running"] = "running";
    JobStatus["timeout"] = "timeout";
})(JobStatus || (JobStatus = {}));
export class Journey {
}
export class JourneyEventMeta {
}
export class JourneyRun {
}
export class JourneyRunConnection {
}
export var JourneyRunStartedBy;
(function (JourneyRunStartedBy) {
    JourneyRunStartedBy["event"] = "event";
    JourneyRunStartedBy["rerun"] = "rerun";
})(JourneyRunStartedBy || (JourneyRunStartedBy = {}));
export var JourneyRunStatus;
(function (JourneyRunStatus) {
    JourneyRunStatus["canceled"] = "canceled";
    JourneyRunStatus["failed"] = "failed";
    JourneyRunStatus["running"] = "running";
    JourneyRunStatus["success"] = "success";
})(JourneyRunStatus || (JourneyRunStatus = {}));
export class JourneyStep {
}
export class JourneyStepRun {
}
export var JourneyStepRunStatus;
(function (JourneyStepRunStatus) {
    JourneyStepRunStatus["canceled"] = "canceled";
    JourneyStepRunStatus["failed"] = "failed";
    JourneyStepRunStatus["running"] = "running";
    JourneyStepRunStatus["skipped"] = "skipped";
    JourneyStepRunStatus["success"] = "success";
    JourneyStepRunStatus["waiting"] = "waiting";
})(JourneyStepRunStatus || (JourneyStepRunStatus = {}));
export var KeyPlanOption;
(function (KeyPlanOption) {
    KeyPlanOption["OneTime"] = "OneTime";
    KeyPlanOption["Subscription"] = "Subscription";
})(KeyPlanOption || (KeyPlanOption = {}));
export var KeyType;
(function (KeyType) {
    KeyType["oneTime"] = "oneTime";
    KeyType["subscription"] = "subscription";
})(KeyType || (KeyType = {}));
export class LabAccessKeyExtended {
}
export class LabAccessKeyExtendedConnection {
}
export class LevelSet {
}
export class Links {
}
export class LinksInput {
}
export var ListingCategory;
(function (ListingCategory) {
    ListingCategory["agricultureData"] = "agricultureData";
    ListingCategory["aiAndMachineLearningData"] = "aiAndMachineLearningData";
    ListingCategory["b2bData"] = "b2bData";
    ListingCategory["commerceData"] = "commerceData";
    ListingCategory["consumerData"] = "consumerData";
    ListingCategory["energyData"] = "energyData";
    ListingCategory["environmentalData"] = "environmentalData";
    ListingCategory["financialData"] = "financialData";
    ListingCategory["geospatialData"] = "geospatialData";
    ListingCategory["healthcareData"] = "healthcareData";
    ListingCategory["infrastructureData"] = "infrastructureData";
    ListingCategory["laborAndEmploymentData"] = "laborAndEmploymentData";
    ListingCategory["legalData"] = "legalData";
    ListingCategory["marketingData"] = "marketingData";
    ListingCategory["mediaAndEntertainmentData"] = "mediaAndEntertainmentData";
    ListingCategory["politicalData"] = "politicalData";
    ListingCategory["populationData"] = "populationData";
    ListingCategory["realEstateData"] = "realEstateData";
    ListingCategory["riskData"] = "riskData";
    ListingCategory["telecomData"] = "telecomData";
    ListingCategory["tradeData"] = "tradeData";
    ListingCategory["transportationAndLogisticsData"] = "transportationAndLogisticsData";
    ListingCategory["weatherAndClimateData"] = "weatherAndClimateData";
    ListingCategory["webData"] = "webData";
})(ListingCategory || (ListingCategory = {}));
export class ListingCategoryCountDetails {
}
export var ListingCategoryCountDetailsSource;
(function (ListingCategoryCountDetailsSource) {
    ListingCategoryCountDetailsSource["listings"] = "listings";
    ListingCategoryCountDetailsSource["providers"] = "providers";
})(ListingCategoryCountDetailsSource || (ListingCategoryCountDetailsSource = {}));
export class ListingCategoryDetails {
}
export class ListingDataAttributes {
}
export class ListingDataVolume {
}
export var ListingSubCategory;
(function (ListingSubCategory) {
    ListingSubCategory["administrativeBoundariesData"] = "administrativeBoundariesData";
    ListingSubCategory["advertisingData"] = "advertisingData";
    ListingSubCategory["agriculturalMachineryAndEquipmentData"] = "agriculturalMachineryAndEquipmentData";
    ListingSubCategory["airQualityData"] = "airQualityData";
    ListingSubCategory["airportInfrastructureData"] = "airportInfrastructureData";
    ListingSubCategory["alternativeData"] = "alternativeData";
    ListingSubCategory["annotatedImageryData"] = "annotatedImageryData";
    ListingSubCategory["atmosphereData"] = "atmosphereData";
    ListingSubCategory["attorneyData"] = "attorneyData";
    ListingSubCategory["audienceBehaviorData"] = "audienceBehaviorData";
    ListingSubCategory["audienceData"] = "audienceData";
    ListingSubCategory["audienceMeasurementData"] = "audienceMeasurementData";
    ListingSubCategory["audioAndSpeechRecognitionData"] = "audioAndSpeechRecognitionData";
    ListingSubCategory["audioData"] = "audioData";
    ListingSubCategory["aviationData"] = "aviationData";
    ListingSubCategory["b2bContactData"] = "b2bContactData";
    ListingSubCategory["b2bIntentData"] = "b2bIntentData";
    ListingSubCategory["b2bLeadsData"] = "b2bLeadsData";
    ListingSubCategory["b2bTransactionData"] = "b2bTransactionData";
    ListingSubCategory["b2cContactData"] = "b2cContactData";
    ListingSubCategory["benefitsAndPerksData"] = "benefitsAndPerksData";
    ListingSubCategory["borderAndNationalSecurityData"] = "borderAndNationalSecurityData";
    ListingSubCategory["brandAffinityData"] = "brandAffinityData";
    ListingSubCategory["bridgeData"] = "bridgeData";
    ListingSubCategory["broadbandData"] = "broadbandData";
    ListingSubCategory["budgetAndSpendingData"] = "budgetAndSpendingData";
    ListingSubCategory["buildingFootprintData"] = "buildingFootprintData";
    ListingSubCategory["businessRegistrationData"] = "businessRegistrationData";
    ListingSubCategory["callAndSmsVolumesData"] = "callAndSmsVolumesData";
    ListingSubCategory["campaignAndElectionData"] = "campaignAndElectionData";
    ListingSubCategory["carbonEmissionsData"] = "carbonEmissionsData";
    ListingSubCategory["carbonFootprintData"] = "carbonFootprintData";
    ListingSubCategory["cellTowerData"] = "cellTowerData";
    ListingSubCategory["cellTowerLocationData"] = "cellTowerLocationData";
    ListingSubCategory["censusData"] = "censusData";
    ListingSubCategory["chatbotTrainingData"] = "chatbotTrainingData";
    ListingSubCategory["climateData"] = "climateData";
    ListingSubCategory["climateRiskData"] = "climateRiskData";
    ListingSubCategory["commercialConstructionData"] = "commercialConstructionData";
    ListingSubCategory["commercialLeasingData"] = "commercialLeasingData";
    ListingSubCategory["commercialRealEstateData"] = "commercialRealEstateData";
    ListingSubCategory["commodityData"] = "commodityData";
    ListingSubCategory["companyData"] = "companyData";
    ListingSubCategory["competitiveIntelligenceData"] = "competitiveIntelligenceData";
    ListingSubCategory["computerVisionData"] = "computerVisionData";
    ListingSubCategory["congressionalData"] = "congressionalData";
    ListingSubCategory["constructionPermitsData"] = "constructionPermitsData";
    ListingSubCategory["consumerBehaviorData"] = "consumerBehaviorData";
    ListingSubCategory["consumerDemographicData"] = "consumerDemographicData";
    ListingSubCategory["consumerMarketingData"] = "consumerMarketingData";
    ListingSubCategory["consumerPurchaseData"] = "consumerPurchaseData";
    ListingSubCategory["consumerReviewAndConfidenceData"] = "consumerReviewAndConfidenceData";
    ListingSubCategory["consumerSalesTractionData"] = "consumerSalesTractionData";
    ListingSubCategory["consumerSpendingData"] = "consumerSpendingData";
    ListingSubCategory["consumerTravelData"] = "consumerTravelData";
    ListingSubCategory["consumptionAndLoadData"] = "consumptionAndLoadData";
    ListingSubCategory["contentEngagementData"] = "contentEngagementData";
    ListingSubCategory["contentMetadataAndCatalogData"] = "contentMetadataAndCatalogData";
    ListingSubCategory["contractData"] = "contractData";
    ListingSubCategory["copyrightData"] = "copyrightData";
    ListingSubCategory["corporateAndBankData"] = "corporateAndBankData";
    ListingSubCategory["courtCaseRecords"] = "courtCaseRecords";
    ListingSubCategory["courtData"] = "courtData";
    ListingSubCategory["covid19Data"] = "covid19Data";
    ListingSubCategory["cpgAndFmcgData"] = "cpgAndFmcgData";
    ListingSubCategory["creditRatingData"] = "creditRatingData";
    ListingSubCategory["crimeRiskData"] = "crimeRiskData";
    ListingSubCategory["cropData"] = "cropData";
    ListingSubCategory["cryptocurrencyData"] = "cryptocurrencyData";
    ListingSubCategory["currencyData"] = "currencyData";
    ListingSubCategory["customerExperienceData"] = "customerExperienceData";
    ListingSubCategory["cyberRiskData"] = "cyberRiskData";
    ListingSubCategory["deepLearningData"] = "deepLearningData";
    ListingSubCategory["deforestationData"] = "deforestationData";
    ListingSubCategory["demandForecastingData"] = "demandForecastingData";
    ListingSubCategory["demographicData"] = "demographicData";
    ListingSubCategory["dentalData"] = "dentalData";
    ListingSubCategory["derivativesAndOtcData"] = "derivativesAndOtcData";
    ListingSubCategory["devicePenetrationData"] = "devicePenetrationData";
    ListingSubCategory["directMarketingData"] = "directMarketingData";
    ListingSubCategory["domainNameData"] = "domainNameData";
    ListingSubCategory["donorData"] = "donorData";
    ListingSubCategory["droppedCallAndNetworkOutageData"] = "droppedCallAndNetworkOutageData";
    ListingSubCategory["droughtAndFloodData"] = "droughtAndFloodData";
    ListingSubCategory["ecommerceData"] = "ecommerceData";
    ListingSubCategory["economicData"] = "economicData";
    ListingSubCategory["electricVehicleEvFleetData"] = "electricVehicleEvFleetData";
    ListingSubCategory["electricityGenerationData"] = "electricityGenerationData";
    ListingSubCategory["emailAndSmsEngagementData"] = "emailAndSmsEngagementData";
    ListingSubCategory["employeeData"] = "employeeData";
    ListingSubCategory["employerRatingAndReviewData"] = "employerRatingAndReviewData";
    ListingSubCategory["energyEfficiencyData"] = "energyEfficiencyData";
    ListingSubCategory["energyInfrastructureData"] = "energyInfrastructureData";
    ListingSubCategory["energyPolicyAndRegulationData"] = "energyPolicyAndRegulationData";
    ListingSubCategory["energyPricingData"] = "energyPricingData";
    ListingSubCategory["energyStorageData"] = "energyStorageData";
    ListingSubCategory["environmentRiskData"] = "environmentRiskData";
    ListingSubCategory["environmentalAndClimateData"] = "environmentalAndClimateData";
    ListingSubCategory["esgData"] = "esgData";
    ListingSubCategory["esgRiskData"] = "esgRiskData";
    ListingSubCategory["eventData"] = "eventData";
    ListingSubCategory["farmBoundaryData"] = "farmBoundaryData";
    ListingSubCategory["fertilizerAndChemicalUsageData"] = "fertilizerAndChemicalUsageData";
    ListingSubCategory["fireData"] = "fireData";
    ListingSubCategory["firmographicData"] = "firmographicData";
    ListingSubCategory["fiveGDeploymentData"] = "fiveGDeploymentData";
    ListingSubCategory["fixedIncomeData"] = "fixedIncomeData";
    ListingSubCategory["fixedNetworkData"] = "fixedNetworkData";
    ListingSubCategory["fleetTelematicsData"] = "fleetTelematicsData";
    ListingSubCategory["footTrafficData"] = "footTrafficData";
    ListingSubCategory["foreclosureData"] = "foreclosureData";
    ListingSubCategory["fraudRiskData"] = "fraudRiskData";
    ListingSubCategory["freightData"] = "freightData";
    ListingSubCategory["fuelData"] = "fuelData";
    ListingSubCategory["fundAndInvestmentHoldingsData"] = "fundAndInvestmentHoldingsData";
    ListingSubCategory["fundraisingAndDonorData"] = "fundraisingAndDonorData";
    ListingSubCategory["gamingAndEsportsData"] = "gamingAndEsportsData";
    ListingSubCategory["gdpAndOutputData"] = "gdpAndOutputData";
    ListingSubCategory["geocodingAndAddressData"] = "geocodingAndAddressData";
    ListingSubCategory["geodemographicData"] = "geodemographicData";
    ListingSubCategory["geographicData"] = "geographicData";
    ListingSubCategory["geologicalData"] = "geologicalData";
    ListingSubCategory["gisData"] = "gisData";
    ListingSubCategory["glassdoorData"] = "glassdoorData";
    ListingSubCategory["globalTradeData"] = "globalTradeData";
    ListingSubCategory["governmentData"] = "governmentData";
    ListingSubCategory["harvestTimingAndMaturityData"] = "harvestTimingAndMaturityData";
    ListingSubCategory["healthRiskData"] = "healthRiskData";
    ListingSubCategory["healthcareMarketingData"] = "healthcareMarketingData";
    ListingSubCategory["healthcareProfessionalData"] = "healthcareProfessionalData";
    ListingSubCategory["historicalWeatherData"] = "historicalWeatherData";
    ListingSubCategory["hospitalData"] = "hospitalData";
    ListingSubCategory["humanCapitalData"] = "humanCapitalData";
    ListingSubCategory["humanRightsRiskData"] = "humanRightsRiskData";
    ListingSubCategory["hydropowerData"] = "hydropowerData";
    ListingSubCategory["importExportData"] = "importExportData";
    ListingSubCategory["indeedData"] = "indeedData";
    ListingSubCategory["inflationData"] = "inflationData";
    ListingSubCategory["influencerAndCreatorEconomyData"] = "influencerAndCreatorEconomyData";
    ListingSubCategory["insuranceData"] = "insuranceData";
    ListingSubCategory["insuranceRiskData"] = "insuranceRiskData";
    ListingSubCategory["intellectualPropertyData"] = "intellectualPropertyData";
    ListingSubCategory["interestRateData"] = "interestRateData";
    ListingSubCategory["iotData"] = "iotData";
    ListingSubCategory["ipAddressData"] = "ipAddressData";
    ListingSubCategory["irrigationAndWaterUsageData"] = "irrigationAndWaterUsageData";
    ListingSubCategory["jobMarketData"] = "jobMarketData";
    ListingSubCategory["jobPostingsData"] = "jobPostingsData";
    ListingSubCategory["kycData"] = "kycData";
    ListingSubCategory["labData"] = "labData";
    ListingSubCategory["laborLawComplianceData"] = "laborLawComplianceData";
    ListingSubCategory["landUseAndLandCoverData"] = "landUseAndLandCoverData";
    ListingSubCategory["largeLanguageModelData"] = "largeLanguageModelData";
    ListingSubCategory["lastMileDeliveryData"] = "lastMileDeliveryData";
    ListingSubCategory["lawEnforcementActivityData"] = "lawEnforcementActivityData";
    ListingSubCategory["legalPartiesData"] = "legalPartiesData";
    ListingSubCategory["lifeCycleAssessmentData"] = "lifeCycleAssessmentData";
    ListingSubCategory["lightningData"] = "lightningData";
    ListingSubCategory["linkedInCompanyData"] = "linkedInCompanyData";
    ListingSubCategory["linkedInData"] = "linkedInData";
    ListingSubCategory["linkedinData"] = "linkedinData";
    ListingSubCategory["litigationData"] = "litigationData";
    ListingSubCategory["livestockData"] = "livestockData";
    ListingSubCategory["lobbyingData"] = "lobbyingData";
    ListingSubCategory["locationData"] = "locationData";
    ListingSubCategory["logisticsNetworkData"] = "logisticsNetworkData";
    ListingSubCategory["machineLearningData"] = "machineLearningData";
    ListingSubCategory["marineData"] = "marineData";
    ListingSubCategory["marketAndPricingData"] = "marketAndPricingData";
    ListingSubCategory["mediaTrendAndConsumptionForecastingData"] = "mediaTrendAndConsumptionForecastingData";
    ListingSubCategory["medicalClaimsData"] = "medicalClaimsData";
    ListingSubCategory["medicalDeviceData"] = "medicalDeviceData";
    ListingSubCategory["medicalImageryData"] = "medicalImageryData";
    ListingSubCategory["mobileAppUsageOverNetworks"] = "mobileAppUsageOverNetworks";
    ListingSubCategory["mobileLocationData"] = "mobileLocationData";
    ListingSubCategory["mobileNetworkCoverageData"] = "mobileNetworkCoverageData";
    ListingSubCategory["mobileNetworkSpeedData"] = "mobileNetworkSpeedData";
    ListingSubCategory["mobilityData"] = "mobilityData";
    ListingSubCategory["modelTrainingAndValidationSets"] = "modelTrainingAndValidationSets";
    ListingSubCategory["mortgageAndLoanData"] = "mortgageAndLoanData";
    ListingSubCategory["musicData"] = "musicData";
    ListingSubCategory["newsData"] = "newsData";
    ListingSubCategory["noiseData"] = "noiseData";
    ListingSubCategory["oddsAndBettingData"] = "oddsAndBettingData";
    ListingSubCategory["oilAndGasData"] = "oilAndGasData";
    ListingSubCategory["onlineMarketplaceData"] = "onlineMarketplaceData";
    ListingSubCategory["parcelData"] = "parcelData";
    ListingSubCategory["patentData"] = "patentData";
    ListingSubCategory["patientData"] = "patientData";
    ListingSubCategory["pestAndDiseaseData"] = "pestAndDiseaseData";
    ListingSubCategory["pharmaData"] = "pharmaData";
    ListingSubCategory["placesData"] = "placesData";
    ListingSubCategory["podcastData"] = "podcastData";
    ListingSubCategory["pointOfInterestData"] = "pointOfInterestData";
    ListingSubCategory["pointOfSaleData"] = "pointOfSaleData";
    ListingSubCategory["politicalRiskData"] = "politicalRiskData";
    ListingSubCategory["pollenData"] = "pollenData";
    ListingSubCategory["populationData"] = "populationData";
    ListingSubCategory["portData"] = "portData";
    ListingSubCategory["powerGridAndTransmissionLineData"] = "powerGridAndTransmissionLineData";
    ListingSubCategory["precipitationData"] = "precipitationData";
    ListingSubCategory["prescriptionDrugData"] = "prescriptionDrugData";
    ListingSubCategory["procurementAndSellerData"] = "procurementAndSellerData";
    ListingSubCategory["productAndSalesData"] = "productAndSalesData";
    ListingSubCategory["productPreferencesAndSentimentData"] = "productPreferencesAndSentimentData";
    ListingSubCategory["propertyData"] = "propertyData";
    ListingSubCategory["publicHealthData"] = "publicHealthData";
    ListingSubCategory["publicSafetyMetricsData"] = "publicSafetyMetricsData";
    ListingSubCategory["publicTransitData"] = "publicTransitData";
    ListingSubCategory["publicTransitInfrastructureData"] = "publicTransitInfrastructureData";
    ListingSubCategory["railNetworksData"] = "railNetworksData";
    ListingSubCategory["realEstateTransactionData"] = "realEstateTransactionData";
    ListingSubCategory["realTimeBiddingData"] = "realTimeBiddingData";
    ListingSubCategory["realTimeWeatherData"] = "realTimeWeatherData";
    ListingSubCategory["recruitingData"] = "recruitingData";
    ListingSubCategory["regulatoryData"] = "regulatoryData";
    ListingSubCategory["remoteAndHybridWorkData"] = "remoteAndHybridWorkData";
    ListingSubCategory["renewablesData"] = "renewablesData";
    ListingSubCategory["reputationalRiskData"] = "reputationalRiskData";
    ListingSubCategory["residentialConstructionData"] = "residentialConstructionData";
    ListingSubCategory["residentialRealEstateData"] = "residentialRealEstateData";
    ListingSubCategory["residentialRentalData"] = "residentialRentalData";
    ListingSubCategory["retailData"] = "retailData";
    ListingSubCategory["rideshareAndTaxiData"] = "rideshareAndTaxiData";
    ListingSubCategory["roadAndStreetNetworkData"] = "roadAndStreetNetworkData";
    ListingSubCategory["roadData"] = "roadData";
    ListingSubCategory["roadNetworksData"] = "roadNetworksData";
    ListingSubCategory["roamingData"] = "roamingData";
    ListingSubCategory["routeOptimizationAndEtaData"] = "routeOptimizationAndEtaData";
    ListingSubCategory["royaltyRatesData"] = "royaltyRatesData";
    ListingSubCategory["salaryData"] = "salaryData";
    ListingSubCategory["satelliteAndRemoteSensingData"] = "satelliteAndRemoteSensingData";
    ListingSubCategory["satelliteData"] = "satelliteData";
    ListingSubCategory["severeWeatherData"] = "severeWeatherData";
    ListingSubCategory["shipmentData"] = "shipmentData";
    ListingSubCategory["shortTermRentalData"] = "shortTermRentalData";
    ListingSubCategory["skillTaxonomyData"] = "skillTaxonomyData";
    ListingSubCategory["socialMediaBuzzAndSentimentData"] = "socialMediaBuzzAndSentimentData";
    ListingSubCategory["socialMediaData"] = "socialMediaData";
    ListingSubCategory["soilAndAgronomicData"] = "soilAndAgronomicData";
    ListingSubCategory["soilData"] = "soilData";
    ListingSubCategory["solarData"] = "solarData";
    ListingSubCategory["solarEnergyData"] = "solarEnergyData";
    ListingSubCategory["spectrumAllocationData"] = "spectrumAllocationData";
    ListingSubCategory["spendingData"] = "spendingData";
    ListingSubCategory["sportsData"] = "sportsData";
    ListingSubCategory["stockMarketData"] = "stockMarketData";
    ListingSubCategory["streamingData"] = "streamingData";
    ListingSubCategory["subscriberDemographicAndUsageData"] = "subscriberDemographicAndUsageData";
    ListingSubCategory["supplyChainData"] = "supplyChainData";
    ListingSubCategory["supplyChainRiskData"] = "supplyChainRiskData";
    ListingSubCategory["surfaceData"] = "surfaceData";
    ListingSubCategory["surveyData"] = "surveyData";
    ListingSubCategory["syntheticData"] = "syntheticData";
    ListingSubCategory["syntheticDataGeneration"] = "syntheticDataGeneration";
    ListingSubCategory["talentData"] = "talentData";
    ListingSubCategory["technographicData"] = "technographicData";
    ListingSubCategory["telecomAndDigitalInfrastructureData"] = "telecomAndDigitalInfrastructureData";
    ListingSubCategory["temperatureData"] = "temperatureData";
    ListingSubCategory["textualData"] = "textualData";
    ListingSubCategory["thirdPartyLogistics3plProviderData"] = "thirdPartyLogistics3plProviderData";
    ListingSubCategory["trademarkData"] = "trademarkData";
    ListingSubCategory["trafficFlowAndCongestionData"] = "trafficFlowAndCongestionData";
    ListingSubCategory["truckingData"] = "truckingData";
    ListingSubCategory["turnoverAndAttritionData"] = "turnoverAndAttritionData";
    ListingSubCategory["tvData"] = "tvData";
    ListingSubCategory["unionMembershipAndLaborActionData"] = "unionMembershipAndLaborActionData";
    ListingSubCategory["urbanPlanningData"] = "urbanPlanningData";
    ListingSubCategory["utilityData"] = "utilityData";
    ListingSubCategory["vehicleRegistrationData"] = "vehicleRegistrationData";
    ListingSubCategory["virusData"] = "virusData";
    ListingSubCategory["voterData"] = "voterData";
    ListingSubCategory["wasteData"] = "wasteData";
    ListingSubCategory["waterAndSewageInfrastructureData"] = "waterAndSewageInfrastructureData";
    ListingSubCategory["waterData"] = "waterData";
    ListingSubCategory["waterRiskData"] = "waterRiskData";
    ListingSubCategory["wealthData"] = "wealthData";
    ListingSubCategory["weatherForecastData"] = "weatherForecastData";
    ListingSubCategory["webActivityData"] = "webActivityData";
    ListingSubCategory["webScrapingData"] = "webScrapingData";
    ListingSubCategory["webSearchData"] = "webSearchData";
    ListingSubCategory["webTrafficData"] = "webTrafficData";
    ListingSubCategory["wildlifeAndConservationData"] = "wildlifeAndConservationData";
    ListingSubCategory["windData"] = "windData";
    ListingSubCategory["windPowerData"] = "windPowerData";
    ListingSubCategory["workforceLocationAndOfficeSiteData"] = "workforceLocationAndOfficeSiteData";
    ListingSubCategory["workplaceDiversityData"] = "workplaceDiversityData";
    ListingSubCategory["yieldAndProductionData"] = "yieldAndProductionData";
})(ListingSubCategory || (ListingSubCategory = {}));
export class ListingSubCategoryCountDetails {
}
export class ListingTimeline {
}
export var LogicOperator;
(function (LogicOperator) {
    LogicOperator["and"] = "and";
    LogicOperator["or"] = "or";
})(LogicOperator || (LogicOperator = {}));
export class MapTemplate {
}
export class MapTemplateDataset {
}
export class MapTemplateDatasetExtended {
}
export class MapTemplateExtended {
}
export var MapTemplateStatus;
(function (MapTemplateStatus) {
    MapTemplateStatus["active"] = "active";
    MapTemplateStatus["inactive"] = "inactive";
})(MapTemplateStatus || (MapTemplateStatus = {}));
export var MapTheme;
(function (MapTheme) {
    MapTheme["dark"] = "dark";
    MapTheme["light"] = "light";
    MapTheme["outdoors"] = "outdoors";
    MapTheme["streets"] = "streets";
})(MapTheme || (MapTheme = {}));
export class MarketplaceDatasetColumn {
}
export class MarketplaceDatasetConnection {
}
export class MarketplaceDatasetDataSourceConnection {
}
export class MarketplaceDatasetDraft {
}
export class MarketplaceDatasetDraftConnection {
}
export class MarketplaceDatasetDraftDataSourceConnection {
}
export class MarketplaceDatasetSlimConnection {
}
export class MarketplaceDatasetStudio {
}
export class MarketplaceDatasetWithOrganization {
}
export class MarketplaceMapPreviewDetails {
}
export class MarketplaceSearchOption {
}
export var MarketplaceSearchOptionType;
(function (MarketplaceSearchOptionType) {
    MarketplaceSearchOptionType["category"] = "category";
    MarketplaceSearchOptionType["listing"] = "listing";
    MarketplaceSearchOptionType["provider"] = "provider";
})(MarketplaceSearchOptionType || (MarketplaceSearchOptionType = {}));
export class Mutation {
}
export class NamedBoundary {
}
export class NamedBoundaryPriceConnection {
}
export class NamedBoundaryResponse {
}
export class NamedBoundarySet {
}
export class NamedBoundarySetResponse {
}
export class NamedBoundarySuggestResponse {
}
export var NotificationCategoryType;
(function (NotificationCategoryType) {
    NotificationCategoryType["account"] = "account";
    NotificationCategoryType["data"] = "data";
    NotificationCategoryType["licenses"] = "licenses";
    NotificationCategoryType["products"] = "products";
    NotificationCategoryType["recipes"] = "recipes";
    NotificationCategoryType["team"] = "team";
})(NotificationCategoryType || (NotificationCategoryType = {}));
export class NumberAttributes {
}
export class OAuthCredentialType {
}
export class OnboardingStepCompletion {
}
export class OnboardingStepCompletionsConnection {
}
export class Organization {
}
export class OrganizationExtended {
}
export class OrganizationExtendedCount {
}
export class OrganizationExtendedOrganizationUserExtended {
}
export class OrganizationFreeComputeUnits {
}
export class OrganizationIndustryListings {
}
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["enterprises"] = "enterprises";
    OrganizationType["freelancersAndIndividualUsers"] = "freelancersAndIndividualUsers";
    OrganizationType["midSizedCompanies"] = "midSizedCompanies";
    OrganizationType["smallBusinesses"] = "smallBusinesses";
})(OrganizationType || (OrganizationType = {}));
export class OrganizationUser {
}
export class OrganizationUserExtended {
}
export class OrganizationUserExtendedCount {
}
export class OrganizationUserExtendedWithTeamIDs {
}
export class OrganizationUserExtendedWithUser {
}
export class OrganizationUsersWithInvites {
}
export class OrganizationWithRelationsCount {
}
export class OriginalSourceInfo {
}
export class ParsedSchema {
}
export var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["Monthly"] = "Monthly";
    PaymentFrequency["Weekly"] = "Weekly";
    PaymentFrequency["Yearly"] = "Yearly";
})(PaymentFrequency || (PaymentFrequency = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["paid"] = "paid";
    PaymentStatus["pending"] = "pending";
})(PaymentStatus || (PaymentStatus = {}));
export class PlatformNotification {
}
export var PlatformNotificationCategoryType;
(function (PlatformNotificationCategoryType) {
    PlatformNotificationCategoryType["account"] = "account";
    PlatformNotificationCategoryType["chat"] = "chat";
    PlatformNotificationCategoryType["feasibilityAssessments"] = "feasibilityAssessments";
    PlatformNotificationCategoryType["projects"] = "projects";
    PlatformNotificationCategoryType["teams"] = "teams";
})(PlatformNotificationCategoryType || (PlatformNotificationCategoryType = {}));
export class PlatformNotificationExtended {
}
export class PolygonGeometry {
}
export class PolygonProperties {
}
export var PriceOption;
(function (PriceOption) {
    PriceOption["OneTimePurchase"] = "OneTimePurchase";
    PriceOption["Other"] = "Other";
    PriceOption["Subscription"] = "Subscription";
    PriceOption["UnitPricing"] = "UnitPricing";
})(PriceOption || (PriceOption = {}));
export class PricedBoundary {
}
export class Pricing {
}
export class PricingInput {
}
export class Product {
}
export class ProductExtended {
}
export class ProductExtendedProductUserExtended {
}
export var ProductPermission;
(function (ProductPermission) {
    ProductPermission["dataLab"] = "dataLab";
    ProductPermission["datascapeAi"] = "datascapeAi";
    ProductPermission["imagery"] = "imagery";
    ProductPermission["simulate"] = "simulate";
})(ProductPermission || (ProductPermission = {}));
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["active"] = "active";
    ProductStatus["cancelled"] = "cancelled";
    ProductStatus["renewLicense"] = "renewLicense";
})(ProductStatus || (ProductStatus = {}));
export class ProductUser {
}
export class ProductUserExtended {
}
export class PromoAssets {
}
export class PromoAssetsInput {
}
export class PublicDatalabSellerAccountConnection {
}
export class PurchasedDataSourceConnection {
}
export class PurchasedDataSourceConnectionWithOrganization {
}
export class PurchasedDataSourceExtended {
}
export class PurchasedDataSourcesConnection {
}
export var PurchasedDatasetSubscriptionFrequency;
(function (PurchasedDatasetSubscriptionFrequency) {
    PurchasedDatasetSubscriptionFrequency["monthly"] = "monthly";
    PurchasedDatasetSubscriptionFrequency["none"] = "none";
    PurchasedDatasetSubscriptionFrequency["weekly"] = "weekly";
    PurchasedDatasetSubscriptionFrequency["yearly"] = "yearly";
})(PurchasedDatasetSubscriptionFrequency || (PurchasedDatasetSubscriptionFrequency = {}));
export class PurchasedMarketplaceDataset {
}
export class PurchasedMarketplaceDatasetConnection {
}
export class PurchasedVariantBoundary {
}
export class Query {
}
export class Quote {
}
export class QuoteBoundaries {
}
export class QuoteCustomerVariantConnection {
}
export class QuoteExtended {
}
export class QuoteLink {
}
export var Range;
(function (Range) {
    Range["days"] = "days";
    Range["months"] = "months";
    Range["weeks"] = "weeks";
    Range["years"] = "years";
})(Range || (Range = {}));
export class RequestOptions {
}
export var RevokePermissionType;
(function (RevokePermissionType) {
    RevokePermissionType["PAUSE_PERMISSION"] = "PAUSE_PERMISSION";
    RevokePermissionType["REVOKE_AT_END_OF_BILLING_CYCLE"] = "REVOKE_AT_END_OF_BILLING_CYCLE";
    RevokePermissionType["REVOKE_IMMEDIATE_WITHOUT_REFUND"] = "REVOKE_IMMEDIATE_WITHOUT_REFUND";
    RevokePermissionType["REVOKE_IMMEDIATE_WITH_REFUND"] = "REVOKE_IMMEDIATE_WITH_REFUND";
})(RevokePermissionType || (RevokePermissionType = {}));
export class Ring {
}
export class SampleDataSourceExtended {
}
export class SampleSettings {
}
export class SavedArea {
}
export class SavedAreaGroup {
}
export class SavedAreaGroupExtended {
}
export class SavedView {
}
export class SavedViewDataset {
}
export class SavedViewDatasetExtended {
}
export class SavedViewExtended {
}
export class SellerAccountPrices {
}
export var SellerAccountPricingFrequency;
(function (SellerAccountPricingFrequency) {
    SellerAccountPricingFrequency["monthly"] = "monthly";
    SellerAccountPricingFrequency["weekly"] = "weekly";
    SellerAccountPricingFrequency["yearly"] = "yearly";
})(SellerAccountPricingFrequency || (SellerAccountPricingFrequency = {}));
export class SellerAccountPricingInput {
}
export class SellerAccountPricingOneTime {
}
export class SellerAccountPricingOneTimeInput {
}
export class SellerAccountPricingSubscription {
}
export class SellerAccountPricingSubscriptionInput {
}
export var SellerAccountPricingType;
(function (SellerAccountPricingType) {
    SellerAccountPricingType["hotSubscription"] = "hotSubscription";
    SellerAccountPricingType["oneTime"] = "oneTime";
    SellerAccountPricingType["subscription"] = "subscription";
})(SellerAccountPricingType || (SellerAccountPricingType = {}));
export class SendGridTemplate {
}
export class SendGridTemplateConnection {
}
export class SendGridTemplateVersion {
}
export class ServerChanges {
}
export class SfConnectionInfo {
}
export class SfCredential {
}
export class SfCredentialInfo {
}
export class SfStorage {
}
export class SfStorageInfo {
}
export class ShapeColor {
}
export var ShapeStyle;
(function (ShapeStyle) {
    ShapeStyle["oval"] = "oval";
    ShapeStyle["square"] = "square";
})(ShapeStyle || (ShapeStyle = {}));
export class SimplifiedNamedBoundarySet {
}
export class SingleDatalabTierDetailsResponse {
}
export class SlackChannel {
}
export class SlimBoundarySetPrice {
}
export class SlimCustomer {
}
export class SlimDataProvider {
}
export class SlimDataSource {
}
export class SlimDataSourcePrice {
}
export class SlimOrganization {
}
export class SlimUser {
}
export var SortOperator;
(function (SortOperator) {
    SortOperator["asc"] = "asc";
    SortOperator["desc"] = "desc";
})(SortOperator || (SortOperator = {}));
export class SpaceTeamMember {
}
export var Status;
(function (Status) {
    Status["draft"] = "draft";
    Status["published"] = "published";
    Status["unpublished"] = "unpublished";
})(Status || (Status = {}));
export class StringAttributes {
}
export class StripeBillingDetails {
}
export class StripeInvoice {
}
export class StripeInvoiceConnection {
}
export class StripePaymentMethodCard {
}
export class StripePaymentMethodConnection {
}
export class StripePaymentMethodLink {
}
export class StripePaymentMethodUnion {
}
export var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus["active"] = "active";
    StripeSubscriptionStatus["canceled"] = "canceled";
    StripeSubscriptionStatus["incomplete"] = "incomplete";
    StripeSubscriptionStatus["incomplete_expired"] = "incomplete_expired";
    StripeSubscriptionStatus["none"] = "none";
    StripeSubscriptionStatus["past_due"] = "past_due";
    StripeSubscriptionStatus["paused"] = "paused";
    StripeSubscriptionStatus["trialing"] = "trialing";
    StripeSubscriptionStatus["unpaid"] = "unpaid";
})(StripeSubscriptionStatus || (StripeSubscriptionStatus = {}));
export var StudioPermission;
(function (StudioPermission) {
    StudioPermission["dataManagement"] = "dataManagement";
    StudioPermission["licenseManagement"] = "licenseManagement";
    StudioPermission["marketplace"] = "marketplace";
    StudioPermission["productManagement"] = "productManagement";
    StudioPermission["recipeManagement"] = "recipeManagement";
    StudioPermission["settings"] = "settings";
    StudioPermission["teamManagement"] = "teamManagement";
})(StudioPermission || (StudioPermission = {}));
export class SubCategoriesWithListings {
}
export class Subscription {
}
export class SubscriptionData {
}
export class SubscriptionDataConnection {
}
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["monthly"] = "monthly";
    SubscriptionFrequency["yearly"] = "yearly";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export class SubscriptionGeometry {
}
export class SubscriptionResponse {
}
export class SuggestInput {
}
export class SupportLoginConnection {
}
export class TableEntity {
}
export var TargetStatus;
(function (TargetStatus) {
    TargetStatus["cold"] = "cold";
    TargetStatus["hot"] = "hot";
    TargetStatus["warm"] = "warm";
})(TargetStatus || (TargetStatus = {}));
export class Team {
}
export class TeamExtended {
}
export class TeamMember {
}
export class TeamMemberExtendedWithUser {
}
export class TeamMemberExtendedWithUserAndTeam {
}
export class TeamMemberId {
}
export var TeamMemberRole;
(function (TeamMemberRole) {
    TeamMemberRole["admin"] = "admin";
    TeamMemberRole["owner"] = "owner";
    TeamMemberRole["standard"] = "standard";
})(TeamMemberRole || (TeamMemberRole = {}));
export var TeamMemberStatus;
(function (TeamMemberStatus) {
    TeamMemberStatus["active"] = "active";
    TeamMemberStatus["invitationDeclined"] = "invitationDeclined";
    TeamMemberStatus["pendingActivation"] = "pendingActivation";
})(TeamMemberStatus || (TeamMemberStatus = {}));
export class TierFeature {
}
export class TierFeatureInput {
}
export class UpdateAzureDataProvider {
}
export class UpdateDemoInstanceInput {
}
export class UpdateOrganizationInput {
}
export class UpdatePlatformNotification {
}
export class UpdateUserInput {
}
export class UpdateUserInvite {
}
export class UploadConnectionInfo {
}
export class UploadCredential {
}
export class UploadCredentialInfo {
}
export class UploadFile {
}
export class UploadFileChunks {
}
export class UploadFileInput {
}
export class UploadFileInputChunks {
}
export var UploadResourceType;
(function (UploadResourceType) {
    UploadResourceType["datasource"] = "datasource";
    UploadResourceType["normal"] = "normal";
    UploadResourceType["sample"] = "sample";
})(UploadResourceType || (UploadResourceType = {}));
export class UploadStorage {
}
export class UploadStorageInfo {
}
export class UploadedSchema {
}
export class User {
}
export class UserConnection {
}
export class UserDataSource {
}
export class UserInvite {
}
export class UserInviteExtended {
}
export var UserInviteStatus;
(function (UserInviteStatus) {
    UserInviteStatus["accepted"] = "accepted";
    UserInviteStatus["canceled"] = "canceled";
    UserInviteStatus["declined"] = "declined";
    UserInviteStatus["pending"] = "pending";
})(UserInviteStatus || (UserInviteStatus = {}));
export var UserRole;
(function (UserRole) {
    UserRole["admin"] = "admin";
    UserRole["custom"] = "custom";
    UserRole["owner"] = "owner";
    UserRole["standard"] = "standard";
})(UserRole || (UserRole = {}));
export class UserSegment {
}
export class UserSegmentUser {
}
export class UserSegmentUsersConnection {
}
export class VelocityStatus {
}
export class VerifiedAccessKeyResponse {
}
export var VerifiedAccessKeyStatus;
(function (VerifiedAccessKeyStatus) {
    VerifiedAccessKeyStatus["Failed"] = "Failed";
    VerifiedAccessKeyStatus["Success"] = "Success";
})(VerifiedAccessKeyStatus || (VerifiedAccessKeyStatus = {}));
export class Viewport {
}
export var WhereOperator;
(function (WhereOperator) {
    WhereOperator["contains"] = "contains";
    WhereOperator["endsWith"] = "endsWith";
    WhereOperator["eq"] = "eq";
    WhereOperator["equals"] = "equals";
    WhereOperator["gt"] = "gt";
    WhereOperator["gte"] = "gte";
    WhereOperator["is"] = "is";
    WhereOperator["isAnyOf"] = "isAnyOf";
    WhereOperator["isEmpty"] = "isEmpty";
    WhereOperator["isNotEmpty"] = "isNotEmpty";
    WhereOperator["lt"] = "lt";
    WhereOperator["lte"] = "lte";
    WhereOperator["neq"] = "neq";
    WhereOperator["none"] = "none";
    WhereOperator["startsWith"] = "startsWith";
})(WhereOperator || (WhereOperator = {}));
export var WorkspaceType;
(function (WorkspaceType) {
    WorkspaceType["snowflake"] = "snowflake";
    WorkspaceType["studio"] = "studio";
})(WorkspaceType || (WorkspaceType = {}));
export const AreaFragmentDoc = gql `
    fragment Area on Area {
  id
  name
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ShapeColorFragmentDoc = gql `
    fragment ShapeColor on ShapeColor {
  color
  opacity
}
    `;
export const PolygonGeometryFragmentDoc = gql `
    fragment PolygonGeometry on PolygonGeometry {
  type
  id
  coordinates
  properties {
    name
    fill {
      ...ShapeColor
    }
    stroke {
      ...ShapeColor
    }
    fkAreaId
    fkSavedAreaId
  }
}
    ${ShapeColorFragmentDoc}`;
export const GeometryCollectionFragmentDoc = gql `
    fragment GeometryCollection on GeometryCollection {
  type
  geometries {
    ...PolygonGeometry
  }
}
    ${PolygonGeometryFragmentDoc}`;
export const SavedAreaFragmentDoc = gql `
    fragment SavedArea on SavedArea {
  id
  name
  description
  fkAreaId
  fkUserId
  fkOrganizationId
  fkMapTemplateId
  fkSavedAreaGroupId
  geometries {
    ...GeometryCollection
  }
  mapUse
  isSavedViewArea
  createdAt
  updatedAt
  deletedAt
}
    ${GeometryCollectionFragmentDoc}`;
export const SavedAreaGroupFragmentDoc = gql `
    fragment SavedAreaGroup on SavedAreaGroup {
  id
  name
  fkAreaId
  fkParentGroupId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const SavedAreaGroupExtendedFragmentDoc = gql `
    fragment SavedAreaGroupExtended on SavedAreaGroupExtended {
  savedAreaGroup {
    ...SavedAreaGroup
  }
  savedAreas {
    ...SavedArea
  }
  subSavedAreaGroups {
    ...SavedAreaGroup
  }
}
    ${SavedAreaGroupFragmentDoc}
${SavedAreaFragmentDoc}`;
export const AreaExtendedFragmentDoc = gql `
    fragment AreaExtended on AreaExtended {
  area {
    ...Area
  }
  savedAreas {
    ...SavedArea
  }
  savedAreaGroups {
    ...SavedAreaGroupExtended
  }
}
    ${AreaFragmentDoc}
${SavedAreaFragmentDoc}
${SavedAreaGroupExtendedFragmentDoc}`;
export const DatasetInquiryFragmentDoc = gql `
    fragment DatasetInquiry on DatasetInquiry {
  id
  fkUserId
  fkOrganizationId
  fkCustomerId
  fkMarketplaceDatasetId
  status
  message
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserFragmentDoc = gql `
    fragment User on User {
  id
  email
  firstName
  lastName
  address
  phoneCountryCode
  phone
  img
  resetPasswordToken
  verified
  verifiedToken
  lastLoginAt
  verifiedTokenExpiresAt
  isAdmin
  createdAt
  updatedAt
  deletedAt
}
    `;
export const OrganizationFragmentDoc = gql `
    fragment Organization on Organization {
  id
  name
  industry
  country
  description
  phoneCountryCode
  phone
  img
  website
  organizationCode
  enterpriseStatus
  slug
  createdAt
  updatedAt
  deletedAt
}
    `;
export const CustomerFragmentDoc = gql `
    fragment Customer on Customer {
  id
  firstName
  lastName
  email
  company
  fkUserId
  notes
  fkOrganizationId
  customerType
  phone
  img
  createdAt
  updatedAt
  deletedAt
}
    `;
export const PricingFragmentDoc = gql `
    fragment Pricing on Pricing {
  price
  priceOption
  frequency
  priceName
}
    `;
export const PromoAssetsFragmentDoc = gql `
    fragment PromoAssets on PromoAssets {
  url
  originalName
  size
}
    `;
export const LinksFragmentDoc = gql `
    fragment Links on Links {
  name
  url
}
    `;
export const MarketplaceDatasetColumnFragmentDoc = gql `
    fragment MarketplaceDatasetColumn on MarketplaceDatasetColumn {
  name
  type
}
    `;
export const SampleSettingsFragmentDoc = gql `
    fragment SampleSettings on SampleSettings {
  dataPercentage
  rowsCount
  samplingTriesCount
}
    `;
export const ListingTimelineFragmentDoc = gql `
    fragment ListingTimeline on ListingTimeline {
  timeCoverage
  range
}
    `;
export const ListingDataVolumeFragmentDoc = gql `
    fragment ListingDataVolume on ListingDataVolume {
  id
  volume
  name
}
    `;
export const ListingDataAttributesFragmentDoc = gql `
    fragment ListingDataAttributes on ListingDataAttributes {
  fkDataSourceId
  sampleFilename
  column
  type
  description
  example
}
    `;
export const MarketplaceDatasetStudioFragmentDoc = gql `
    fragment MarketplaceDatasetStudio on MarketplaceDatasetStudio {
  id
  name
  description
  content
  img
  size
  pricing {
    ...Pricing
  }
  tableId
  content
  geographyColumn
  tableName
  azurePath
  azureMarketplaceDatasetId
  status
  industries
  type
  fkDataSourceId
  fkOrganizationId
  subscriptionFrequency
  contactLink
  email
  sampleFilenames
  promoAssets {
    ...PromoAssets
  }
  additionalLinks {
    ...Links
  }
  slug
  collectionName
  columns {
    ...MarketplaceDatasetColumn
  }
  buyNow
  samplingSettings {
    ...SampleSettings
  }
  stripeProductId
  paymentsEnabled
  termsOfUseLink
  isFreeListing
  categories
  subCategories
  countries
  organizationTypes
  keywords
  timeline {
    ...ListingTimeline
  }
  dataVolume {
    ...ListingDataVolume
  }
  fileSize
  fileUnit
  dataOrigin
  dataAttributes {
    ...ListingDataAttributes
  }
  fileFormats
  deliveryMethods
  frequency
  fkDataProductId
  createdAt
  updatedAt
  deletedAt
}
    ${PricingFragmentDoc}
${PromoAssetsFragmentDoc}
${LinksFragmentDoc}
${MarketplaceDatasetColumnFragmentDoc}
${SampleSettingsFragmentDoc}
${ListingTimelineFragmentDoc}
${ListingDataVolumeFragmentDoc}
${ListingDataAttributesFragmentDoc}`;
export const DatasetInquiryExtendedFragmentDoc = gql `
    fragment DatasetInquiryExtended on DatasetInquiryExtended {
  inquiry {
    ...DatasetInquiry
  }
  user {
    ...User
  }
  organization {
    ...Organization
  }
  customer {
    ...Customer
  }
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
}
    ${DatasetInquiryFragmentDoc}
${UserFragmentDoc}
${OrganizationFragmentDoc}
${CustomerFragmentDoc}
${MarketplaceDatasetStudioFragmentDoc}`;
export const SlimCustomerFragmentDoc = gql `
    fragment SlimCustomer on SlimCustomer {
  id
  firstName
  lastName
  email
  company
}
    `;
export const DatalabEntitlementFragmentDoc = gql `
    fragment DatalabEntitlement on DatalabEntitlement {
  id
  entitlementType
  fkCustomerId
  apiKey
  customer {
    ...SlimCustomer
  }
  fkOrganizationId
  status
  datasources
  keyType
  price
  expiryDate
  createdAt
  updatedAt
  deletedAt
}
    ${SlimCustomerFragmentDoc}`;
export const CustomerExtendedFragmentDoc = gql `
    fragment CustomerExtended on CustomerExtended {
  customer {
    ...Customer
  }
  inquiries {
    ...DatasetInquiry
  }
  accessKeys {
    ...DatalabEntitlement
  }
  user {
    ...User
  }
  dataSourcePermissionsCount
}
    ${CustomerFragmentDoc}
${DatasetInquiryFragmentDoc}
${DatalabEntitlementFragmentDoc}
${UserFragmentDoc}`;
export const DataProductFragmentDoc = gql `
    fragment DataProduct on DataProduct {
  id
  name
  description
  fkDataSourceId
  fkOrganizationId
  createdAt
  updatedAt
}
    `;
export const DataSourcePriceLicensingFragmentDoc = gql `
    fragment DataSourcePriceLicensing on DataSourcePriceLicensing {
  resale
  internalUse
  commercialUse
  personalUse
}
    `;
export const DataSourcePriceFeaturesFragmentDoc = gql `
    fragment DataSourcePriceFeatures on DataSourcePriceFeatures {
  fullDatasetDownload
  partitionedAccess
  apiAccess
  streamingData
  scheduledUpdates
  downloadOnce
  continuousSync
}
    `;
export const DataSourcePriceAccessControlsFragmentDoc = gql `
    fragment DataSourcePriceAccessControls on DataSourcePriceAccessControls {
  singleDeviceAccess
  multiUserLicense
  ipBasedAccessControl
  timeLimitedAccess
  usageMetering
  geoFencing
  accessKeyAuthentication
  oAuthIntegratedAccess
}
    `;
export const DataSourcePriceDeliveryFragmentDoc = gql `
    fragment DataSourcePriceDelivery on DataSourcePriceDelivery {
  apiAccess
  email
  ftpSftp
  scheduled
  webhookNotifications
}
    `;
export const DataProductVariantBoundarySetPriceFragmentDoc = gql `
    fragment DataProductVariantBoundarySetPrice on DataProductVariantBoundarySetPrice {
  id
  fkOrganizationId
  fkDataProductVariantId
  boundarySetId
  fullPrice
  unitPrice
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DataSourcePriceFragmentDoc = gql `
    fragment DataSourcePrice on DataSourcePrice {
  id
  name
  description
  subscriptionFrequency
  price
  usage
  usageFrequency
  fkDataSourceId
  fkDataProductId
  fkOrganizationId
  egress
  datascape
  alwaysOn
  licensing {
    ...DataSourcePriceLicensing
  }
  features {
    ...DataSourcePriceFeatures
  }
  accessControls {
    ...DataSourcePriceAccessControls
  }
  delivery {
    ...DataSourcePriceDelivery
  }
  marketplaceActivation
  instantOfferActivation
  interactiveQuoteActivation
  sampleSettings {
    ...SampleSettings
  }
  coverage
  boundarySetPrices {
    ...DataProductVariantBoundarySetPrice
  }
  createdAt
  updatedAt
}
    ${DataSourcePriceLicensingFragmentDoc}
${DataSourcePriceFeaturesFragmentDoc}
${DataSourcePriceAccessControlsFragmentDoc}
${DataSourcePriceDeliveryFragmentDoc}
${SampleSettingsFragmentDoc}
${DataProductVariantBoundarySetPriceFragmentDoc}`;
export const CloudStorageInfoFragmentDoc = gql `
    fragment CloudStorageInfo on CloudStorageInfo {
  ... on AzureStorage {
    cloudStorageType
    info {
      accountName
      containerName
      blobName
    }
  }
  ... on AwsStorage {
    cloudStorageType
    info {
      storage
      bucketName
    }
  }
  ... on SfStorage {
    cloudStorageType
    info {
      accountId
    }
  }
  ... on GcpStorage {
    cloudStorageType
    info {
      projectId
      gcpBucketName
    }
  }
  ... on GoogleDriveStorage {
    cloudStorageType
    info {
      folderId
    }
  }
  ... on UploadStorage {
    cloudStorageType
    info {
      url
    }
  }
}
    `;
export const EtlDatasetLocationDetailFragmentDoc = gql `
    fragment EtlDatasetLocationDetail on EtlDatasetLocationDetail {
  id
  fkEtlDatasetLocationId
  path
  lastModifiedAt
  createdAt
  updatedAt
  deletedAt
}
    `;
export const CloudFileDetailFragmentDoc = gql `
    fragment CloudFileDetail on CloudFileDetail {
  id
  path
  lastModifiedAt
  size
}
    `;
export const EtlDatasetLocationFragmentDoc = gql `
    fragment EtlDatasetLocation on EtlDatasetLocation {
  id
  fkOrganizationId
  organization {
    ...Organization
  }
  name
  credential
  tableId
  fileType
  cloudStorageInfo {
    ...CloudStorageInfo
  }
  downloadType
  geographyColumn
  geographyType
  locationDetails {
    ...EtlDatasetLocationDetail
  }
  cronInterval
  fileDetails {
    ...CloudFileDetail
  }
  dataSourceId
  createdAt
  updatedAt
  deletedAt
}
    ${OrganizationFragmentDoc}
${CloudStorageInfoFragmentDoc}
${EtlDatasetLocationDetailFragmentDoc}
${CloudFileDetailFragmentDoc}`;
export const OriginalSourceInfoFragmentDoc = gql `
    fragment OriginalSourceInfo on OriginalSourceInfo {
  name
  path
  size
  downloadType
  lastModifiedAt
  extension
}
    `;
export const DataSourceStudioFragmentDoc = gql `
    fragment DataSourceStudio on DataSourceStudio {
  id
  img
  name
  description
  size
  tableId
  geographyColumn
  tableName
  azurePath
  ramActual
  diskActual
  collectionName
  fkOrganizationId
  fkEtlDatasetLocationId
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  type
  slug
  columns {
    ...MarketplaceDatasetColumn
  }
  fkUserId
  sampleId
  createdAt
  updatedAt
  deletedAt
  originalSourceInfo {
    ...OriginalSourceInfo
  }
}
    ${EtlDatasetLocationFragmentDoc}
${MarketplaceDatasetColumnFragmentDoc}
${OriginalSourceInfoFragmentDoc}`;
export const DataProductVariantsConnectionFragmentDoc = gql `
    fragment DataProductVariantsConnection on DataProductVariantsConnection {
  dataProduct {
    ...DataProduct
  }
  dataProductVariants {
    ...DataSourcePrice
  }
  dataSource {
    ...DataSourceStudio
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
}
    ${DataProductFragmentDoc}
${DataSourcePriceFragmentDoc}
${DataSourceStudioFragmentDoc}
${EtlDatasetLocationFragmentDoc}`;
export const DataProductVariantsCountConnectionFragmentDoc = gql `
    fragment DataProductVariantsCountConnection on DataProductVariantsCountConnection {
  dataProductVariantConnections {
    ...DataProductVariantsConnection
  }
  count
}
    ${DataProductVariantsConnectionFragmentDoc}`;
export const SlimDataSourceFragmentDoc = gql `
    fragment SlimDataSource on SlimDataSource {
  id
  name
  description
  img
  ramActual
  diskActual
}
    `;
export const EtlInstanceFragmentDoc = gql `
    fragment EtlInstance on EtlInstance {
  id
  startTime
  endTime
  status
  type
  fkDatasetLocationId
  ramActual
  ramEstimate
  diskActual
  diskEstimate
  rowCount
  originalFileRowCount
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DataSourcePricePriceFrequencyConnectionFragmentDoc = gql `
    fragment DataSourcePricePriceFrequencyConnection on DataSourcePricePriceFrequencyConnection {
  price
  subscriptionFrequency
}
    `;
export const DataProductsTableFragmentDoc = gql `
    fragment DataProductsTable on DataProductsTable {
  dataProduct {
    ...DataProduct
  }
  dataSource {
    ...SlimDataSource
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  latestEtlInstance {
    ...EtlInstance
  }
  startingPrice {
    ...DataSourcePricePriceFrequencyConnection
  }
  marketplaceListingImgs
  numPricingOptions
}
    ${DataProductFragmentDoc}
${SlimDataSourceFragmentDoc}
${EtlDatasetLocationFragmentDoc}
${EtlInstanceFragmentDoc}
${DataSourcePricePriceFrequencyConnectionFragmentDoc}`;
export const DataProductsTableCountConnectionFragmentDoc = gql `
    fragment DataProductsTableCountConnection on DataProductsTableCountConnection {
  dataProducts {
    ...DataProductsTable
  }
  count
}
    ${DataProductsTableFragmentDoc}`;
export const SlimDataSourcePriceFragmentDoc = gql `
    fragment SlimDataSourcePrice on SlimDataSourcePrice {
  id
  name
}
    `;
export const DataSourceConfigurationFragmentDoc = gql `
    fragment DataSourceConfiguration on DataSourceConfiguration {
  id
  fkOrganizationId
  fkDataSourceId
  status
  targetState
  levelsOfDetail
  serverUrl
  lastEnabled
  createdAt
  deletedAt
  updatedAt
}
    `;
export const DataProductExtendedFragmentDoc = gql `
    fragment DataProductExtended on DataProductExtended {
  dataProduct {
    ...DataProduct
  }
  dataProductVariants {
    ...SlimDataSourcePrice
  }
  dataSource {
    ...SlimDataSource
  }
  configuration {
    ...DataSourceConfiguration
  }
}
    ${DataProductFragmentDoc}
${SlimDataSourcePriceFragmentDoc}
${SlimDataSourceFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export const DataSourcePermissionFragmentDoc = gql `
    fragment DataSourcePermission on DataSourcePermission {
  id
  fkDataSourcePriceId
  dataSourcePriceName
  dataSourcePriceDescription
  dataSourcePriceSubscriptionFrequency
  dataSourcePricePrice
  dataSourcePriceUsage
  fkDataSourcePriceDataSourceId
  fkDataSourcePriceOrganizationId
  dataSourcePriceStripeProductId
  dataSourcePriceStripePriceId
  dataSourcePriceEgress
  dataSourcePriceDatascape
  dataSourcePriceAlwaysOn
  dataSourcePriceUsageFrequency
  dataSourcePriceLicensing {
    ...DataSourcePriceLicensing
  }
  dataSourcePriceMarketplaceActivation
  dataSourcePriceInstantOfferActivation
  dataSourcePriceInteractiveQuoteActivation
  paymentType
  stripeSubscriptionStatus
  stripeCustomerId
  stripeSubscriptionId
  stripeConnectAccountId
  stripePaymentMethodId
  subscriptionStartedAt
  subscriptionCancelledAt
  subscriptionEndedAt
  subscriptionCurrentPeriodStart
  subscriptionCurrentPeriodEnd
  accessUntil
  stripePaymentIntentId
  fkUserId
  fkOrganizationId
  isActive
  fkDataSourceId
  fkQuoteId
  fkUserDataSourceId
  fkPurchasedMarketplaceDatasetId
  fkMarketplaceDatasetId
  sampleId
  createdAt
  updatedAt
}
    ${DataSourcePriceLicensingFragmentDoc}`;
export const PurchasedDataSourceExtendedFragmentDoc = gql `
    fragment PurchasedDataSourceExtended on PurchasedDataSourceExtended {
  dataSource {
    ...DataSourceStudio
  }
  dataSourcePermission {
    ...DataSourcePermission
  }
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
  configuration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourcePermissionFragmentDoc}
${MarketplaceDatasetStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}`;
export const PurchasedDataSourcesConnectionFragmentDoc = gql `
    fragment PurchasedDataSourcesConnection on PurchasedDataSourcesConnection {
  purchasedDataSources {
    ...PurchasedDataSourceExtended
  }
  count
}
    ${PurchasedDataSourceExtendedFragmentDoc}`;
export const DataSourcePermissionUserConnectionFragmentDoc = gql `
    fragment DataSourcePermissionUserConnection on DataSourcePermissionUserConnection {
  user {
    ...User
  }
  dataSourcePermission {
    ...DataSourcePermission
  }
}
    ${UserFragmentDoc}
${DataSourcePermissionFragmentDoc}`;
export const SlimOrganizationFragmentDoc = gql `
    fragment SlimOrganization on SlimOrganization {
  id
  name
  industry
  country
  description
  phoneCountryCode
  phone
  img
  website
  slug
}
    `;
export const ActiveDataSourceExtendedFragmentDoc = gql `
    fragment ActiveDataSourceExtended on ActiveDataSourceExtended {
  dataSource {
    ...DataSourceStudio
  }
  dataSourcePermission {
    ...DataSourcePermission
  }
  configuration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  providerOrganization {
    ...SlimOrganization
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourcePermissionFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}
${SlimOrganizationFragmentDoc}`;
export const ActiveDataSourcesCountConnectionFragmentDoc = gql `
    fragment ActiveDataSourcesCountConnection on ActiveDataSourcesCountConnection {
  activeDataSources {
    ...ActiveDataSourceExtended
  }
  count
}
    ${ActiveDataSourceExtendedFragmentDoc}`;
export const DataSourcePriceActiveSubscriptionDataSourceConnectionFragmentDoc = gql `
    fragment DataSourcePriceActiveSubscriptionDataSourceConnection on DataSourcePriceActiveSubscriptionDataSourceConnection {
  dataSourcePrice {
    ...DataSourcePrice
  }
  dataSource {
    ...DataSourceStudio
  }
  hasActiveSubscription
}
    ${DataSourcePriceFragmentDoc}
${DataSourceStudioFragmentDoc}`;
export const DataSourcePriceWithDataSourceCountConnectionFragmentDoc = gql `
    fragment DataSourcePriceWithDataSourceCountConnection on DataSourcePriceWithDataSourceCountConnection {
  count
  dataSourcePrices {
    ...DataSourcePriceActiveSubscriptionDataSourceConnection
  }
}
    ${DataSourcePriceActiveSubscriptionDataSourceConnectionFragmentDoc}`;
export const DataSourcePriceActiveSubscriptionConnectionFragmentDoc = gql `
    fragment DataSourcePriceActiveSubscriptionConnection on DataSourcePriceActiveSubscriptionConnection {
  dataSourcePrice {
    ...DataSourcePrice
  }
  hasActiveSubscription
}
    ${DataSourcePriceFragmentDoc}`;
export const DataSourcePriceCountConnectionFragmentDoc = gql `
    fragment DataSourcePriceCountConnection on DataSourcePriceCountConnection {
  count
  dataSourcePrices {
    ...DataSourcePriceActiveSubscriptionConnection
  }
}
    ${DataSourcePriceActiveSubscriptionConnectionFragmentDoc}`;
export const DataSourcePricePublishedConnectionFragmentDoc = gql `
    fragment DataSourcePricePublishedConnection on DataSourcePricePublishedConnection {
  dataSourcePrice {
    ...DataSourcePrice
  }
  published
}
    ${DataSourcePriceFragmentDoc}`;
export const DataSourcePricePublishedCountConnectionFragmentDoc = gql `
    fragment DataSourcePricePublishedCountConnection on DataSourcePricePublishedCountConnection {
  connections {
    ...DataSourcePricePublishedConnection
  }
  count
}
    ${DataSourcePricePublishedConnectionFragmentDoc}`;
export const DataSourcePriceExtendedFragmentDoc = gql `
    fragment DataSourcePriceExtended on DataSourcePriceExtended {
  dataSourcePrice {
    ...DataSourcePrice
  }
  dataSource {
    ...DataSourceStudio
  }
  dataProduct {
    ...DataProduct
  }
  configuration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  hasActiveSubscriptions
}
    ${DataSourcePriceFragmentDoc}
${DataSourceStudioFragmentDoc}
${DataProductFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}`;
export const DataSourcePriceExtendedCountConnectionFragmentDoc = gql `
    fragment DataSourcePriceExtendedCountConnection on DataSourcePriceExtendedCountConnection {
  dataSourcePrices {
    ...DataSourcePriceExtended
  }
  count
}
    ${DataSourcePriceExtendedFragmentDoc}`;
export const SlimBoundarySetPriceFragmentDoc = gql `
    fragment SlimBoundarySetPrice on SlimBoundarySetPrice {
  boundarySetId
  fullPrice
}
    `;
export const BillingPortalSessionFragmentDoc = gql `
    fragment BillingPortalSession on BillingPortalSession {
  url
}
    `;
export const DatalabFeatureAccessFragmentDoc = gql `
    fragment DatalabFeatureAccess on DatalabFeatureAccess {
  feature
  access
}
    `;
export const DatalabFeatureAccessWithTierFragmentDoc = gql `
    fragment DatalabFeatureAccessWithTier on DatalabFeatureAccessWithTier {
  featureAccess {
    ...DatalabFeatureAccess
  }
  tier
}
    ${DatalabFeatureAccessFragmentDoc}`;
export const DatalabFeatureAccessCountFragmentDoc = gql `
    fragment DatalabFeatureAccessCount on DatalabFeatureAccessCount {
  featureAccess {
    ...DatalabFeatureAccess
  }
  currentQuantity
  remaining
  atLimit
  nextUpgrade {
    ...DatalabFeatureAccessWithTier
  }
}
    ${DatalabFeatureAccessFragmentDoc}
${DatalabFeatureAccessWithTierFragmentDoc}`;
export const DatalabFeatureAccessResultFragmentDoc = gql `
    fragment DatalabFeatureAccessResult on DatalabFeatureAccessResult {
  organizationId
  tier
  features {
    ...DatalabFeatureAccess
  }
}
    ${DatalabFeatureAccessFragmentDoc}`;
export const DatalabProcessMeterFragmentDoc = gql `
    fragment DatalabProcessMeter on DatalabProcessMeter {
  storage {
    total
    used
    unit
  }
}
    `;
export const SellerAccountPricingOneTimeFragmentDoc = gql `
    fragment SellerAccountPricingOneTime on SellerAccountPricingOneTime {
  id
  type
  fkMarketplaceDatasetId
  price
  stripeProductId
  stripePriceId
  isInUse
  archivedAt
  createdAt
  updatedAt
}
    `;
export const SellerAccountPricingSubscriptionFragmentDoc = gql `
    fragment SellerAccountPricingSubscription on SellerAccountPricingSubscription {
  id
  type
  fkMarketplaceDatasetId
  price
  frequency
  stripeProductId
  stripePriceId
  isInUse
  archivedAt
  createdAt
  updatedAt
}
    `;
export const SellerAccountPricingFragmentDoc = gql `
    fragment SellerAccountPricing on SellerAccountPricing {
  ... on SellerAccountPricingOneTime {
    ...SellerAccountPricingOneTime
  }
  ... on SellerAccountPricingSubscription {
    ...SellerAccountPricingSubscription
  }
}
    ${SellerAccountPricingOneTimeFragmentDoc}
${SellerAccountPricingSubscriptionFragmentDoc}`;
export const SellerAccountPricesFragmentDoc = gql `
    fragment SellerAccountPrices on SellerAccountPrices {
  prices {
    ...SellerAccountPricing
  }
}
    ${SellerAccountPricingFragmentDoc}`;
export const DatalabSubscriptionFragmentDoc = gql `
    fragment DatalabSubscription on DatalabSubscription {
  id
  fkOrganizationId
  tier
  nextCycleTier
  subscriptionStartedAt
  subscriptionCanceledAt
  subscriptionEndedAt
  subscriptionFrequency
  subscriptionCurrentPeriodStart
  subscriptionCurrentPeriodEnd
  paymentType
  stripeSubscriptionStatus
  stripeCustomerId
  stripeSubscriptionId
  stripePaymentMethodId
  storageAddonQuantity
  computeAddonQuantity
  createdAt
  updatedAt
}
    `;
export const DatalabSubscriptionConnectionFragmentDoc = gql `
    fragment DatalabSubscriptionConnection on DatalabSubscriptionConnection {
  datalabSubscription {
    ...DatalabSubscription
  }
  tier
}
    ${DatalabSubscriptionFragmentDoc}`;
export const DatalabTierDetailsFragmentDoc = gql `
    fragment DatalabTierDetails on DatalabTierDetails {
  id
  tier
  live
  name
  subtitle
  price
  annualPrice
  features {
    feature
    info
  }
  badge
  noPriceText
  createdAt
  updatedAt
  deletedAt
}
    `;
export const PurchasedMarketplaceDatasetFragmentDoc = gql `
    fragment PurchasedMarketplaceDataset on PurchasedMarketplaceDataset {
  id
  fkMarketplaceDatasetsId
  fkOrganizationId
  fkUserId
  user {
    ...User
  }
  fkDatalabSellerPriceId
  paymentType
  stripeSubscriptionId
  stripeConnectAccountId
  stripePaymentMethodId
  stripeCustomerId
  stripeSubscriptionStatus
  subscriptionFrequency
  subscriptionStartedAt
  subscriptionCanceledAt
  subscriptionEndedAt
  subscriptionCurrentPeriodStart
  subscriptionCurrentPeriodEnd
  purchaseType
  accessUntil
  stripePaymentIntentId
  createdAt
  updatedAt
}
    ${UserFragmentDoc}`;
export const UserDataSourceFragmentDoc = gql `
    fragment UserDataSource on UserDataSource {
  id
  name
  description
  type
  fkUserId
  fkOrganizationId
  fkDataSourceId
  fkPurchasedMarketplaceDatasetId
  sampleId
  tableName
  collectionName
  geographyColumn
  tableId
  size
  color
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DataSourceWithConfigAndEtlExtendedFragmentDoc = gql `
    fragment DataSourceWithConfigAndEtlExtended on DataSourceWithConfigAndEtlExtended {
  dataSource {
    ...DataSourceStudio
  }
  configuration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  latestEtlInstance {
    ...EtlInstance
  }
  userDataSource {
    ...UserDataSource
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}
${EtlInstanceFragmentDoc}
${UserDataSourceFragmentDoc}`;
export const PurchasedDataSourceConnectionFragmentDoc = gql `
    fragment PurchasedDataSourceConnection on PurchasedDataSourceConnection {
  purchasedDataset {
    ...PurchasedMarketplaceDataset
  }
  dataset {
    ...DataSourceWithConfigAndEtlExtended
  }
  hasAccess
}
    ${PurchasedMarketplaceDatasetFragmentDoc}
${DataSourceWithConfigAndEtlExtendedFragmentDoc}`;
export const PurchasedDataSourceConnectionWithOrganizationFragmentDoc = gql `
    fragment PurchasedDataSourceConnectionWithOrganization on PurchasedDataSourceConnectionWithOrganization {
  organization {
    ...SlimOrganization
  }
  purchasedDatasetConnection {
    ...PurchasedDataSourceConnection
  }
}
    ${SlimOrganizationFragmentDoc}
${PurchasedDataSourceConnectionFragmentDoc}`;
export const DatasetStatusFragmentDoc = gql `
    fragment DatasetStatus on DatasetStatus {
  organizationId
  datasetId
  collectionName
  statusType
  percentComplete
  errorDetails
}
    `;
export const VelocityStatusFragmentDoc = gql `
    fragment VelocityStatus on VelocityStatus {
  id
  serverUrl
  datasets {
    ...DatasetStatus
  }
  diskBytesAvailable
  ramBytesAvailable
  lastPing
  createdAt
  updatedAt
  deletedAt
}
    ${DatasetStatusFragmentDoc}`;
export const AzureMarketplaceDatasetEntityFragmentDoc = gql `
    fragment AzureMarketplaceDatasetEntity on AzureMarketplaceDatasetEntity {
  partitionKey
  rowKey
  accountId
  name
  description
  img
  slug
  size
  price
  fkProviderId
  createdAt
  updatedAt
  tableName
  collectionName
  geographyColumn
  tableId
  path
  type
  columns
}
    `;
export const MarketplaceDatasetDraftFragmentDoc = gql `
    fragment MarketplaceDatasetDraft on MarketplaceDatasetDraft {
  id
  name
  description
  content
  img
  size
  email
  pricing {
    ...Pricing
  }
  content
  status
  industries
  fkDataSourceId
  fkOrganizationId
  subscriptionFrequency
  contactLink
  sampleFilenames
  samplingSettings {
    ...SampleSettings
  }
  buyNow
  promoAssets {
    ...PromoAssets
  }
  additionalLinks {
    ...Links
  }
  termsOfUseLink
  categories
  subCategories
  countries
  organizationTypes
  keywords
  timeline {
    ...ListingTimeline
  }
  dataVolume {
    ...ListingDataVolume
  }
  fileSize
  fileUnit
  dataOrigin
  dataAttributes {
    ...ListingDataAttributes
  }
  fileFormats
  deliveryMethods
  frequency
  fkDataProductId
  createdAt
  updatedAt
  deletedAt
}
    ${PricingFragmentDoc}
${SampleSettingsFragmentDoc}
${PromoAssetsFragmentDoc}
${LinksFragmentDoc}
${ListingTimelineFragmentDoc}
${ListingDataVolumeFragmentDoc}
${ListingDataAttributesFragmentDoc}`;
export const MarketplaceDatasetDraftConnectionFragmentDoc = gql `
    fragment MarketplaceDatasetDraftConnection on MarketplaceDatasetDraftConnection {
  listings {
    ...MarketplaceDatasetDraft
  }
  total
}
    ${MarketplaceDatasetDraftFragmentDoc}`;
export const MarketplaceDatasetConnectionFragmentDoc = gql `
    fragment MarketplaceDatasetConnection on MarketplaceDatasetConnection {
  dataset {
    ...MarketplaceDatasetStudio
  }
  prices {
    ...SellerAccountPricing
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}
${SellerAccountPricingFragmentDoc}`;
export const DataSourceWithEtlDetailsFragmentDoc = gql `
    fragment DataSourceWithEtlDetails on DataSourceWithEtlDetails {
  fkDataSourceId
  fkEtlDatasetLocationId
  cloudStorageInfo {
    ...CloudStorageInfo
  }
  cronInterval
  fileType
}
    ${CloudStorageInfoFragmentDoc}`;
export const MarketplaceDatasetWithOrganizationFragmentDoc = gql `
    fragment MarketplaceDatasetWithOrganization on MarketplaceDatasetWithOrganization {
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
  organization {
    ...Organization
  }
  dataSource {
    ...DataSourceStudio
  }
  dataSourceConfiguration {
    ...DataSourceConfiguration
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}
${OrganizationFragmentDoc}
${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export const MarketplaceMapPreviewDetailsFragmentDoc = gql `
    fragment MarketplaceMapPreviewDetails on MarketplaceMapPreviewDetails {
  fkMarketplaceDatasetId
  fkDataSourceId
  fkOrganizationId
  status
  targetState
  serverUrl
  maxRows
  maxPercentage
  dggsColumn
  geographyColumn
  tableId
  lastSampleRequest
  totalSampleRequests
  lastSampleId
  collectionName
  geographyType
}
    `;
export const DatasetSampleRequestFragmentDoc = gql `
    fragment DatasetSampleRequest on DatasetSampleRequest {
  id
  fkMarketplaceDatasetId
  fkDataSourceId
  sampleId
  fkOrganizationId
  fkUserId
  fkSampleDataSourceId
  fkQuoteId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DataSourceComputeStatusConnectionFragmentDoc = gql `
    fragment DataSourceComputeStatusConnection on DataSourceComputeStatusConnection {
  dataSource {
    ...SlimDataSource
  }
  computeStatus
}
    ${SlimDataSourceFragmentDoc}`;
export const PurchasedMarketplaceDatasetConnectionFragmentDoc = gql `
    fragment PurchasedMarketplaceDatasetConnection on PurchasedMarketplaceDatasetConnection {
  purchasedDataset {
    ...PurchasedMarketplaceDataset
  }
  dataset {
    ...MarketplaceDatasetStudio
  }
  configuration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  dataSource {
    ...DataSourceStudio
  }
  userDataSource {
    ...UserDataSource
  }
  sellerAccountPricing {
    ...SellerAccountPricing
  }
  hasAccess
}
    ${PurchasedMarketplaceDatasetFragmentDoc}
${MarketplaceDatasetStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}
${DataSourceStudioFragmentDoc}
${UserDataSourceFragmentDoc}
${SellerAccountPricingFragmentDoc}`;
export const MarketplaceDatasetDataSourceConnectionFragmentDoc = gql `
    fragment MarketplaceDatasetDataSourceConnection on MarketplaceDatasetDataSourceConnection {
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
  dataSource {
    ...SlimDataSource
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}
${SlimDataSourceFragmentDoc}`;
export const MarketplaceDatasetDraftDataSourceConnectionFragmentDoc = gql `
    fragment MarketplaceDatasetDraftDataSourceConnection on MarketplaceDatasetDraftDataSourceConnection {
  marketplaceDatasetDraft {
    ...MarketplaceDatasetDraft
  }
  dataSource {
    ...SlimDataSource
  }
}
    ${MarketplaceDatasetDraftFragmentDoc}
${SlimDataSourceFragmentDoc}`;
export const ListingCategoryDetailsFragmentDoc = gql `
    fragment ListingCategoryDetails on ListingCategoryDetails {
  category
  description
  listings
  providers
}
    `;
export const ListingCategoryCountDetailsFragmentDoc = gql `
    fragment ListingCategoryCountDetails on ListingCategoryCountDetails {
  source
  category
  count
  subCategories {
    subCategory
    count
  }
}
    `;
export const SubCategoriesWithListingsFragmentDoc = gql `
    fragment SubCategoriesWithListings on SubCategoriesWithListings {
  category
  subCategories
}
    `;
export const MarketplaceSearchOptionFragmentDoc = gql `
    fragment MarketplaceSearchOption on MarketplaceSearchOption {
  type
  id
  name
  img
  slug
}
    `;
export const MarketplaceDatasetSlimConnectionFragmentDoc = gql `
    fragment MarketplaceDatasetSlimConnection on MarketplaceDatasetSlimConnection {
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
  organization {
    ...Organization
  }
  dataSource {
    ...SlimDataSource
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}
${OrganizationFragmentDoc}
${SlimDataSourceFragmentDoc}`;
export const DataSourceWithConfigAndEtlConnectionFragmentDoc = gql `
    fragment DataSourceWithConfigAndEtlConnection on DataSourceWithConfigAndEtlConnection {
  data {
    ...DataSourceWithConfigAndEtlExtended
  }
  total
}
    ${DataSourceWithConfigAndEtlExtendedFragmentDoc}`;
export const DataSourcePricingOptionsConnectionFragmentDoc = gql `
    fragment DataSourcePricingOptionsConnection on DataSourcePricingOptionsConnection {
  dataSource {
    ...SlimDataSource
  }
  startingPrice {
    ...DataSourcePricePriceFrequencyConnection
  }
  marketplaceListingImgs
  numPricingOptions
}
    ${SlimDataSourceFragmentDoc}
${DataSourcePricePriceFrequencyConnectionFragmentDoc}`;
export const DataSourcePricingOptionsCountConnectionFragmentDoc = gql `
    fragment DataSourcePricingOptionsCountConnection on DataSourcePricingOptionsCountConnection {
  connections {
    ...DataSourcePricingOptionsConnection
  }
  count
}
    ${DataSourcePricingOptionsConnectionFragmentDoc}`;
export const DataSourceNumVariantsConnectionFragmentDoc = gql `
    fragment DataSourceNumVariantsConnection on DataSourceNumVariantsConnection {
  dataSource {
    ...SlimDataSource
  }
  numVariants
}
    ${SlimDataSourceFragmentDoc}`;
export const DemoInstancesFragmentDoc = gql `
    fragment DemoInstances on DemoInstances {
  id
  name
  description
  url
  slug
  createdAt
  updatedAt
  deletedAt
}
    `;
export const FileGenerationFragmentDoc = gql `
    fragment FileGeneration on FileGeneration {
  id
  name
  description
  fkOrganizationId
  fkUserId
  fkSavedViewId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const GeneratedFileFragmentDoc = gql `
    fragment GeneratedFile on GeneratedFile {
  id
  fkFileGenerationId
  fkDataSourceId
  name
  path
  fileType
  diskActual
  status
  expiredAt
  lastExportedAt
  createdAt
  updatedAt
  deletedAt
}
    `;
export const FileGenerationExtendedFragmentDoc = gql `
    fragment FileGenerationExtended on FileGenerationExtended {
  fileGeneration {
    ...FileGeneration
  }
  generatedFiles {
    ...GeneratedFile
  }
}
    ${FileGenerationFragmentDoc}
${GeneratedFileFragmentDoc}`;
export const GeneratedFileExtendedFragmentDoc = gql `
    fragment GeneratedFileExtended on GeneratedFileExtended {
  generateFile {
    ...GeneratedFile
  }
  originCloudStorageType
}
    ${GeneratedFileFragmentDoc}`;
export const FileGenerationConnectionFragmentDoc = gql `
    fragment FileGenerationConnection on FileGenerationConnection {
  fileGeneration {
    ...FileGeneration
  }
  mapTemplateId
  generatedFiles {
    ...GeneratedFileExtended
  }
}
    ${FileGenerationFragmentDoc}
${GeneratedFileExtendedFragmentDoc}`;
export const EntitlementFragmentDoc = gql `
    fragment Entitlement on Entitlement {
  id
  accessKey
  type
  createdAt
  updatedAt
  deletedAt
}
    `;
export const VerifiedAccessKeyResponseFragmentDoc = gql `
    fragment VerifiedAccessKeyResponse on VerifiedAccessKeyResponse {
  status
  message
  productId
}
    `;
export const LabAccessKeyExtendedFragmentDoc = gql `
    fragment LabAccessKeyExtended on LabAccessKeyExtended {
  apiKey
  status
  datasources {
    ...DataSourceWithConfigAndEtlExtended
  }
  marketplaceDatasets {
    ...MarketplaceDatasetStudio
  }
  customer {
    ...SlimCustomer
  }
  keyType
  datalabEntitlementId
  price
  expiryDate
  keyCreatedAt
  keyUpdatedAt
}
    ${DataSourceWithConfigAndEtlExtendedFragmentDoc}
${MarketplaceDatasetStudioFragmentDoc}
${SlimCustomerFragmentDoc}`;
export const LabAccessKeyExtendedConnectionFragmentDoc = gql `
    fragment LabAccessKeyExtendedConnection on LabAccessKeyExtendedConnection {
  labAccessKeyExtended {
    ...LabAccessKeyExtended
  }
  total
}
    ${LabAccessKeyExtendedFragmentDoc}`;
export const CloudCredentialInfoFragmentDoc = gql `
    fragment CloudCredentialInfo on CloudCredentialInfo {
  ... on AzureCredential {
    cloudStorageType
    credential {
      ... on AzureAadCredential {
        azureCredentialType
        clientId
        clientSecret
        tenantId
      }
      ... on AzureSasCredential {
        azureCredentialType
        sasToken
      }
    }
  }
  ... on AwsCredential {
    cloudStorageType
    credential {
      ... on AwsIamCredential {
        awsCredentialType
        region
        accessKeyId
        secretAccessKey
      }
      ... on AwsPurlCredential {
        awsCredentialType
        presignedUrl
      }
    }
  }
  ... on SfCredential {
    cloudStorageType
    credential {
      presignedUrl
    }
  }
  ... on GcpCredential {
    cloudStorageType
    credential {
      ... on GcpPKeyCredential {
        gcpCredentialType
        clientEmail
        privateKey
      }
      ... on GcpOAuthCredential {
        gcpCredentialType
        accessToken
        refreshToken
      }
    }
  }
  ... on GoogleDriveCredential {
    cloudStorageType
    credential {
      ... on GoogleDriveOAuthCredential {
        googleDriveCredentialType
        accessToken
        refreshToken
      }
      ... on GoogleDriveUrlCredential {
        googleDriveCredentialType
        url
        urlAccessToken
        urlRefreshToken
      }
    }
  }
  ... on UploadCredential {
    cloudStorageType
    credential {
      containerName
    }
  }
}
    `;
export const DataSourceEtlLocationFragmentDoc = gql `
    fragment DataSourceEtlLocation on DataSourceEtlLocation {
  dataSourceId
  etlLocation {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export const TableEntityFragmentDoc = gql `
    fragment TableEntity on TableEntity {
  entity
}
    `;
export const EtlErrorFragmentDoc = gql `
    fragment EtlError on EtlError {
  id
  fkInstanceId
  errorType
  errorMessage
  timestamp
  errorCriticality
  createdAt
  updatedAt
  deletedAt
}
    `;
export const DeleteEtlInstanceOrErrorFragmentDoc = gql `
    fragment DeleteEtlInstanceOrError on DeleteEtlInstanceOrError {
  id
}
    `;
export const EtlProcessFragmentDoc = gql `
    fragment EtlProcess on EtlProcess {
  count
  status
  datasetLocationId
}
    `;
export const ExternalCredentialFragmentDoc = gql `
    fragment ExternalCredential on ExternalCredential {
  id
  cloudStorageType
}
    `;
export const CloudConnectionInfoFragmentDoc = gql `
    fragment CloudConnectionInfo on CloudConnectionInfo {
  ... on AzureConnectionInfo {
    cloudStorageType
    credential {
      cloudStorageType
      credential {
        ... on AzureAadCredential {
          azureCredentialType
          clientId
          clientSecret
          tenantId
        }
        ... on AzureSasCredential {
          azureCredentialType
          sasToken
        }
      }
    }
    storageInfo {
      cloudStorageType
      info {
        accountName
        containerName
        blobName
      }
    }
  }
  ... on AwsConnectionInfo {
    cloudStorageType
    credential {
      cloudStorageType
      credential {
        ... on AwsIamCredential {
          awsCredentialType
          region
          accessKeyId
          secretAccessKey
        }
        ... on AwsPurlCredential {
          awsCredentialType
          presignedUrl
        }
      }
    }
    storageInfo {
      cloudStorageType
      info {
        storage
        bucketName
      }
    }
  }
  ... on GoogleDriveConnectionInfo {
    cloudStorageType
    credential {
      cloudStorageType
      credential {
        ... on GoogleDriveOAuthCredential {
          googleDriveCredentialType
          accessToken
          refreshToken
        }
        ... on GoogleDriveUrlCredential {
          googleDriveCredentialType
          url
          urlAccessToken
          urlRefreshToken
        }
      }
    }
    storageInfo {
      cloudStorageType
      info {
        folderId
      }
    }
  }
  ... on SfConnectionInfo {
    cloudStorageType
    credential {
      cloudStorageType
      credential {
        presignedUrl
      }
    }
    storageInfo {
      cloudStorageType
      info {
        accountId
      }
    }
  }
  ... on GcpConnectionInfo {
    cloudStorageType
    credential {
      cloudStorageType
      credential {
        ... on GcpPKeyCredential {
          gcpCredentialType
          clientEmail
          privateKey
        }
        ... on GcpOAuthCredential {
          gcpCredentialType
          accessToken
          refreshToken
        }
      }
    }
    storageInfo {
      cloudStorageType
      info {
        projectId
        gcpBucketName
      }
    }
  }
  ... on UploadConnectionInfo {
    cloudStorageType
    credential {
      ... on UploadCredential {
        cloudStorageType
        credential {
          containerName
        }
      }
    }
    storageInfo {
      cloudStorageType
      info {
        url
      }
    }
  }
}
    `;
export const ExternalCredentialExtendedFragmentDoc = gql `
    fragment ExternalCredentialExtended on ExternalCredentialExtended {
  id
  cloudConnectionInfo {
    ...CloudConnectionInfo
  }
  organization {
    ...Organization
  }
}
    ${CloudConnectionInfoFragmentDoc}
${OrganizationFragmentDoc}`;
export const DeletedStorageBlobFragmentDoc = gql `
    fragment DeletedStorageBlob on DeletedStorageBlob {
  succeeded
  errorCode
  requestId
}
    `;
export const InstantOfferFragmentDoc = gql `
    fragment InstantOffer on InstantOffer {
  id
  fkOrganizationId
  fkCustomerId
  fkDataSourcePriceId
  link
  paymentStatus
  createdAt
  updatedAt
  deletedAt
}
    `;
export const InstantOfferExtendedFragmentDoc = gql `
    fragment InstantOfferExtended on InstantOfferExtended {
  customer {
    ...Customer
  }
  dataSourcePrice {
    ...DataSourcePrice
  }
  instantOffer {
    ...InstantOffer
  }
  organization {
    ...SlimOrganization
  }
}
    ${CustomerFragmentDoc}
${DataSourcePriceFragmentDoc}
${InstantOfferFragmentDoc}
${SlimOrganizationFragmentDoc}`;
export const InstantOfferCustomerVariantConnectionFragmentDoc = gql `
    fragment InstantOfferCustomerVariantConnection on InstantOfferCustomerVariantConnection {
  data {
    ...InstantOfferExtended
  }
  totalCount
}
    ${InstantOfferExtendedFragmentDoc}`;
export const JourneyEventMetaFragmentDoc = gql `
    fragment JourneyEventMeta on JourneyEventMeta {
  id
  event
  description
  image
  isIntegrated
  lastRan
  createdAt
  updatedAt
}
    `;
export const JourneyRunFragmentDoc = gql `
    fragment JourneyRun on JourneyRun {
  id
  event
  fkJourneyId
  startedBy
  status
  message
  data
  inputData
  createdAt
  updatedAt
}
    `;
export const JourneyStepRunFragmentDoc = gql `
    fragment JourneyStepRun on JourneyStepRun {
  id
  event
  fkJourneyRunId
  fkJourneyStepId
  status
  message
  type
  name
  description
  image
  active
  validated
  job
  startingStep
  result
  error
  data
  createdAt
  updatedAt
}
    `;
export const JourneyStepFragmentDoc = gql `
    fragment JourneyStep on JourneyStep {
  id
  fkJourneyId
  type
  name
  description
  image
  active
  validated
  job
  startingStep
  createdAt
  updatedAt
}
    `;
export const JourneyFragmentDoc = gql `
    fragment Journey on Journey {
  id
  event
  name
  description
  image
  active
  createdAt
  updatedAt
}
    `;
export const MapTemplateFragmentDoc = gql `
    fragment MapTemplate on MapTemplate {
  id
  name
  description
  fkUserId
  fkOrganizationId
  status
  img
  isGlobal
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ColorSwatchFragmentDoc = gql `
    fragment ColorSwatch on ColorSwatch {
  range
  color
}
    `;
export const DatasetStylesFragmentDoc = gql `
    fragment DatasetStyles on DatasetStyles {
  shape
  fill {
    ...ShapeColor
  }
  stroke {
    ...ShapeColor
  }
  customMarker
  dataAggregation {
    heatmap {
      id
      swatch {
        ...ColorSwatch
      }
    }
  }
}
    ${ShapeColorFragmentDoc}
${ColorSwatchFragmentDoc}`;
export const MapTemplateDatasetFragmentDoc = gql `
    fragment MapTemplateDataset on MapTemplateDataset {
  id
  fkDataSourceId
  fkMapTemplateId
  mapUse
  styles {
    ...DatasetStyles
  }
  createdAt
  updatedAt
  deletedAt
}
    ${DatasetStylesFragmentDoc}`;
export const ViewportFragmentDoc = gql `
    fragment Viewport on Viewport {
  latBounds {
    min
    max
  }
  lngBounds {
    min
    max
  }
}
    `;
export const RequestOptionsFragmentDoc = gql `
    fragment RequestOptions on RequestOptions {
  pointMaxGeomsPerCell
  pointResolutionOffset
  polygonMaxGeomsPerCell
  polygonResolutionOffset
  geometriesChunkSize
  aggregatesChunkSize
  levelSets
}
    `;
export const DatasetConfigurationFragmentDoc = gql `
    fragment DatasetConfiguration on DatasetConfiguration {
  showLevelSets
  showPoints
  options {
    ...RequestOptions
  }
}
    ${RequestOptionsFragmentDoc}`;
export const DatasetGeometryPointFragmentDoc = gql `
    fragment DatasetGeometryPoint on DatasetGeometryPoint {
  fkDataSourceId
  fkMapTemplateDatasetId
  tableId
  row
}
    `;
export const FilterDataFragmentDoc = gql `
    fragment FilterData on FilterData {
  stringData
  numberData
  dateData
  booleanData
}
    `;
export const FilterItemFragmentDoc = gql `
    fragment FilterItem on FilterItem {
  id
  type
  column
  data {
    ...FilterData
  }
  operator
}
    ${FilterDataFragmentDoc}`;
export const FilterObjectFragmentDoc = gql `
    fragment FilterObject on FilterObject {
  databaseId
  filters {
    ...FilterItem
  }
  logicOperator
  collection
  databaseType
  options {
    ...RequestOptions
  }
}
    ${FilterItemFragmentDoc}
${RequestOptionsFragmentDoc}`;
export const SavedViewDatasetFragmentDoc = gql `
    fragment SavedViewDataset on SavedViewDataset {
  fkDataSourceId
  fkMapTemplateDatasetId
  styles {
    ...DatasetStyles
  }
  selected
  configuration {
    ...DatasetConfiguration
  }
  selectedRows {
    ...DatasetGeometryPoint
  }
  pinnedRows {
    ...DatasetGeometryPoint
  }
  filters {
    ...FilterObject
  }
}
    ${DatasetStylesFragmentDoc}
${DatasetConfigurationFragmentDoc}
${DatasetGeometryPointFragmentDoc}
${FilterObjectFragmentDoc}`;
export const SavedViewFragmentDoc = gql `
    fragment SavedView on SavedView {
  id
  name
  description
  fkMapTemplateId
  fkSavedAreaId
  fkUserId
  fkOrganizationId
  img
  theme
  isExport
  viewport {
    ...Viewport
  }
  datasets {
    ...SavedViewDataset
  }
  createdAt
  updatedAt
  deletedAt
}
    ${ViewportFragmentDoc}
${SavedViewDatasetFragmentDoc}`;
export const MapTemplateExtendedFragmentDoc = gql `
    fragment MapTemplateExtended on MapTemplateExtended {
  mapTemplate {
    ...MapTemplate
  }
  mapTemplateDatasets {
    ...MapTemplateDataset
  }
  savedViews {
    ...SavedView
  }
  savedAreas {
    ...SavedArea
  }
  dataSources {
    ...DataSourceStudio
  }
}
    ${MapTemplateFragmentDoc}
${MapTemplateDatasetFragmentDoc}
${SavedViewFragmentDoc}
${SavedAreaFragmentDoc}
${DataSourceStudioFragmentDoc}`;
export const MapTemplateDatasetExtendedFragmentDoc = gql `
    fragment MapTemplateDatasetExtended on MapTemplateDatasetExtended {
  mapTemplateDataset {
    ...MapTemplateDataset
  }
  mapTemplate {
    ...MapTemplate
  }
  dataSource {
    ...DataSourceStudio
  }
  dataSourceConfiguration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
}
    ${MapTemplateDatasetFragmentDoc}
${MapTemplateFragmentDoc}
${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}`;
export const NamedBoundarySetFragmentDoc = gql `
    fragment NamedBoundarySet on NamedBoundarySet {
  id
  name
  boundaries {
    id
    name
    geometry
  }
}
    `;
export const NamedBoundarySetResponseFragmentDoc = gql `
    fragment NamedBoundarySetResponse on NamedBoundarySetResponse {
  boundarySet {
    ...NamedBoundarySet
  }
}
    ${NamedBoundarySetFragmentDoc}`;
export const NamedBoundaryFragmentDoc = gql `
    fragment NamedBoundary on NamedBoundary {
  id
  name
  geometry
}
    `;
export const NamedBoundaryResponseFragmentDoc = gql `
    fragment NamedBoundaryResponse on NamedBoundaryResponse {
  boundary {
    ...NamedBoundary
  }
}
    ${NamedBoundaryFragmentDoc}`;
export const NamedBoundarySuggestResponseFragmentDoc = gql `
    fragment NamedBoundarySuggestResponse on NamedBoundarySuggestResponse {
  suggestions
}
    `;
export const GetBoundariesGeoJsonResponseFragmentDoc = gql `
    fragment GetBoundariesGeoJsonResponse on GetBoundariesGeoJsonResponse {
  boundaries {
    ...NamedBoundary
  }
}
    ${NamedBoundaryFragmentDoc}`;
export const NamedBoundaryPriceConnectionFragmentDoc = gql `
    fragment NamedBoundaryPriceConnection on NamedBoundaryPriceConnection {
  boundary {
    ...NamedBoundary
  }
  fullPrice
}
    ${NamedBoundaryFragmentDoc}`;
export const BoundarySetTableCountConnectionFragmentDoc = gql `
    fragment BoundarySetTableCountConnection on BoundarySetTableCountConnection {
  namedBoundaries {
    ...NamedBoundaryPriceConnection
  }
  count
}
    ${NamedBoundaryPriceConnectionFragmentDoc}`;
export const OnboardingStepCompletionFragmentDoc = gql `
    fragment OnboardingStepCompletion on OnboardingStepCompletion {
  id
  integrationId
  onboardingStepId
  fkOrganizationId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ClientOnboardingCtaFragmentDoc = gql `
    fragment ClientOnboardingCTA on ClientOnboardingCTA {
  text
  link
}
    `;
export const ClientOnboardingStepFragmentDoc = gql `
    fragment ClientOnboardingStep on ClientOnboardingStep {
  id
  fkOrganizationId
  fkWorkspaceId
  fkWorkspaceIntegrationId
  imageUrl
  videoUrl
  title
  subtitle
  content
  primaryCTA {
    ...ClientOnboardingCTA
  }
  secondaryCTA {
    ...ClientOnboardingCTA
  }
  isLive
  index
  completeOnClick
  createdAt
  updatedAt
}
    ${ClientOnboardingCtaFragmentDoc}`;
export const OnboardingStepCompletionsConnectionFragmentDoc = gql `
    fragment OnboardingStepCompletionsConnection on OnboardingStepCompletionsConnection {
  steps {
    ...ClientOnboardingStep
  }
  stepCompletionIds
}
    ${ClientOnboardingStepFragmentDoc}`;
export const OrganizationIndustryListingsFragmentDoc = gql `
    fragment OrganizationIndustryListings on OrganizationIndustryListings {
  organizations {
    ...Organization
  }
  industries
}
    ${OrganizationFragmentDoc}`;
export const OrganizationWithRelationsCountFragmentDoc = gql `
    fragment OrganizationWithRelationsCount on OrganizationWithRelationsCount {
  organization {
    ...Organization
  }
  marketplaceDatasets
  organizationUsers
  dataSources
}
    ${OrganizationFragmentDoc}`;
export const OrganizationUserFragmentDoc = gql `
    fragment OrganizationUser on OrganizationUser {
  id
  fkOrganizationId
  fkUserId
  studioPermissions
  productPermissions
  isOwner
  isSupport
  createdAt
  updatedAt
  deletedAt
}
    `;
export const OrganizationUserExtendedFragmentDoc = gql `
    fragment OrganizationUserExtended on OrganizationUserExtended {
  organizationUser {
    ...OrganizationUser
  }
  user {
    ...User
  }
  organization {
    ...Organization
  }
}
    ${OrganizationUserFragmentDoc}
${UserFragmentDoc}
${OrganizationFragmentDoc}`;
export const OrganizationExtendedFragmentDoc = gql `
    fragment OrganizationExtended on OrganizationExtended {
  organization {
    ...Organization
  }
  organizationUsers {
    ...OrganizationUser
  }
}
    ${OrganizationFragmentDoc}
${OrganizationUserFragmentDoc}`;
export const OrganizationUserExtendedWithUserFragmentDoc = gql `
    fragment OrganizationUserExtendedWithUser on OrganizationUserExtendedWithUser {
  organizationUser {
    ...OrganizationUser
  }
  user {
    ...User
  }
}
    ${OrganizationUserFragmentDoc}
${UserFragmentDoc}`;
export const OrganizationExtendedOrganizationUserExtendedFragmentDoc = gql `
    fragment OrganizationExtendedOrganizationUserExtended on OrganizationExtendedOrganizationUserExtended {
  organization {
    ...Organization
  }
  organizationUsers {
    ...OrganizationUserExtendedWithUser
  }
}
    ${OrganizationFragmentDoc}
${OrganizationUserExtendedWithUserFragmentDoc}`;
export const OrganizationExtendedCountFragmentDoc = gql `
    fragment OrganizationExtendedCount on OrganizationExtendedCount {
  organization {
    ...Organization
  }
  organizationUsers {
    ...OrganizationUser
  }
  organizationUsersCount
}
    ${OrganizationFragmentDoc}
${OrganizationUserFragmentDoc}`;
export const OrganizationUserExtendedWithTeamIDsFragmentDoc = gql `
    fragment OrganizationUserExtendedWithTeamIDs on OrganizationUserExtendedWithTeamIDs {
  organizationUser {
    ...OrganizationUser
  }
  user {
    ...User
  }
  teamIDs
}
    ${OrganizationUserFragmentDoc}
${UserFragmentDoc}`;
export const UserInviteFragmentDoc = gql `
    fragment UserInvite on UserInvite {
  id
  email
  token
  fkUserId
  fkOrganizationId
  fkTeamId
  fkProductId
  status
  studioPermissions
  productPermissions
  createdAt
  updatedAt
  deletedAt
}
    `;
export const TeamFragmentDoc = gql `
    fragment Team on Team {
  id
  name
  fkOrganizationId
  description
  image
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProductFragmentDoc = gql `
    fragment Product on Product {
  id
  name
  fkOrganizationId
  productEnum
  description
  image
  status
  url
  spaceType
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserInviteExtendedFragmentDoc = gql `
    fragment UserInviteExtended on UserInviteExtended {
  invite {
    ...UserInvite
  }
  sender {
    ...User
  }
  recipient {
    ...User
  }
  team {
    ...Team
  }
  organization {
    ...Organization
  }
  product {
    ...Product
  }
}
    ${UserInviteFragmentDoc}
${UserFragmentDoc}
${TeamFragmentDoc}
${OrganizationFragmentDoc}
${ProductFragmentDoc}`;
export const OrganizationUsersWithInvitesFragmentDoc = gql `
    fragment OrganizationUsersWithInvites on OrganizationUsersWithInvites {
  users {
    ...OrganizationUserExtendedWithUser
  }
  invites {
    ...UserInviteExtended
  }
}
    ${OrganizationUserExtendedWithUserFragmentDoc}
${UserInviteExtendedFragmentDoc}`;
export const AzureDataProviderEntityFragmentDoc = gql `
    fragment AzureDataProviderEntity on AzureDataProviderEntity {
  category
  description
  accountId
  img
  name
  slug
  partitionKey
  rowKey
  status
  createdAt
  updatedAt
  organizationCode
}
    `;
export const SlimDataProviderFragmentDoc = gql `
    fragment SlimDataProvider on SlimDataProvider {
  id
  name
  img
  country
  description
  categories
  subCategories
  countries
  listings
  slug
}
    `;
export const StripeInvoiceFragmentDoc = gql `
    fragment StripeInvoice on StripeInvoice {
  id
  total
  invoiceUrl
  createdAt
}
    `;
export const StripeBillingDetailsFragmentDoc = gql `
    fragment StripeBillingDetails on StripeBillingDetails {
  city
  country
  line1
  line2
  postalCode
  state
  email
  name
}
    `;
export const StripePaymentMethodCardFragmentDoc = gql `
    fragment StripePaymentMethodCard on StripePaymentMethodCard {
  paymentMethodId
  brand
  expiryMonth
  expiryYear
  lastFourDigits
  billingDetails {
    ...StripeBillingDetails
  }
  isDefault
}
    ${StripeBillingDetailsFragmentDoc}`;
export const StripePaymentMethodLinkFragmentDoc = gql `
    fragment StripePaymentMethodLink on StripePaymentMethodLink {
  paymentMethodId
  email
  billingDetails {
    ...StripeBillingDetails
  }
  isDefault
}
    ${StripeBillingDetailsFragmentDoc}`;
export const StripePaymentMethodUnionFragmentDoc = gql `
    fragment StripePaymentMethodUnion on StripePaymentMethodUnion {
  paymentMethodId
  card {
    ...StripePaymentMethodCard
  }
  link {
    ...StripePaymentMethodLink
  }
}
    ${StripePaymentMethodCardFragmentDoc}
${StripePaymentMethodLinkFragmentDoc}`;
export const PlatformNotificationExtendedFragmentDoc = gql `
    fragment PlatformNotificationExtended on PlatformNotificationExtended {
  id
  fkUserId
  title
  message
  link
  readAt
  image
  createdAt
  organization {
    id
    name
  }
}
    `;
export const PlatformNotificationFragmentDoc = gql `
    fragment PlatformNotification on PlatformNotification {
  id
  fkUserId
  title
  message
  link
  readAt
  image
  createdAt
  organization {
    id
    name
  }
}
    `;
export const ProductUserFragmentDoc = gql `
    fragment ProductUser on ProductUser {
  id
  fkUserId
  fkProductId
  fkOrganizationUserId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ProductExtendedFragmentDoc = gql `
    fragment ProductExtended on ProductExtended {
  product {
    ...Product
  }
  productUser {
    ...ProductUser
  }
}
    ${ProductFragmentDoc}
${ProductUserFragmentDoc}`;
export const ProductUserExtendedFragmentDoc = gql `
    fragment ProductUserExtended on ProductUserExtended {
  productUser {
    ...ProductUser
  }
  product {
    ...Product
  }
  user {
    ...User
  }
  organizationUser {
    ...OrganizationUser
  }
}
    ${ProductUserFragmentDoc}
${ProductFragmentDoc}
${UserFragmentDoc}
${OrganizationUserFragmentDoc}`;
export const ProductExtendedProductUserExtendedFragmentDoc = gql `
    fragment ProductExtendedProductUserExtended on ProductExtendedProductUserExtended {
  product {
    ...Product
  }
  productUserExtended {
    ...ProductUserExtended
  }
}
    ${ProductFragmentDoc}
${ProductUserExtendedFragmentDoc}`;
export const SpaceTeamMemberFragmentDoc = gql `
    fragment SpaceTeamMember on SpaceTeamMember {
  fkUserId
  fkOrganizationUserId
  fkProductUserId
  firstName
  lastName
  img
  email
  role
  status
  token
  lastLogin
}
    `;
export const QuoteFragmentDoc = gql `
    fragment Quote on Quote {
  id
  fkCustomerId
  fkOrganizationId
  link
  expireAt
  fkDataSourcePriceId
  discountType
  discountValue
  stripeProductId
  stripePriceId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const QuoteBoundariesFragmentDoc = gql `
    fragment QuoteBoundaries on QuoteBoundaries {
  id
  fkQuoteId
  namedBoundaryId
  namedBoundaryName
  boundarySetId
}
    `;
export const QuoteExtendedFragmentDoc = gql `
    fragment QuoteExtended on QuoteExtended {
  quote {
    ...Quote
  }
  customer {
    ...Customer
  }
  quoteBoundaries {
    ...QuoteBoundaries
  }
  dataSourcePrice {
    ...DataSourcePrice
  }
  dataProduct {
    ...DataProduct
  }
  prices {
    ...DataProductVariantBoundarySetPrice
  }
}
    ${QuoteFragmentDoc}
${CustomerFragmentDoc}
${QuoteBoundariesFragmentDoc}
${DataSourcePriceFragmentDoc}
${DataProductFragmentDoc}
${DataProductVariantBoundarySetPriceFragmentDoc}`;
export const QuoteCustomerVariantConnectionFragmentDoc = gql `
    fragment QuoteCustomerVariantConnection on QuoteCustomerVariantConnection {
  data {
    ...QuoteExtended
  }
  totalCount
}
    ${QuoteExtendedFragmentDoc}`;
export const SampleDataSourceExtendedFragmentDoc = gql `
    fragment SampleDataSourceExtended on SampleDataSourceExtended {
  userDataSource {
    ...UserDataSource
  }
  organization {
    ...Organization
  }
  dataSourceConfiguration {
    ...DataSourceConfiguration
  }
  marketplaceDataset {
    ...MarketplaceDatasetStudio
  }
  dataSource {
    ...DataSourceStudio
  }
  quote {
    ...Quote
  }
}
    ${UserDataSourceFragmentDoc}
${OrganizationFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${MarketplaceDatasetStudioFragmentDoc}
${DataSourceStudioFragmentDoc}
${QuoteFragmentDoc}`;
export const DatalabSellerAccountFragmentDoc = gql `
    fragment DatalabSellerAccount on DatalabSellerAccount {
  id
  fkOrganizationId
  stripeConnectAccountId
  accountType
  isOnboardingComplete
  createdAt
  updatedAt
}
    `;
export const QuoteLinkFragmentDoc = gql `
    fragment QuoteLink on QuoteLink {
  quote {
    ...Quote
  }
  boundaries {
    ...QuoteBoundaries
  }
  dataSourcePrice {
    ...DataSourcePrice
  }
  dataSourceName
  serverUrl
  tableId
  geographyColumn
  geographyType
  collection
  sample {
    ...SampleDataSourceExtended
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
  sellerAccount {
    ...DatalabSellerAccount
  }
  dataSourcePermission {
    ...DataSourcePermission
  }
}
    ${QuoteFragmentDoc}
${QuoteBoundariesFragmentDoc}
${DataSourcePriceFragmentDoc}
${SampleDataSourceExtendedFragmentDoc}
${EtlDatasetLocationFragmentDoc}
${DatalabSellerAccountFragmentDoc}
${DataSourcePermissionFragmentDoc}`;
export const SavedViewDatasetExtendedFragmentDoc = gql `
    fragment SavedViewDatasetExtended on SavedViewDatasetExtended {
  dataset {
    ...SavedViewDataset
  }
  dataSource {
    ...DataSourceStudio
  }
  mapTemplateDataset {
    ...MapTemplateDataset
  }
  dataSourceConfiguration {
    ...DataSourceConfiguration
  }
  etlDatasetLocation {
    ...EtlDatasetLocation
  }
}
    ${SavedViewDatasetFragmentDoc}
${DataSourceStudioFragmentDoc}
${MapTemplateDatasetFragmentDoc}
${DataSourceConfigurationFragmentDoc}
${EtlDatasetLocationFragmentDoc}`;
export const SavedViewExtendedFragmentDoc = gql `
    fragment SavedViewExtended on SavedViewExtended {
  savedView {
    ...SavedView
  }
  savedArea {
    ...SavedArea
  }
  datasets {
    ...SavedViewDatasetExtended
  }
}
    ${SavedViewFragmentDoc}
${SavedAreaFragmentDoc}
${SavedViewDatasetExtendedFragmentDoc}`;
export const SendGridTemplateVersionFragmentDoc = gql `
    fragment SendGridTemplateVersion on SendGridTemplateVersion {
  id
  name
  templateId
  subject
  active
  thumbnail
  updatedAt
}
    `;
export const SendGridTemplateFragmentDoc = gql `
    fragment SendGridTemplate on SendGridTemplate {
  id
  name
  versions {
    ...SendGridTemplateVersion
  }
  updatedAt
}
    ${SendGridTemplateVersionFragmentDoc}`;
export const SlackChannelFragmentDoc = gql `
    fragment SlackChannel on SlackChannel {
  id
  name
  numMembers
}
    `;
export const ComputeChangesFragmentDoc = gql `
    fragment ComputeChanges on ComputeChanges {
  dataSourceId
  status
}
    `;
export const ServerChangesFragmentDoc = gql `
    fragment ServerChanges on ServerChanges {
  dataSourceId
  status
  serverUrl
}
    `;
export const EtlOriginalSourcesProcessFragmentDoc = gql `
    fragment EtlOriginalSourcesProcess on EtlOriginalSourcesProcess {
  etlDatasetLocationId
  status
}
    `;
export const EgressSubscriptionReturnFragmentDoc = gql `
    fragment EgressSubscriptionReturn on EgressSubscriptionReturn {
  progress
  totalBytes
  bytesTransferred
}
    `;
export const TeamMemberFragmentDoc = gql `
    fragment TeamMember on TeamMember {
  id
  fkTeamId
  fkUserId
  fkOrganizationId
  fkOrganizationUserId
  createdAt
  updatedAt
  deletedAt
}
    `;
export const TeamMemberExtendedWithUserFragmentDoc = gql `
    fragment TeamMemberExtendedWithUser on TeamMemberExtendedWithUser {
  teamMember {
    ...TeamMember
  }
  user {
    ...User
  }
}
    ${TeamMemberFragmentDoc}
${UserFragmentDoc}`;
export const TeamExtendedFragmentDoc = gql `
    fragment TeamExtended on TeamExtended {
  team {
    ...Team
  }
  teamMembers {
    ...TeamMemberExtendedWithUser
  }
}
    ${TeamFragmentDoc}
${TeamMemberExtendedWithUserFragmentDoc}`;
export const TeamMemberExtendedWithUserAndTeamFragmentDoc = gql `
    fragment TeamMemberExtendedWithUserAndTeam on TeamMemberExtendedWithUserAndTeam {
  teamMember {
    ...TeamMember
  }
  user {
    ...User
  }
  team {
    ...Team
  }
}
    ${TeamMemberFragmentDoc}
${UserFragmentDoc}
${TeamFragmentDoc}`;
export const UserSegmentFragmentDoc = gql `
    fragment UserSegment on UserSegment {
  id
  name
  description
  createdAt
  updatedAt
}
    `;
export const UserSegmentUserFragmentDoc = gql `
    fragment UserSegmentUser on UserSegmentUser {
  id
  fkUserSegmentId
  fkUserId
  fkOrganizationId
  email
  firstName
  lastName
  createdAt
  updatedAt
}
    `;
export const UserSegmentUsersConnectionFragmentDoc = gql `
    fragment UserSegmentUsersConnection on UserSegmentUsersConnection {
  users {
    ...UserSegmentUser
  }
  totalCount
}
    ${UserSegmentUserFragmentDoc}`;
export const EmailVerifyResponseFragmentDoc = gql `
    fragment EmailVerifyResponse on EmailVerifyResponse {
  email
  success
  userExist
}
    `;
export const AuthenticatedUserFragmentDoc = gql `
    fragment AuthenticatedUser on AuthenticatedUser {
  jwt
  user {
    ...User
  }
  organizationUser {
    ...OrganizationUser
  }
  organization {
    ...Organization
  }
  product {
    ...Product
  }
}
    ${UserFragmentDoc}
${OrganizationUserFragmentDoc}
${OrganizationFragmentDoc}
${ProductFragmentDoc}`;
export const UserConnectionFragmentDoc = gql `
    fragment UserConnection on UserConnection {
  id
  connectionType
  fkUserId
  fkOrganizationId
  fkProductId
  fkTeamId
  fkUserInviteId
  user {
    ...User
  }
  organization {
    ...Organization
  }
  product {
    ...Product
  }
  team {
    ...Team
  }
  userInvite {
    ...UserInvite
  }
  createdAt
  updatedAt
  deletedAt
}
    ${UserFragmentDoc}
${OrganizationFragmentDoc}
${ProductFragmentDoc}
${TeamFragmentDoc}
${UserInviteFragmentDoc}`;
export const SlimUserFragmentDoc = gql `
    fragment SlimUser on SlimUser {
  id
  email
  firstName
  lastName
  address
  phoneCountryCode
  phone
  img
  verified
}
    `;
export const GetVersionDocument = gql `
    query getVersion {
  getVersion
}
    `;
export function useGetVersionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetVersionDocument, options);
}
export function useGetVersionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetVersionDocument, options);
}
export function useGetVersionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetVersionDocument, options);
}
export const FetchAreaDocument = gql `
    query fetchArea($input: InputArea!) {
  fetchArea(input: $input) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;
export function useFetchAreaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAreaDocument, options);
}
export function useFetchAreaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAreaDocument, options);
}
export function useFetchAreaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAreaDocument, options);
}
export const FetchAreasDocument = gql `
    query fetchAreas {
  fetchAreas {
    ...Area
  }
}
    ${AreaFragmentDoc}`;
export function useFetchAreasQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAreasDocument, options);
}
export function useFetchAreasLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAreasDocument, options);
}
export function useFetchAreasSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAreasDocument, options);
}
export const FetchAreasExtendedDocument = gql `
    query fetchAreasExtended($input: InputAreaExtended!) {
  fetchAreasExtended(input: $input) {
    ...AreaExtended
  }
}
    ${AreaExtendedFragmentDoc}`;
export function useFetchAreasExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAreasExtendedDocument, options);
}
export function useFetchAreasExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAreasExtendedDocument, options);
}
export function useFetchAreasExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAreasExtendedDocument, options);
}
export const FetchSavedAreaDocument = gql `
    query fetchSavedArea($id: String!) {
  fetchSavedArea(id: $id) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useFetchSavedAreaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedAreaDocument, options);
}
export function useFetchSavedAreaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedAreaDocument, options);
}
export function useFetchSavedAreaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedAreaDocument, options);
}
export const FetchSavedAreasDocument = gql `
    query fetchSavedAreas($input: InputSavedArea!) {
  fetchSavedAreas(input: $input) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useFetchSavedAreasQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedAreasDocument, options);
}
export function useFetchSavedAreasLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedAreasDocument, options);
}
export function useFetchSavedAreasSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedAreasDocument, options);
}
export const FetchSavedAreasByIdsDocument = gql `
    query fetchSavedAreasByIds($ids: [String!]!, $fkMapTemplateId: String) {
  fetchSavedAreasByIds(ids: $ids, fkMapTemplateId: $fkMapTemplateId) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useFetchSavedAreasByIdsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedAreasByIdsDocument, options);
}
export function useFetchSavedAreasByIdsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedAreasByIdsDocument, options);
}
export function useFetchSavedAreasByIdsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedAreasByIdsDocument, options);
}
export const FetchAllSavedAreasDocument = gql `
    query fetchAllSavedAreas($input: InputSavedAreaExtended!) {
  fetchAllSavedAreas(input: $input) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useFetchAllSavedAreasQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllSavedAreasDocument, options);
}
export function useFetchAllSavedAreasLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllSavedAreasDocument, options);
}
export function useFetchAllSavedAreasSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllSavedAreasDocument, options);
}
export const CreateSavedAreaDocument = gql `
    mutation createSavedArea($input: InputCreateSavedArea!) {
  createSavedArea(input: $input) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useCreateSavedAreaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateSavedAreaDocument, options);
}
export const UpdateSavedAreaDocument = gql `
    mutation updateSavedArea($input: InputUpdateSavedArea!) {
  updateSavedArea(input: $input) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useUpdateSavedAreaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateSavedAreaDocument, options);
}
export const DeleteSavedAreaDocument = gql `
    mutation deleteSavedArea($id: String!) {
  deleteSavedArea(id: $id) {
    ...SavedArea
  }
}
    ${SavedAreaFragmentDoc}`;
export function useDeleteSavedAreaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteSavedAreaDocument, options);
}
export const GetCloudStorageConnectionDocument = gql `
    query getCloudStorageConnection($input: InputCloudStorageConnection) {
  getCloudStorageConnection(input: $input) {
    id
    path
    size
    lastModifiedAt
  }
}
    `;
export function useGetCloudStorageConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetCloudStorageConnectionDocument, options);
}
export function useGetCloudStorageConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetCloudStorageConnectionDocument, options);
}
export function useGetCloudStorageConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCloudStorageConnectionDocument, options);
}
export const GoogleCallbackDocument = gql `
    mutation googleCallback($code: String!, $app: Applications!) {
  googleCallback(code: $code, app: $app) {
    accessToken
    refreshToken
  }
}
    `;
export function useGoogleCallbackMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GoogleCallbackDocument, options);
}
export const GoogleLoginDocument = gql `
    query googleLogin($input: InputGoogleLogin!) {
  googleLogin(input: $input)
}
    `;
export function useGoogleLoginQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GoogleLoginDocument, options);
}
export function useGoogleLoginLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GoogleLoginDocument, options);
}
export function useGoogleLoginSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GoogleLoginDocument, options);
}
export const FetchColumnDetailAndSchemaFromBigGeoAzureDocument = gql `
    query fetchColumnDetailAndSchemaFromBigGeoAzure($input: InputColumnDetailAndSchemaFromBigGeoAzure) {
  fetchColumnDetailAndSchemaFromBigGeoAzure(input: $input) {
    ...TableEntity
  }
}
    ${TableEntityFragmentDoc}`;
export function useFetchColumnDetailAndSchemaFromBigGeoAzureQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchColumnDetailAndSchemaFromBigGeoAzureDocument, options);
}
export function useFetchColumnDetailAndSchemaFromBigGeoAzureLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchColumnDetailAndSchemaFromBigGeoAzureDocument, options);
}
export function useFetchColumnDetailAndSchemaFromBigGeoAzureSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchColumnDetailAndSchemaFromBigGeoAzureDocument, options);
}
export const FetchDataSourceSchemaDocument = gql `
    query fetchDataSourceSchema($dataSourceId: String!) {
  fetchDataSourceSchema(dataSourceId: $dataSourceId) {
    ...TableEntity
  }
}
    ${TableEntityFragmentDoc}`;
export function useFetchDataSourceSchemaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceSchemaDocument, options);
}
export function useFetchDataSourceSchemaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceSchemaDocument, options);
}
export function useFetchDataSourceSchemaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceSchemaDocument, options);
}
export const GetGoogleDriveFilesDocument = gql `
    query getGoogleDriveFiles($accessToken: String!, $folderId: String) {
  getGoogleDriveFiles(accessToken: $accessToken, folderId: $folderId) {
    path
    size
    lastModifiedAt
  }
}
    `;
export function useGetGoogleDriveFilesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetGoogleDriveFilesDocument, options);
}
export function useGetGoogleDriveFilesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetGoogleDriveFilesDocument, options);
}
export function useGetGoogleDriveFilesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGoogleDriveFilesDocument, options);
}
export const GetGoogleDrivePublicFilesDocument = gql `
    query getGoogleDrivePublicFiles($fileUrl: String!) {
  getGoogleDrivePublicFiles(fileUrl: $fileUrl) {
    path
    size
    lastModifiedAt
  }
}
    `;
export function useGetGoogleDrivePublicFilesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetGoogleDrivePublicFilesDocument, options);
}
export function useGetGoogleDrivePublicFilesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetGoogleDrivePublicFilesDocument, options);
}
export function useGetGoogleDrivePublicFilesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGoogleDrivePublicFilesDocument, options);
}
export const DownloadGoogleDriveFileDocument = gql `
    query downloadGoogleDriveFile($fileUrl: String!, $accessToken: String) {
  downloadGoogleDriveFile(fileUrl: $fileUrl, accessToken: $accessToken)
}
    `;
export function useDownloadGoogleDriveFileQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(DownloadGoogleDriveFileDocument, options);
}
export function useDownloadGoogleDriveFileLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(DownloadGoogleDriveFileDocument, options);
}
export function useDownloadGoogleDriveFileSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DownloadGoogleDriveFileDocument, options);
}
export const FetchCustomerExtendedDocument = gql `
    query fetchCustomerExtended($id: String!) {
  fetchCustomerExtended(id: $id) {
    ...CustomerExtended
  }
}
    ${CustomerExtendedFragmentDoc}`;
export function useFetchCustomerExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCustomerExtendedDocument, options);
}
export function useFetchCustomerExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCustomerExtendedDocument, options);
}
export function useFetchCustomerExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCustomerExtendedDocument, options);
}
export const FetchCustomerByPkDocument = gql `
    query fetchCustomerByPk($id: String!) {
  fetchCustomerByPk(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export function useFetchCustomerByPkQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCustomerByPkDocument, options);
}
export function useFetchCustomerByPkLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCustomerByPkDocument, options);
}
export function useFetchCustomerByPkSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCustomerByPkDocument, options);
}
export const FetchCustomersDocument = gql `
    query fetchCustomers($input: InputFetchCustomers!) {
  fetchCustomers(input: $input) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export function useFetchCustomersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCustomersDocument, options);
}
export function useFetchCustomersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCustomersDocument, options);
}
export function useFetchCustomersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCustomersDocument, options);
}
export const FetchCustomersExtendedDocument = gql `
    query fetchCustomersExtended($input: InputFetchCustomers!) {
  fetchCustomersExtended(input: $input) {
    ...CustomerExtended
  }
}
    ${CustomerExtendedFragmentDoc}`;
export function useFetchCustomersExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCustomersExtendedDocument, options);
}
export function useFetchCustomersExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCustomersExtendedDocument, options);
}
export function useFetchCustomersExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCustomersExtendedDocument, options);
}
export const FetchDatasetInquiryExtendedDocument = gql `
    query fetchDatasetInquiryExtended($id: String!) {
  fetchDatasetInquiryExtended(id: $id) {
    ...DatasetInquiryExtended
  }
}
    ${DatasetInquiryExtendedFragmentDoc}`;
export function useFetchDatasetInquiryExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasetInquiryExtendedDocument, options);
}
export function useFetchDatasetInquiryExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasetInquiryExtendedDocument, options);
}
export function useFetchDatasetInquiryExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasetInquiryExtendedDocument, options);
}
export const FetchDatasetInquiriesExtendedDocument = gql `
    query fetchDatasetInquiriesExtended($input: InputDatasetInquiry!) {
  fetchDatasetInquiriesExtended(input: $input) {
    ...DatasetInquiryExtended
  }
}
    ${DatasetInquiryExtendedFragmentDoc}`;
export function useFetchDatasetInquiriesExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasetInquiriesExtendedDocument, options);
}
export function useFetchDatasetInquiriesExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasetInquiriesExtendedDocument, options);
}
export function useFetchDatasetInquiriesExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasetInquiriesExtendedDocument, options);
}
export const CheckIfCustomerExistsDocument = gql `
    query checkIfCustomerExists($email: String!) {
  checkIfCustomerExists(email: $email)
}
    `;
export function useCheckIfCustomerExistsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(CheckIfCustomerExistsDocument, options);
}
export function useCheckIfCustomerExistsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(CheckIfCustomerExistsDocument, options);
}
export function useCheckIfCustomerExistsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CheckIfCustomerExistsDocument, options);
}
export const CreateCustomerDocument = gql `
    mutation createCustomer($input: InputCreateCustomer!) {
  createCustomer(input: $input) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export function useCreateCustomerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateCustomerDocument, options);
}
export const UpdateCustomerDocument = gql `
    mutation updateCustomer($input: InputUpdateCustomer!) {
  updateCustomer(input: $input) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export function useUpdateCustomerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateCustomerDocument, options);
}
export const DeleteCustomerDocument = gql `
    mutation deleteCustomer($id: String!) {
  deleteCustomer(id: $id) {
    ...Customer
  }
}
    ${CustomerFragmentDoc}`;
export function useDeleteCustomerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteCustomerDocument, options);
}
export const CreateDatasetInquiryDocument = gql `
    mutation createDatasetInquiry($input: InputCreateDatasetInquiry!) {
  createDatasetInquiry(input: $input) {
    ...DatasetInquiry
  }
}
    ${DatasetInquiryFragmentDoc}`;
export function useCreateDatasetInquiryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDatasetInquiryDocument, options);
}
export const UpdateDatasetInquiryDocument = gql `
    mutation updateDatasetInquiry($input: InputUpdateDatasetInquiry!) {
  updateDatasetInquiry(input: $input) {
    ...DatasetInquiry
  }
}
    ${DatasetInquiryFragmentDoc}`;
export function useUpdateDatasetInquiryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDatasetInquiryDocument, options);
}
export const UpdateDatasetInquiriesDocument = gql `
    mutation updateDatasetInquiries($input: InputUpdateDatasetInquiries!) {
  updateDatasetInquiries(input: $input) {
    ...DatasetInquiry
  }
}
    ${DatasetInquiryFragmentDoc}`;
export function useUpdateDatasetInquiriesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDatasetInquiriesDocument, options);
}
export const SendDatasetInquiryDocument = gql `
    mutation sendDatasetInquiry($input: InputSendDatasetInquiry!) {
  sendDatasetInquiry(input: $input) {
    ...DatasetInquiry
  }
}
    ${DatasetInquiryFragmentDoc}`;
export function useSendDatasetInquiryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SendDatasetInquiryDocument, options);
}
export const FetchDataProductVariantConnectionsDocument = gql `
    query fetchDataProductVariantConnections($input: InputDataProductVariant!) {
  fetchDataProductVariantConnections(input: $input) {
    ...DataProductVariantsCountConnection
  }
}
    ${DataProductVariantsCountConnectionFragmentDoc}`;
export function useFetchDataProductVariantConnectionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataProductVariantConnectionsDocument, options);
}
export function useFetchDataProductVariantConnectionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataProductVariantConnectionsDocument, options);
}
export function useFetchDataProductVariantConnectionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataProductVariantConnectionsDocument, options);
}
export const FetchDataProductsTableDocument = gql `
    query fetchDataProductsTable($dataGridFetchInput: DataGridFetchInput) {
  fetchDataProductsTable(dataGridFetchInput: $dataGridFetchInput) {
    ...DataProductsTableCountConnection
  }
}
    ${DataProductsTableCountConnectionFragmentDoc}`;
export function useFetchDataProductsTableQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataProductsTableDocument, options);
}
export function useFetchDataProductsTableLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataProductsTableDocument, options);
}
export function useFetchDataProductsTableSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataProductsTableDocument, options);
}
export const FetchDataProductExtendedDocument = gql `
    query fetchDataProductExtended($input: InputFetchDataProduct!) {
  fetchDataProductExtended(input: $input) {
    ...DataProductExtended
  }
}
    ${DataProductExtendedFragmentDoc}`;
export function useFetchDataProductExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataProductExtendedDocument, options);
}
export function useFetchDataProductExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataProductExtendedDocument, options);
}
export function useFetchDataProductExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataProductExtendedDocument, options);
}
export const FetchDataProductsExtendedDocument = gql `
    query fetchDataProductsExtended {
  fetchDataProductsExtended {
    ...DataProductExtended
  }
}
    ${DataProductExtendedFragmentDoc}`;
export function useFetchDataProductsExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataProductsExtendedDocument, options);
}
export function useFetchDataProductsExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataProductsExtendedDocument, options);
}
export function useFetchDataProductsExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataProductsExtendedDocument, options);
}
export const CreateDataProductDocument = gql `
    mutation createDataProduct($fkDataSourceId: String!) {
  createDataProduct(fkDataSourceId: $fkDataSourceId) {
    ...DataProduct
  }
}
    ${DataProductFragmentDoc}`;
export function useCreateDataProductMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDataProductDocument, options);
}
export const FetchCustomerPurchasedDataSourcesDocument = gql `
    query fetchCustomerPurchasedDataSources($input: InputFetchCustomerPurchasedDataSources!) {
  fetchCustomerPurchasedDataSources(input: $input) {
    ...PurchasedDataSourcesConnection
  }
}
    ${PurchasedDataSourcesConnectionFragmentDoc}`;
export function useFetchCustomerPurchasedDataSourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCustomerPurchasedDataSourcesDocument, options);
}
export function useFetchCustomerPurchasedDataSourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCustomerPurchasedDataSourcesDocument, options);
}
export function useFetchCustomerPurchasedDataSourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCustomerPurchasedDataSourcesDocument, options);
}
export const FetchDataSourcePermissionsDocument = gql `
    query fetchDataSourcePermissions($input: InputDataSourcePermission!) {
  fetchDataSourcePermissions(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function useFetchDataSourcePermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePermissionsDocument, options);
}
export function useFetchDataSourcePermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePermissionsDocument, options);
}
export function useFetchDataSourcePermissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePermissionsDocument, options);
}
export const FetchActiveDataSourcePermissionDocument = gql `
    query fetchActiveDataSourcePermission($input: InputFetchActiveDataSourcePermission!) {
  fetchActiveDataSourcePermission(input: $input) {
    ...ActiveDataSourceExtended
  }
}
    ${ActiveDataSourceExtendedFragmentDoc}`;
export function useFetchActiveDataSourcePermissionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActiveDataSourcePermissionDocument, options);
}
export function useFetchActiveDataSourcePermissionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActiveDataSourcePermissionDocument, options);
}
export function useFetchActiveDataSourcePermissionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActiveDataSourcePermissionDocument, options);
}
export const FetchActivePurchasedDataSourcesDocument = gql `
    query fetchActivePurchasedDataSources($input: InputFetchActivePurchasedDataSources!) {
  fetchActivePurchasedDataSources(input: $input) {
    ...PurchasedDataSourcesConnection
  }
}
    ${PurchasedDataSourcesConnectionFragmentDoc}`;
export function useFetchActivePurchasedDataSourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActivePurchasedDataSourcesDocument, options);
}
export function useFetchActivePurchasedDataSourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActivePurchasedDataSourcesDocument, options);
}
export function useFetchActivePurchasedDataSourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActivePurchasedDataSourcesDocument, options);
}
export const FetchUsersActiveDataSourcesDocument = gql `
    query fetchUsersActiveDataSources($input: DataGridFetchInput!) {
  fetchUsersActiveDataSources(input: $input) {
    ...ActiveDataSourcesCountConnection
  }
}
    ${ActiveDataSourcesCountConnectionFragmentDoc}`;
export function useFetchUsersActiveDataSourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUsersActiveDataSourcesDocument, options);
}
export function useFetchUsersActiveDataSourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUsersActiveDataSourcesDocument, options);
}
export function useFetchUsersActiveDataSourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUsersActiveDataSourcesDocument, options);
}
export const FetchActivePurchasedDataSourceByListingIdDocument = gql `
    query fetchActivePurchasedDataSourceByListingId($input: InputFetchActivePurchasedDataSourceByListingId!) {
  fetchActivePurchasedDataSourceByListingId(input: $input) {
    ...PurchasedDataSourceExtended
  }
}
    ${PurchasedDataSourceExtendedFragmentDoc}`;
export function useFetchActivePurchasedDataSourceByListingIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActivePurchasedDataSourceByListingIdDocument, options);
}
export function useFetchActivePurchasedDataSourceByListingIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActivePurchasedDataSourceByListingIdDocument, options);
}
export function useFetchActivePurchasedDataSourceByListingIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActivePurchasedDataSourceByListingIdDocument, options);
}
export const FetchActivePurchasedDataSourceByIdDocument = gql `
    query fetchActivePurchasedDataSourceById($input: InputFetchActivePurchasedDataSourceById!) {
  fetchActivePurchasedDataSourceById(input: $input) {
    ...PurchasedDataSourceExtended
  }
}
    ${PurchasedDataSourceExtendedFragmentDoc}`;
export function useFetchActivePurchasedDataSourceByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActivePurchasedDataSourceByIdDocument, options);
}
export function useFetchActivePurchasedDataSourceByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActivePurchasedDataSourceByIdDocument, options);
}
export function useFetchActivePurchasedDataSourceByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActivePurchasedDataSourceByIdDocument, options);
}
export const FetchActiveDataSourcePermissionsDocument = gql `
    query fetchActiveDataSourcePermissions($input: InputFetchActiveDataSourcePermissions!) {
  fetchActiveDataSourcePermissions(input: $input) {
    ...ActiveDataSourceExtended
  }
}
    ${ActiveDataSourceExtendedFragmentDoc}`;
export function useFetchActiveDataSourcePermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActiveDataSourcePermissionsDocument, options);
}
export function useFetchActiveDataSourcePermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActiveDataSourcePermissionsDocument, options);
}
export function useFetchActiveDataSourcePermissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActiveDataSourcePermissionsDocument, options);
}
export const FetchActiveDataSourcePermissionsMarketplaceDocument = gql `
    query fetchActiveDataSourcePermissionsMarketplace {
  fetchActiveDataSourcePermissionsMarketplace {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function useFetchActiveDataSourcePermissionsMarketplaceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchActiveDataSourcePermissionsMarketplaceDocument, options);
}
export function useFetchActiveDataSourcePermissionsMarketplaceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchActiveDataSourcePermissionsMarketplaceDocument, options);
}
export function useFetchActiveDataSourcePermissionsMarketplaceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchActiveDataSourcePermissionsMarketplaceDocument, options);
}
export const FetchMarketplaceListingHasActivePermissionsDocument = gql `
    query fetchMarketplaceListingHasActivePermissions($fkMarketplaceDatasetId: String!) {
  fetchMarketplaceListingHasActivePermissions(
    fkMarketplaceDatasetId: $fkMarketplaceDatasetId
  )
}
    `;
export function useFetchMarketplaceListingHasActivePermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceListingHasActivePermissionsDocument, options);
}
export function useFetchMarketplaceListingHasActivePermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceListingHasActivePermissionsDocument, options);
}
export function useFetchMarketplaceListingHasActivePermissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceListingHasActivePermissionsDocument, options);
}
export const FetchDataSourceExternalActivePermissionsDocument = gql `
    query fetchDataSourceExternalActivePermissions($fkDataSourceId: String!) {
  fetchDataSourceExternalActivePermissions(fkDataSourceId: $fkDataSourceId) {
    ...DataSourcePermissionUserConnection
  }
}
    ${DataSourcePermissionUserConnectionFragmentDoc}`;
export function useFetchDataSourceExternalActivePermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceExternalActivePermissionsDocument, options);
}
export function useFetchDataSourceExternalActivePermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceExternalActivePermissionsDocument, options);
}
export function useFetchDataSourceExternalActivePermissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceExternalActivePermissionsDocument, options);
}
export const ResumePausedCustomerDataSourcePermissionDocument = gql `
    mutation resumePausedCustomerDataSourcePermission($input: InputResumePausedCustomerDataSourcePermission!) {
  resumePausedCustomerDataSourcePermission(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function useResumePausedCustomerDataSourcePermissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ResumePausedCustomerDataSourcePermissionDocument, options);
}
export const PurchaseDataSourceDocument = gql `
    mutation purchaseDataSource($input: InputPurchaseDataSource!) {
  purchaseDataSource(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function usePurchaseDataSourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseDataSourceDocument, options);
}
export const PurchaseVariantBoundariesDocument = gql `
    mutation purchaseVariantBoundaries($input: InputPurchaseVariantBoundaries!) {
  purchaseVariantBoundaries(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function usePurchaseVariantBoundariesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseVariantBoundariesDocument, options);
}
export const PurchaseInstantOfferDocument = gql `
    mutation purchaseInstantOffer($input: InputPurchaseInstantOffer!) {
  purchaseInstantOffer(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function usePurchaseInstantOfferMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseInstantOfferDocument, options);
}
export const CancelPurchasedDataSourceDocument = gql `
    mutation cancelPurchasedDataSource($input: InputCancelPurchasedDataSource!) {
  cancelPurchasedDataSource(input: $input)
}
    `;
export function useCancelPurchasedDataSourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CancelPurchasedDataSourceDocument, options);
}
export const ResumeCancelledPurchasedDataSourceDocument = gql `
    mutation resumeCancelledPurchasedDataSource($input: InputCancelPurchasedDataSource!) {
  resumeCancelledPurchasedDataSource(input: $input)
}
    `;
export function useResumeCancelledPurchasedDataSourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ResumeCancelledPurchasedDataSourceDocument, options);
}
export const RevokeCustomerDataSourcePermissionDocument = gql `
    mutation revokeCustomerDataSourcePermission($input: InputRevokeCustomerDataSourcePermission!) {
  revokeCustomerDataSourcePermission(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function useRevokeCustomerDataSourcePermissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(RevokeCustomerDataSourcePermissionDocument, options);
}
export const FetchDataSourcePriceExtendedDocument = gql `
    query fetchDataSourcePriceExtended($input: InputFetchDataSourcePrice!) {
  fetchDataSourcePriceExtended(input: $input) {
    ...DataSourcePriceExtended
  }
}
    ${DataSourcePriceExtendedFragmentDoc}`;
export function useFetchDataSourcePriceExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePriceExtendedDocument, options);
}
export function useFetchDataSourcePriceExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePriceExtendedDocument, options);
}
export function useFetchDataSourcePriceExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePriceExtendedDocument, options);
}
export const FetchDataSourcePricesExtendedDocument = gql `
    query fetchDataSourcePricesExtended($dataGridFetchInput: DataGridFetchInput!) {
  fetchDataSourcePricesExtended(dataGridFetchInput: $dataGridFetchInput) {
    ...DataSourcePriceExtendedCountConnection
  }
}
    ${DataSourcePriceExtendedCountConnectionFragmentDoc}`;
export function useFetchDataSourcePricesExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePricesExtendedDocument, options);
}
export function useFetchDataSourcePricesExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePricesExtendedDocument, options);
}
export function useFetchDataSourcePricesExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePricesExtendedDocument, options);
}
export const FetchDataSourcePricesDocument = gql `
    query fetchDataSourcePrices($input: InputFetchDataSourcePrices!) {
  fetchDataSourcePrices(input: $input) {
    ...DataSourcePriceCountConnection
  }
}
    ${DataSourcePriceCountConnectionFragmentDoc}`;
export function useFetchDataSourcePricesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePricesDocument, options);
}
export function useFetchDataSourcePricesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePricesDocument, options);
}
export function useFetchDataSourcePricesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePricesDocument, options);
}
export const FetchOrgDataSourcePricesForInstantOfferDocument = gql `
    query fetchOrgDataSourcePricesForInstantOffer($input: DataGridFetchInput) {
  fetchOrgDataSourcePricesForInstantOffer(input: $input) {
    ...DataSourcePriceWithDataSourceCountConnection
  }
}
    ${DataSourcePriceWithDataSourceCountConnectionFragmentDoc}`;
export function useFetchOrgDataSourcePricesForInstantOfferQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrgDataSourcePricesForInstantOfferDocument, options);
}
export function useFetchOrgDataSourcePricesForInstantOfferLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrgDataSourcePricesForInstantOfferDocument, options);
}
export function useFetchOrgDataSourcePricesForInstantOfferSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrgDataSourcePricesForInstantOfferDocument, options);
}
export const FetchDataSourcePriceDocument = gql `
    query fetchDataSourcePrice($input: InputFetchDataSourcePrice!) {
  fetchDataSourcePrice(input: $input) {
    ...DataSourcePriceActiveSubscriptionConnection
  }
}
    ${DataSourcePriceActiveSubscriptionConnectionFragmentDoc}`;
export function useFetchDataSourcePriceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePriceDocument, options);
}
export function useFetchDataSourcePriceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePriceDocument, options);
}
export function useFetchDataSourcePriceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePriceDocument, options);
}
export const FetchHasDataSourcePricesDocument = gql `
    query fetchHasDataSourcePrices($fkOrganizationId: String!) {
  fetchHasDataSourcePrices(fkOrganizationId: $fkOrganizationId)
}
    `;
export function useFetchHasDataSourcePricesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchHasDataSourcePricesDocument, options);
}
export function useFetchHasDataSourcePricesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchHasDataSourcePricesDocument, options);
}
export function useFetchHasDataSourcePricesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchHasDataSourcePricesDocument, options);
}
export const FetchDataSourcePricePublishedConnectionsDocument = gql `
    query fetchDataSourcePricePublishedConnections($input: InputFetchDataSourcePricePublishedConnections!) {
  fetchDataSourcePricePublishedConnections(input: $input) {
    ...DataSourcePricePublishedCountConnection
  }
}
    ${DataSourcePricePublishedCountConnectionFragmentDoc}`;
export function useFetchDataSourcePricePublishedConnectionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePricePublishedConnectionsDocument, options);
}
export function useFetchDataSourcePricePublishedConnectionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePricePublishedConnectionsDocument, options);
}
export function useFetchDataSourcePricePublishedConnectionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePricePublishedConnectionsDocument, options);
}
export const FetchMarketplaceDatasetLowestPriceFrequencyDocument = gql `
    query fetchMarketplaceDatasetLowestPriceFrequency($fkMarketplaceDatasetId: String!) {
  fetchMarketplaceDatasetLowestPriceFrequency(
    fkMarketplaceDatasetId: $fkMarketplaceDatasetId
  ) {
    ...DataSourcePricePriceFrequencyConnection
  }
}
    ${DataSourcePricePriceFrequencyConnectionFragmentDoc}`;
export function useFetchMarketplaceDatasetLowestPriceFrequencyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetLowestPriceFrequencyDocument, options);
}
export function useFetchMarketplaceDatasetLowestPriceFrequencyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetLowestPriceFrequencyDocument, options);
}
export function useFetchMarketplaceDatasetLowestPriceFrequencySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetLowestPriceFrequencyDocument, options);
}
export const FetchPublishedDataSourcePricesDocument = gql `
    query fetchPublishedDataSourcePrices($fkMarketplaceDatasetId: String!) {
  fetchPublishedDataSourcePrices(fkMarketplaceDatasetId: $fkMarketplaceDatasetId) {
    ...DataSourcePrice
  }
}
    ${DataSourcePriceFragmentDoc}`;
export function useFetchPublishedDataSourcePricesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchPublishedDataSourcePricesDocument, options);
}
export function useFetchPublishedDataSourcePricesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchPublishedDataSourcePricesDocument, options);
}
export function useFetchPublishedDataSourcePricesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchPublishedDataSourcePricesDocument, options);
}
export const FetchPublishedDataSourcePriceDocument = gql `
    query fetchPublishedDataSourcePrice($input: InputFetchPublishedDataSourcePrice!) {
  fetchPublishedDataSourcePrice(input: $input) {
    ...DataSourcePrice
  }
}
    ${DataSourcePriceFragmentDoc}`;
export function useFetchPublishedDataSourcePriceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchPublishedDataSourcePriceDocument, options);
}
export function useFetchPublishedDataSourcePriceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchPublishedDataSourcePriceDocument, options);
}
export function useFetchPublishedDataSourcePriceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchPublishedDataSourcePriceDocument, options);
}
export const FetchHasPriceRequiringResourcesDocument = gql `
    query fetchHasPriceRequiringResources($fkDataSourceId: String!) {
  fetchHasPriceRequiringResources(fkDataSourceId: $fkDataSourceId)
}
    `;
export function useFetchHasPriceRequiringResourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchHasPriceRequiringResourcesDocument, options);
}
export function useFetchHasPriceRequiringResourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchHasPriceRequiringResourcesDocument, options);
}
export function useFetchHasPriceRequiringResourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchHasPriceRequiringResourcesDocument, options);
}
export const FetchNumberPublishedDataSourcePricesDocument = gql `
    query fetchNumberPublishedDataSourcePrices($fkMarketplaceDatasetId: String!) {
  fetchNumberPublishedDataSourcePrices(
    fkMarketplaceDatasetId: $fkMarketplaceDatasetId
  )
}
    `;
export function useFetchNumberPublishedDataSourcePricesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchNumberPublishedDataSourcePricesDocument, options);
}
export function useFetchNumberPublishedDataSourcePricesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchNumberPublishedDataSourcePricesDocument, options);
}
export function useFetchNumberPublishedDataSourcePricesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchNumberPublishedDataSourcePricesDocument, options);
}
export const CreateEditDataSourcePriceDocument = gql `
    mutation createEditDataSourcePrice($input: InputCreateEditDataSourcePrice!) {
  createEditDataSourcePrice(input: $input) {
    ...DataSourcePrice
  }
}
    ${DataSourcePriceFragmentDoc}`;
export function useCreateEditDataSourcePriceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateEditDataSourcePriceDocument, options);
}
export const PublishDataSourcePricesDocument = gql `
    mutation publishDataSourcePrices($input: InputPublishDataSourcePrices!) {
  publishDataSourcePrices(input: $input)
}
    `;
export function usePublishDataSourcePricesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PublishDataSourcePricesDocument, options);
}
export const UnpublishDataSourcePricesDocument = gql `
    mutation unpublishDataSourcePrices($input: InputPublishDataSourcePrices!) {
  unpublishDataSourcePrices(input: $input)
}
    `;
export function useUnpublishDataSourcePricesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UnpublishDataSourcePricesDocument, options);
}
export const PublishAllDataSourcePricesDocument = gql `
    mutation publishAllDataSourcePrices($input: InputPublishAllDataSourcePrices!) {
  publishAllDataSourcePrices(input: $input)
}
    `;
export function usePublishAllDataSourcePricesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PublishAllDataSourcePricesDocument, options);
}
export const CreateBillingPortalSessionDocument = gql `
    mutation createBillingPortalSession($input: InputCreateBillingPortalSession!) {
  createBillingPortalSession(input: $input) {
    url
  }
}
    `;
export function useCreateBillingPortalSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateBillingPortalSessionDocument, options);
}
export const FetchOrganizationDatalabFeatureAccessDocument = gql `
    query fetchOrganizationDatalabFeatureAccess {
  fetchOrganizationDatalabFeatureAccess {
    ...DatalabFeatureAccessResult
  }
}
    ${DatalabFeatureAccessResultFragmentDoc}`;
export function useFetchOrganizationDatalabFeatureAccessQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationDatalabFeatureAccessDocument, options);
}
export function useFetchOrganizationDatalabFeatureAccessLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationDatalabFeatureAccessDocument, options);
}
export function useFetchOrganizationDatalabFeatureAccessSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationDatalabFeatureAccessDocument, options);
}
export const FetchOrganizationDatalabFeatureAccessAdminDocument = gql `
    query fetchOrganizationDatalabFeatureAccessAdmin($organizationId: String!) {
  fetchOrganizationDatalabFeatureAccessAdmin(organizationId: $organizationId) {
    ...DatalabFeatureAccessResult
  }
}
    ${DatalabFeatureAccessResultFragmentDoc}`;
export function useFetchOrganizationDatalabFeatureAccessAdminQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationDatalabFeatureAccessAdminDocument, options);
}
export function useFetchOrganizationDatalabFeatureAccessAdminLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationDatalabFeatureAccessAdminDocument, options);
}
export function useFetchOrganizationDatalabFeatureAccessAdminSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationDatalabFeatureAccessAdminDocument, options);
}
export const FetchDatalabFeatureAccessCountDocument = gql `
    query fetchDatalabFeatureAccessCount($feature: DatalabFeature!) {
  fetchDatalabFeatureAccessCount(feature: $feature) {
    ...DatalabFeatureAccessCount
  }
}
    ${DatalabFeatureAccessCountFragmentDoc}`;
export function useFetchDatalabFeatureAccessCountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatalabFeatureAccessCountDocument, options);
}
export function useFetchDatalabFeatureAccessCountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatalabFeatureAccessCountDocument, options);
}
export function useFetchDatalabFeatureAccessCountSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatalabFeatureAccessCountDocument, options);
}
export const FetchOrganizationsDatalabProcessMeterDocument = gql `
    query fetchOrganizationsDatalabProcessMeter($organizationId: String) {
  fetchOrganizationsDatalabProcessMeter(organizationId: $organizationId) {
    ...DatalabProcessMeter
  }
}
    ${DatalabProcessMeterFragmentDoc}`;
export function useFetchOrganizationsDatalabProcessMeterQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsDatalabProcessMeterDocument, options);
}
export function useFetchOrganizationsDatalabProcessMeterLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsDatalabProcessMeterDocument, options);
}
export function useFetchOrganizationsDatalabProcessMeterSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsDatalabProcessMeterDocument, options);
}
export const UpdateOrganizationDatalabFeatureAccessDocument = gql `
    mutation updateOrganizationDatalabFeatureAccess($organizationId: String!, $featureAccess: DatalabFeatureAccessCheck!) {
  updateOrganizationDatalabFeatureAccess(
    organizationId: $organizationId
    featureAccess: $featureAccess
  ) {
    ...DatalabFeatureAccess
  }
}
    ${DatalabFeatureAccessFragmentDoc}`;
export function useUpdateOrganizationDatalabFeatureAccessMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateOrganizationDatalabFeatureAccessDocument, options);
}
export const FetchOrganizationFreeComputeUnitsRemainingDocument = gql `
    query fetchOrganizationFreeComputeUnitsRemaining {
  fetchOrganizationFreeComputeUnitsRemaining {
    units
    unitsRemaining
  }
}
    `;
export function useFetchOrganizationFreeComputeUnitsRemainingQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationFreeComputeUnitsRemainingDocument, options);
}
export function useFetchOrganizationFreeComputeUnitsRemainingLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationFreeComputeUnitsRemainingDocument, options);
}
export function useFetchOrganizationFreeComputeUnitsRemainingSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationFreeComputeUnitsRemainingDocument, options);
}
export const FetchUsersPaymentMethodByOrganizationDocument = gql `
    query fetchUsersPaymentMethodByOrganization($organizationId: String!) {
  fetchUsersPaymentMethodByOrganization(organizationId: $organizationId) {
    cards {
      ...StripePaymentMethodCard
    }
    links {
      ...StripePaymentMethodLink
    }
  }
}
    ${StripePaymentMethodCardFragmentDoc}
${StripePaymentMethodLinkFragmentDoc}`;
export function useFetchUsersPaymentMethodByOrganizationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUsersPaymentMethodByOrganizationDocument, options);
}
export function useFetchUsersPaymentMethodByOrganizationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUsersPaymentMethodByOrganizationDocument, options);
}
export function useFetchUsersPaymentMethodByOrganizationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUsersPaymentMethodByOrganizationDocument, options);
}
export const AttachStripePaymentMethodToSellerAccountCustomerDocument = gql `
    mutation attachStripePaymentMethodToSellerAccountCustomer($paymentMethodId: String!, $organizationId: String!) {
  attachStripePaymentMethodToSellerAccountCustomer(
    paymentMethodId: $paymentMethodId
    organizationId: $organizationId
  ) {
    ...StripePaymentMethodUnion
  }
}
    ${StripePaymentMethodUnionFragmentDoc}`;
export function useAttachStripePaymentMethodToSellerAccountCustomerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(AttachStripePaymentMethodToSellerAccountCustomerDocument, options);
}
export const FetchOrganizationsDatalabSellerAccountsDocument = gql `
    query fetchOrganizationsDatalabSellerAccounts {
  fetchOrganizationsDatalabSellerAccounts {
    datalabSellerAccount {
      ...DatalabSellerAccount
    }
    sellerAccountStatus
  }
}
    ${DatalabSellerAccountFragmentDoc}`;
export function useFetchOrganizationsDatalabSellerAccountsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsDatalabSellerAccountsDocument, options);
}
export function useFetchOrganizationsDatalabSellerAccountsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsDatalabSellerAccountsDocument, options);
}
export function useFetchOrganizationsDatalabSellerAccountsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsDatalabSellerAccountsDocument, options);
}
export const CreateOrganizationDatalabStripeSellerAccountSessionDocument = gql `
    mutation createOrganizationDatalabStripeSellerAccountSession {
  createOrganizationDatalabStripeSellerAccountSession {
    clientSecret
  }
}
    `;
export function useCreateOrganizationDatalabStripeSellerAccountSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateOrganizationDatalabStripeSellerAccountSessionDocument, options);
}
export const CreateOrganizationDatalabSellerAccountDocument = gql `
    mutation createOrganizationDatalabSellerAccount {
  createOrganizationDatalabSellerAccount {
    ...DatalabSellerAccount
  }
}
    ${DatalabSellerAccountFragmentDoc}`;
export function useCreateOrganizationDatalabSellerAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateOrganizationDatalabSellerAccountDocument, options);
}
export const DatalabSellerAccountStripeConnectCreateAccountLoginLinkDocument = gql `
    mutation datalabSellerAccountStripeConnectCreateAccountLoginLink {
  datalabSellerAccountStripeConnectCreateAccountLoginLink
}
    `;
export function useDatalabSellerAccountStripeConnectCreateAccountLoginLinkMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DatalabSellerAccountStripeConnectCreateAccountLoginLinkDocument, options);
}
export const FetchPublicDatalabSellerAccountDocument = gql `
    query fetchPublicDatalabSellerAccount($organizationId: String!) {
  fetchPublicDatalabSellerAccount(organizationId: $organizationId) {
    datalabSellerAccount {
      ...DatalabSellerAccount
    }
  }
}
    ${DatalabSellerAccountFragmentDoc}`;
export function useFetchPublicDatalabSellerAccountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchPublicDatalabSellerAccountDocument, options);
}
export function useFetchPublicDatalabSellerAccountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchPublicDatalabSellerAccountDocument, options);
}
export function useFetchPublicDatalabSellerAccountSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchPublicDatalabSellerAccountDocument, options);
}
export const FetchOrganizationsDatalabSubscriptionDocument = gql `
    query fetchOrganizationsDatalabSubscription {
  fetchOrganizationsDatalabSubscription {
    ...DatalabSubscriptionConnection
  }
}
    ${DatalabSubscriptionConnectionFragmentDoc}`;
export function useFetchOrganizationsDatalabSubscriptionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsDatalabSubscriptionDocument, options);
}
export function useFetchOrganizationsDatalabSubscriptionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsDatalabSubscriptionDocument, options);
}
export function useFetchOrganizationsDatalabSubscriptionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsDatalabSubscriptionDocument, options);
}
export const ChangeDatalabTierDocument = gql `
    mutation changeDatalabTier($tier: DatalabPaywallTier!, $subscriptionFrequency: SubscriptionFrequency!) {
  changeDatalabTier(tier: $tier, subscriptionFrequency: $subscriptionFrequency) {
    checkoutUrl
    subscription {
      ...DatalabSubscriptionConnection
    }
  }
}
    ${DatalabSubscriptionConnectionFragmentDoc}`;
export function useChangeDatalabTierMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ChangeDatalabTierDocument, options);
}
export const ChangeDatalabSubscriptionStripePaymentMethodDocument = gql `
    mutation changeDatalabSubscriptionStripePaymentMethod($paymentMethodId: String!) {
  changeDatalabSubscriptionStripePaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export function useChangeDatalabSubscriptionStripePaymentMethodMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ChangeDatalabSubscriptionStripePaymentMethodDocument, options);
}
export const AttachDatalabSubscriptionStripePaymentMethodDocument = gql `
    mutation attachDatalabSubscriptionStripePaymentMethod($paymentMethodId: String!) {
  attachDatalabSubscriptionStripePaymentMethod(paymentMethodId: $paymentMethodId) {
    paymentMethodId
    card {
      ...StripePaymentMethodCard
    }
    link {
      ...StripePaymentMethodLink
    }
  }
}
    ${StripePaymentMethodCardFragmentDoc}
${StripePaymentMethodLinkFragmentDoc}`;
export function useAttachDatalabSubscriptionStripePaymentMethodMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(AttachDatalabSubscriptionStripePaymentMethodDocument, options);
}
export const PurchaseDatalabStorageDocument = gql `
    mutation purchaseDatalabStorage($quantity: Int!, $subscriptionFrequency: SubscriptionFrequency!) {
  purchaseDatalabStorage(
    quantity: $quantity
    subscriptionFrequency: $subscriptionFrequency
  ) {
    checkoutUrl
    subscription {
      ...DatalabSubscriptionConnection
    }
  }
}
    ${DatalabSubscriptionConnectionFragmentDoc}`;
export function usePurchaseDatalabStorageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseDatalabStorageDocument, options);
}
export const PurchaseDatalabComputeDocument = gql `
    mutation purchaseDatalabCompute($quantity: Int!, $subscriptionFrequency: SubscriptionFrequency!) {
  purchaseDatalabCompute(
    quantity: $quantity
    subscriptionFrequency: $subscriptionFrequency
  ) {
    checkoutUrl
    subscription {
      ...DatalabSubscriptionConnection
    }
  }
}
    ${DatalabSubscriptionConnectionFragmentDoc}`;
export function usePurchaseDatalabComputeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseDatalabComputeDocument, options);
}
export const FetchAllDatalabTierDetailsDocument = gql `
    query fetchAllDatalabTierDetails {
  fetchAllDatalabTierDetails {
    ...DatalabTierDetails
  }
}
    ${DatalabTierDetailsFragmentDoc}`;
export function useFetchAllDatalabTierDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllDatalabTierDetailsDocument, options);
}
export function useFetchAllDatalabTierDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllDatalabTierDetailsDocument, options);
}
export function useFetchAllDatalabTierDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllDatalabTierDetailsDocument, options);
}
export const FetchLiveDatalabTierDetailsDocument = gql `
    query fetchLiveDatalabTierDetails {
  fetchLiveDatalabTierDetails {
    ...DatalabTierDetails
  }
}
    ${DatalabTierDetailsFragmentDoc}`;
export function useFetchLiveDatalabTierDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchLiveDatalabTierDetailsDocument, options);
}
export function useFetchLiveDatalabTierDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchLiveDatalabTierDetailsDocument, options);
}
export function useFetchLiveDatalabTierDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchLiveDatalabTierDetailsDocument, options);
}
export const FetchOneDatalabTierDetailsDocument = gql `
    query fetchOneDatalabTierDetails($tier: DatalabPaywallTier!) {
  fetchOneDatalabTierDetails(tier: $tier) {
    tier
    details {
      ...DatalabTierDetails
    }
  }
}
    ${DatalabTierDetailsFragmentDoc}`;
export function useFetchOneDatalabTierDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneDatalabTierDetailsDocument, options);
}
export function useFetchOneDatalabTierDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneDatalabTierDetailsDocument, options);
}
export function useFetchOneDatalabTierDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneDatalabTierDetailsDocument, options);
}
export const EditDatalabTierDetailsDocument = gql `
    mutation editDatalabTierDetails($input: DatalabTierDetailsInput!) {
  editDatalabTierDetails(input: $input) {
    ...DatalabTierDetails
  }
}
    ${DatalabTierDetailsFragmentDoc}`;
export function useEditDatalabTierDetailsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditDatalabTierDetailsDocument, options);
}
export const FetchSubCategoriesWithListingsDocument = gql `
    query fetchSubCategoriesWithListings {
  fetchSubCategoriesWithListings {
    ...SubCategoriesWithListings
  }
}
    ${SubCategoriesWithListingsFragmentDoc}`;
export function useFetchSubCategoriesWithListingsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSubCategoriesWithListingsDocument, options);
}
export function useFetchSubCategoriesWithListingsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSubCategoriesWithListingsDocument, options);
}
export function useFetchSubCategoriesWithListingsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSubCategoriesWithListingsDocument, options);
}
export const FetchMarketplaceSearchOptionsDocument = gql `
    query fetchMarketplaceSearchOptions($input: InputMarketplaceSearchOptions!) {
  fetchMarketplaceSearchOptions(input: $input) {
    ...MarketplaceSearchOption
  }
}
    ${MarketplaceSearchOptionFragmentDoc}`;
export function useFetchMarketplaceSearchOptionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceSearchOptionsDocument, options);
}
export function useFetchMarketplaceSearchOptionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceSearchOptionsDocument, options);
}
export function useFetchMarketplaceSearchOptionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceSearchOptionsDocument, options);
}
export const FetchCategoriesWithListingsDocument = gql `
    query fetchCategoriesWithListings {
  fetchCategoriesWithListings
}
    `;
export function useFetchCategoriesWithListingsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchCategoriesWithListingsDocument, options);
}
export function useFetchCategoriesWithListingsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchCategoriesWithListingsDocument, options);
}
export function useFetchCategoriesWithListingsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchCategoriesWithListingsDocument, options);
}
export const FetchListingCategoryCountDetailsDocument = gql `
    query fetchListingCategoryCountDetails($input: InputListingCategoryCountDetails!) {
  fetchListingCategoryCountDetails(input: $input) {
    ...ListingCategoryCountDetails
  }
}
    ${ListingCategoryCountDetailsFragmentDoc}`;
export function useFetchListingCategoryCountDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchListingCategoryCountDetailsDocument, options);
}
export function useFetchListingCategoryCountDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchListingCategoryCountDetailsDocument, options);
}
export function useFetchListingCategoryCountDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchListingCategoryCountDetailsDocument, options);
}
export const FetchPopularCategoriesDocument = gql `
    query fetchPopularCategories($limit: Int) {
  fetchPopularCategories(limit: $limit)
}
    `;
export function useFetchPopularCategoriesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchPopularCategoriesDocument, options);
}
export function useFetchPopularCategoriesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchPopularCategoriesDocument, options);
}
export function useFetchPopularCategoriesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchPopularCategoriesDocument, options);
}
export const FetchListingCategoriesDetailsDocument = gql `
    query fetchListingCategoriesDetails($input: InputListingCategoriesDetails!) {
  fetchListingCategoriesDetails(input: $input) {
    ...ListingCategoryDetails
  }
}
    ${ListingCategoryDetailsFragmentDoc}`;
export function useFetchListingCategoriesDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchListingCategoriesDetailsDocument, options);
}
export function useFetchListingCategoriesDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchListingCategoriesDetailsDocument, options);
}
export function useFetchListingCategoriesDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchListingCategoriesDetailsDocument, options);
}
export const FetchSlimDataSourceDocument = gql `
    query fetchSlimDataSource($dataSourceId: String!) {
  fetchSlimDataSource(dataSourceId: $dataSourceId) {
    ...SlimDataSource
  }
}
    ${SlimDataSourceFragmentDoc}`;
export function useFetchSlimDataSourceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSlimDataSourceDocument, options);
}
export function useFetchSlimDataSourceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSlimDataSourceDocument, options);
}
export function useFetchSlimDataSourceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSlimDataSourceDocument, options);
}
export const FetchAllVelocityStatusesDocument = gql `
    query fetchAllVelocityStatuses {
  fetchAllVelocityStatuses {
    ...VelocityStatus
  }
}
    ${VelocityStatusFragmentDoc}`;
export function useFetchAllVelocityStatusesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllVelocityStatusesDocument, options);
}
export function useFetchAllVelocityStatusesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllVelocityStatusesDocument, options);
}
export function useFetchAllVelocityStatusesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllVelocityStatusesDocument, options);
}
export const GetMapPreviewDetailsDocument = gql `
    query getMapPreviewDetails($input: InputMarketplaceMapPreviewDetails!) {
  getMapPreviewDetails(input: $input) {
    ...MarketplaceMapPreviewDetails
  }
}
    ${MarketplaceMapPreviewDetailsFragmentDoc}`;
export function useGetMapPreviewDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetMapPreviewDetailsDocument, options);
}
export function useGetMapPreviewDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetMapPreviewDetailsDocument, options);
}
export function useGetMapPreviewDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetMapPreviewDetailsDocument, options);
}
export const FetchDataSourcesWithConfigAndEtlExtendedFromServerUrlDocument = gql `
    query fetchDataSourcesWithConfigAndEtlExtendedFromServerUrl($serverUrl: String!) {
  fetchDataSourcesWithConfigAndEtlExtendedFromServerUrl(serverUrl: $serverUrl) {
    ...DataSourceWithConfigAndEtlExtended
  }
}
    ${DataSourceWithConfigAndEtlExtendedFragmentDoc}`;
export function useFetchDataSourcesWithConfigAndEtlExtendedFromServerUrlQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcesWithConfigAndEtlExtendedFromServerUrlDocument, options);
}
export function useFetchDataSourcesWithConfigAndEtlExtendedFromServerUrlLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcesWithConfigAndEtlExtendedFromServerUrlDocument, options);
}
export function useFetchDataSourcesWithConfigAndEtlExtendedFromServerUrlSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcesWithConfigAndEtlExtendedFromServerUrlDocument, options);
}
export const FetchDatasourceStudioByIdDocument = gql `
    query fetchDatasourceStudioById($id: String!) {
  fetchDatasourceStudioById(id: $id) {
    dataSource {
      ...DataSourceStudio
    }
    configuration {
      ...DataSourceConfiguration
    }
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export function useFetchDatasourceStudioByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasourceStudioByIdDocument, options);
}
export function useFetchDatasourceStudioByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasourceStudioByIdDocument, options);
}
export function useFetchDatasourceStudioByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasourceStudioByIdDocument, options);
}
export const FetchDataSourceConfigUnauthedDocument = gql `
    query fetchDataSourceConfigUnauthed($dataSourceId: String!, $organizationId: String!) {
  fetchDataSourceConfigUnauthed(
    dataSourceId: $dataSourceId
    organizationId: $organizationId
  ) {
    ...DataSourceConfiguration
  }
}
    ${DataSourceConfigurationFragmentDoc}`;
export function useFetchDataSourceConfigUnauthedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceConfigUnauthedDocument, options);
}
export function useFetchDataSourceConfigUnauthedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceConfigUnauthedDocument, options);
}
export function useFetchDataSourceConfigUnauthedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceConfigUnauthedDocument, options);
}
export const FetchDataSourceConfigDocument = gql `
    query fetchDataSourceConfig($dataSourceId: String!, $organizationId: String!) {
  fetchDataSourceConfig(
    dataSourceId: $dataSourceId
    organizationId: $organizationId
  ) {
    ...DataSourceConfiguration
  }
}
    ${DataSourceConfigurationFragmentDoc}`;
export function useFetchDataSourceConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceConfigDocument, options);
}
export function useFetchDataSourceConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceConfigDocument, options);
}
export function useFetchDataSourceConfigSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceConfigDocument, options);
}
export const FetchDataSourceWithEtlDetailsDocument = gql `
    query fetchDataSourceWithEtlDetails($id: String!) {
  fetchDataSourceWithEtlDetails(id: $id) {
    ...DataSourceWithEtlDetails
  }
}
    ${DataSourceWithEtlDetailsFragmentDoc}`;
export function useFetchDataSourceWithEtlDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceWithEtlDetailsDocument, options);
}
export function useFetchDataSourceWithEtlDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceWithEtlDetailsDocument, options);
}
export function useFetchDataSourceWithEtlDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceWithEtlDetailsDocument, options);
}
export const FetchMarketplaceDatasetWithOrganizationDocument = gql `
    query fetchMarketplaceDatasetWithOrganization($datasetId: String!) {
  fetchMarketplaceDatasetWithOrganization(datasetId: $datasetId) {
    ...MarketplaceDatasetWithOrganization
  }
}
    ${MarketplaceDatasetWithOrganizationFragmentDoc}`;
export function useFetchMarketplaceDatasetWithOrganizationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetWithOrganizationDocument, options);
}
export function useFetchMarketplaceDatasetWithOrganizationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetWithOrganizationDocument, options);
}
export function useFetchMarketplaceDatasetWithOrganizationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetWithOrganizationDocument, options);
}
export const FetchMarketplaceDatasetBySlugWithOrganizationDocument = gql `
    query fetchMarketplaceDatasetBySlugWithOrganization($slug: String!) {
  fetchMarketplaceDatasetBySlugWithOrganization(slug: $slug) {
    ...MarketplaceDatasetWithOrganization
  }
}
    ${MarketplaceDatasetWithOrganizationFragmentDoc}`;
export function useFetchMarketplaceDatasetBySlugWithOrganizationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetBySlugWithOrganizationDocument, options);
}
export function useFetchMarketplaceDatasetBySlugWithOrganizationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetBySlugWithOrganizationDocument, options);
}
export function useFetchMarketplaceDatasetBySlugWithOrganizationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetBySlugWithOrganizationDocument, options);
}
export const FetchDataSourcesWithConfigAndEtlExtendedDocument = gql `
    query fetchDataSourcesWithConfigAndEtlExtended($input: InputFetchDatasourcesWithConfigAndEtl!) {
  fetchDataSourcesWithConfigAndEtlExtended(input: $input) {
    ...DataSourceWithConfigAndEtlConnection
  }
}
    ${DataSourceWithConfigAndEtlConnectionFragmentDoc}`;
export function useFetchDataSourcesWithConfigAndEtlExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcesWithConfigAndEtlExtendedDocument, options);
}
export function useFetchDataSourcesWithConfigAndEtlExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcesWithConfigAndEtlExtendedDocument, options);
}
export function useFetchDataSourcesWithConfigAndEtlExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcesWithConfigAndEtlExtendedDocument, options);
}
export const FetchOneDataSourceWithConfigAndEtlExtendedDocument = gql `
    query fetchOneDataSourceWithConfigAndEtlExtended($datasetId: String!) {
  fetchOneDataSourceWithConfigAndEtlExtended(datasetId: $datasetId) {
    ...DataSourceWithConfigAndEtlExtended
  }
}
    ${DataSourceWithConfigAndEtlExtendedFragmentDoc}`;
export function useFetchOneDataSourceWithConfigAndEtlExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneDataSourceWithConfigAndEtlExtendedDocument, options);
}
export function useFetchOneDataSourceWithConfigAndEtlExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneDataSourceWithConfigAndEtlExtendedDocument, options);
}
export function useFetchOneDataSourceWithConfigAndEtlExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneDataSourceWithConfigAndEtlExtendedDocument, options);
}
export const FetchDatasourcesStudioDocument = gql `
    query fetchDatasourcesStudio($input: FetchDataSources!) {
  fetchDatasourcesStudio(input: $input) {
    ...DataSourceStudio
  }
}
    ${DataSourceStudioFragmentDoc}`;
export function useFetchDatasourcesStudioQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasourcesStudioDocument, options);
}
export function useFetchDatasourcesStudioLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasourcesStudioDocument, options);
}
export function useFetchDatasourcesStudioSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasourcesStudioDocument, options);
}
export const FetchMarketplaceDatasetDocument = gql `
    query fetchMarketplaceDataset($input: FetchOneMarketplaceDataset!) {
  fetchMarketplaceDataset(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useFetchMarketplaceDatasetQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetDocument, options);
}
export function useFetchMarketplaceDatasetLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetDocument, options);
}
export function useFetchMarketplaceDatasetSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetDocument, options);
}
export const FetchMarketplaceDatasetUnauthedDocument = gql `
    query fetchMarketplaceDatasetUnauthed($input: FetchOneMarketplaceDataset!) {
  fetchMarketplaceDatasetUnauthed(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useFetchMarketplaceDatasetUnauthedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetUnauthedDocument, options);
}
export function useFetchMarketplaceDatasetUnauthedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetUnauthedDocument, options);
}
export function useFetchMarketplaceDatasetUnauthedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetUnauthedDocument, options);
}
export const FetchMarketplaceDatasetsDocument = gql `
    query fetchMarketplaceDatasets($input: FetchMarketplaceDatasets!) {
  fetchMarketplaceDatasets(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useFetchMarketplaceDatasetsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetsDocument, options);
}
export function useFetchMarketplaceDatasetsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetsDocument, options);
}
export function useFetchMarketplaceDatasetsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetsDocument, options);
}
export const FetchMarketplaceDatasetsUnauthedDocument = gql `
    query fetchMarketplaceDatasetsUnauthed($input: FetchMarketplaceDatasets!) {
  fetchMarketplaceDatasetsUnauthed(input: $input) {
    ...MarketplaceDatasetWithOrganization
  }
}
    ${MarketplaceDatasetWithOrganizationFragmentDoc}`;
export function useFetchMarketplaceDatasetsUnauthedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetsUnauthedDocument, options);
}
export function useFetchMarketplaceDatasetsUnauthedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetsUnauthedDocument, options);
}
export function useFetchMarketplaceDatasetsUnauthedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetsUnauthedDocument, options);
}
export const FetchSampleFileContentsDocument = gql `
    query fetchSampleFileContents($input: InputSampleFileContents!) {
  fetchSampleFileContents(input: $input) {
    ...TableEntity
  }
}
    ${TableEntityFragmentDoc}`;
export function useFetchSampleFileContentsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSampleFileContentsDocument, options);
}
export function useFetchSampleFileContentsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSampleFileContentsDocument, options);
}
export function useFetchSampleFileContentsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSampleFileContentsDocument, options);
}
export const FetchDatasetListingDraftByIdDocument = gql `
    query fetchDatasetListingDraftById($id: String!) {
  fetchDatasetListingDraftById(id: $id) {
    ...MarketplaceDatasetDraft
  }
}
    ${MarketplaceDatasetDraftFragmentDoc}`;
export function useFetchDatasetListingDraftByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasetListingDraftByIdDocument, options);
}
export function useFetchDatasetListingDraftByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasetListingDraftByIdDocument, options);
}
export function useFetchDatasetListingDraftByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasetListingDraftByIdDocument, options);
}
export const FetchAllDatasetListingsByOrgIdDocument = gql `
    query fetchAllDatasetListingsByOrgId($orgId: String!, $status: Status, $options: InputMarketplaceDatasetOptions) {
  fetchAllDatasetListingsByOrgId(
    orgId: $orgId
    status: $status
    options: $options
  ) {
    ...MarketplaceDatasetDraftConnection
  }
}
    ${MarketplaceDatasetDraftConnectionFragmentDoc}`;
export function useFetchAllDatasetListingsByOrgIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllDatasetListingsByOrgIdDocument, options);
}
export function useFetchAllDatasetListingsByOrgIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllDatasetListingsByOrgIdDocument, options);
}
export function useFetchAllDatasetListingsByOrgIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllDatasetListingsByOrgIdDocument, options);
}
export const FetchDatasourceStudioDocument = gql `
    query fetchDatasourceStudio($datasourceId: String!) {
  fetchDatasourceStudio(datasourceId: $datasourceId) {
    dataSource {
      ...DataSourceStudio
    }
    configuration {
      ...DataSourceConfiguration
    }
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export function useFetchDatasourceStudioQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasourceStudioDocument, options);
}
export function useFetchDatasourceStudioLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasourceStudioDocument, options);
}
export function useFetchDatasourceStudioSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasourceStudioDocument, options);
}
export const FetchDatasourceByEtlDatasetLocationIdDocument = gql `
    query fetchDatasourceByEtlDatasetLocationId($datasetLocationId: String!) {
  fetchDatasourceByEtlDatasetLocationId(datasetLocationId: $datasetLocationId) {
    ...DataSourceStudio
  }
}
    ${DataSourceStudioFragmentDoc}`;
export function useFetchDatasourceByEtlDatasetLocationIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasourceByEtlDatasetLocationIdDocument, options);
}
export function useFetchDatasourceByEtlDatasetLocationIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasourceByEtlDatasetLocationIdDocument, options);
}
export function useFetchDatasourceByEtlDatasetLocationIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasourceByEtlDatasetLocationIdDocument, options);
}
export const FetchDatasourceFileSizeDocument = gql `
    query fetchDatasourceFileSize($datasourceId: String!, $fkOrganizationId: String) {
  fetchDatasourceFileSize(
    datasourceId: $datasourceId
    fkOrganizationId: $fkOrganizationId
  )
}
    `;
export function useFetchDatasourceFileSizeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatasourceFileSizeDocument, options);
}
export function useFetchDatasourceFileSizeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatasourceFileSizeDocument, options);
}
export function useFetchDatasourceFileSizeSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatasourceFileSizeDocument, options);
}
export const FetchDataSourcePricingOptionsConnectionsDocument = gql `
    query fetchDataSourcePricingOptionsConnections($input: InputFetchDataSourcePricingOptionsConnections!) {
  fetchDataSourcePricingOptionsConnections(input: $input) {
    ...DataSourcePricingOptionsCountConnection
  }
}
    ${DataSourcePricingOptionsCountConnectionFragmentDoc}`;
export function useFetchDataSourcePricingOptionsConnectionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourcePricingOptionsConnectionsDocument, options);
}
export function useFetchDataSourcePricingOptionsConnectionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourcePricingOptionsConnectionsDocument, options);
}
export function useFetchDataSourcePricingOptionsConnectionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourcePricingOptionsConnectionsDocument, options);
}
export const FetchDataSourceNumVariantsConnectionsDocument = gql `
    query fetchDataSourceNumVariantsConnections($fkOrganizationId: String!) {
  fetchDataSourceNumVariantsConnections(fkOrganizationId: $fkOrganizationId) {
    ...DataSourceNumVariantsConnection
  }
}
    ${DataSourceNumVariantsConnectionFragmentDoc}`;
export function useFetchDataSourceNumVariantsConnectionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDataSourceNumVariantsConnectionsDocument, options);
}
export function useFetchDataSourceNumVariantsConnectionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDataSourceNumVariantsConnectionsDocument, options);
}
export function useFetchDataSourceNumVariantsConnectionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDataSourceNumVariantsConnectionsDocument, options);
}
export const FetchMarketplaceDatasetDataSourceConnectionDocument = gql `
    query fetchMarketplaceDatasetDataSourceConnection($input: FetchOneMarketplaceDataset!) {
  fetchMarketplaceDatasetDataSourceConnection(input: $input) {
    marketplaceDataset {
      ...MarketplaceDatasetStudio
    }
    dataSource {
      ...SlimDataSource
    }
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}
${SlimDataSourceFragmentDoc}`;
export function useFetchMarketplaceDatasetDataSourceConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetDataSourceConnectionDocument, options);
}
export function useFetchMarketplaceDatasetDataSourceConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetDataSourceConnectionDocument, options);
}
export function useFetchMarketplaceDatasetDataSourceConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetDataSourceConnectionDocument, options);
}
export const FetchMarketplaceDatasetDraftDataSourceConnectionDocument = gql `
    query fetchMarketplaceDatasetDraftDataSourceConnection($input: InputFetchMarketplaceDatasetDraftDataSourceConnection!) {
  fetchMarketplaceDatasetDraftDataSourceConnection(input: $input) {
    ...MarketplaceDatasetDraftDataSourceConnection
  }
}
    ${MarketplaceDatasetDraftDataSourceConnectionFragmentDoc}`;
export function useFetchMarketplaceDatasetDraftDataSourceConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetDraftDataSourceConnectionDocument, options);
}
export function useFetchMarketplaceDatasetDraftDataSourceConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetDraftDataSourceConnectionDocument, options);
}
export function useFetchMarketplaceDatasetDraftDataSourceConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetDraftDataSourceConnectionDocument, options);
}
export const FetchMarketplaceDatasetsWithPublishedDataSourcePricesDocument = gql `
    query fetchMarketplaceDatasetsWithPublishedDataSourcePrices($fkOrganizationId: String!) {
  fetchMarketplaceDatasetsWithPublishedDataSourcePrices(
    fkOrganizationId: $fkOrganizationId
  )
}
    `;
export function useFetchMarketplaceDatasetsWithPublishedDataSourcePricesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetsWithPublishedDataSourcePricesDocument, options);
}
export function useFetchMarketplaceDatasetsWithPublishedDataSourcePricesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetsWithPublishedDataSourcePricesDocument, options);
}
export function useFetchMarketplaceDatasetsWithPublishedDataSourcePricesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetsWithPublishedDataSourcePricesDocument, options);
}
export const FetchMarketplaceDatasetSlimConnectionDocument = gql `
    query fetchMarketplaceDatasetSlimConnection($slug: String!) {
  fetchMarketplaceDatasetSlimConnection(slug: $slug) {
    ...MarketplaceDatasetSlimConnection
  }
}
    ${MarketplaceDatasetSlimConnectionFragmentDoc}`;
export function useFetchMarketplaceDatasetSlimConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceDatasetSlimConnectionDocument, options);
}
export function useFetchMarketplaceDatasetSlimConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceDatasetSlimConnectionDocument, options);
}
export function useFetchMarketplaceDatasetSlimConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceDatasetSlimConnectionDocument, options);
}
export const CreatePurchasedDatasetFromApiKeyDocument = gql `
    mutation createPurchasedDatasetFromApiKey($apiKey: String!) {
  createPurchasedDatasetFromApiKey(apiKey: $apiKey) {
    ...PurchasedDataSourceConnectionWithOrganization
  }
}
    ${PurchasedDataSourceConnectionWithOrganizationFragmentDoc}`;
export function useCreatePurchasedDatasetFromApiKeyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreatePurchasedDatasetFromApiKeyDocument, options);
}
export const GetSampleDocument = gql `
    mutation getSample($input: InputGetSample!) {
  getSample(input: $input) {
    ...SampleDataSourceExtended
  }
}
    ${SampleDataSourceExtendedFragmentDoc}`;
export function useGetSampleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GetSampleDocument, options);
}
export const DeleteDataSourceAndExtendDocument = gql `
    mutation deleteDataSourceAndExtend($id: String!) {
  deleteDataSourceAndExtend(id: $id) {
    ...DataSourceStudio
  }
}
    ${DataSourceStudioFragmentDoc}`;
export function useDeleteDataSourceAndExtendMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteDataSourceAndExtendDocument, options);
}
export const UpdateDataSourceConfigDocument = gql `
    mutation updateDataSourceConfig($input: InputDataSourceConfig!) {
  updateDataSourceConfig(input: $input) {
    ...DataSourceConfiguration
  }
}
    ${DataSourceConfigurationFragmentDoc}`;
export function useUpdateDataSourceConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDataSourceConfigDocument, options);
}
export const CreateDataSourceStudioDocument = gql `
    mutation createDataSourceStudio($input: InputCreateDataSourceStudio!) {
  createDataSourceStudio(input: $input) {
    dataSource {
      ...DataSourceStudio
    }
    configuration {
      ...DataSourceConfiguration
    }
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export function useCreateDataSourceStudioMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDataSourceStudioDocument, options);
}
export const CreateMarketplaceDatasetDocument = gql `
    mutation createMarketplaceDataset($input: CreateMarketplaceDataset!) {
  createMarketplaceDataset(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useCreateMarketplaceDatasetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateMarketplaceDatasetDocument, options);
}
export const UpdateMarketplaceDatasetDocument = gql `
    mutation updateMarketplaceDataset($input: EditMarketplaceDataset!) {
  updateMarketplaceDataset(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useUpdateMarketplaceDatasetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateMarketplaceDatasetDocument, options);
}
export const DeleteMarketplaceDatasetDocument = gql `
    mutation deleteMarketplaceDataset($id: String!) {
  deleteMarketplaceDataset(id: $id) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useDeleteMarketplaceDatasetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteMarketplaceDatasetDocument, options);
}
export const CreateDatasetListingDraftDocument = gql `
    mutation createDatasetListingDraft($input: InputMarketplaceDatasetDraft!) {
  createDatasetListingDraft(input: $input) {
    ...MarketplaceDatasetDraft
  }
}
    ${MarketplaceDatasetDraftFragmentDoc}`;
export function useCreateDatasetListingDraftMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDatasetListingDraftDocument, options);
}
export const UpdateDatasetListingDraftDocument = gql `
    mutation updateDatasetListingDraft($id: String!, $input: InputMarketplaceDatasetDraft!) {
  updateDatasetListingDraft(id: $id, input: $input) {
    ...MarketplaceDatasetDraft
  }
}
    ${MarketplaceDatasetDraftFragmentDoc}`;
export function useUpdateDatasetListingDraftMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDatasetListingDraftDocument, options);
}
export const DeleteDatasetListingDraftDocument = gql `
    mutation deleteDatasetListingDraft($id: String!) {
  deleteDatasetListingDraft(id: $id) {
    ...MarketplaceDatasetDraft
  }
}
    ${MarketplaceDatasetDraftFragmentDoc}`;
export function useDeleteDatasetListingDraftMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteDatasetListingDraftDocument, options);
}
export const CreateDatasetListingDocument = gql `
    mutation createDatasetListing($input: InputCreateDataListing!) {
  createDatasetListing(input: $input) {
    ...MarketplaceDatasetStudio
  }
}
    ${MarketplaceDatasetStudioFragmentDoc}`;
export function useCreateDatasetListingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDatasetListingDocument, options);
}
export const FetchAllDemoInstancesDocument = gql `
    query fetchAllDemoInstances($input: InputFetchAllDemoInstances!) {
  fetchAllDemoInstances(input: $input) {
    ...DemoInstances
  }
}
    ${DemoInstancesFragmentDoc}`;
export function useFetchAllDemoInstancesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllDemoInstancesDocument, options);
}
export function useFetchAllDemoInstancesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllDemoInstancesDocument, options);
}
export function useFetchAllDemoInstancesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllDemoInstancesDocument, options);
}
export const FetchDemoInstanceByIdDocument = gql `
    query fetchDemoInstanceById($id: String!) {
  fetchDemoInstanceById(id: $id) {
    ...DemoInstances
  }
}
    ${DemoInstancesFragmentDoc}`;
export function useFetchDemoInstanceByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDemoInstanceByIdDocument, options);
}
export function useFetchDemoInstanceByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDemoInstanceByIdDocument, options);
}
export function useFetchDemoInstanceByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDemoInstanceByIdDocument, options);
}
export const CreateDemoInstanceDocument = gql `
    mutation createDemoInstance($input: CreateDemoInstanceInput!) {
  createDemoInstance(input: $input) {
    ...DemoInstances
  }
}
    ${DemoInstancesFragmentDoc}`;
export function useCreateDemoInstanceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDemoInstanceDocument, options);
}
export const UpdateDemoInstanceDocument = gql `
    mutation updateDemoInstance($input: UpdateDemoInstanceInput!) {
  updateDemoInstance(input: $input) {
    ...DemoInstances
  }
}
    ${DemoInstancesFragmentDoc}`;
export function useUpdateDemoInstanceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDemoInstanceDocument, options);
}
export const DeleteDemoInstanceDocument = gql `
    mutation deleteDemoInstance($id: String!) {
  deleteDemoInstance(id: $id) {
    ...DemoInstances
  }
}
    ${DemoInstancesFragmentDoc}`;
export function useDeleteDemoInstanceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteDemoInstanceDocument, options);
}
export const FetchFileGenerationConnectionDocument = gql `
    query fetchFileGenerationConnection($input: InputFileGenerationConnection!) {
  fetchFileGenerationConnection(input: $input) {
    ...FileGenerationConnection
  }
}
    ${FileGenerationConnectionFragmentDoc}`;
export function useFetchFileGenerationConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchFileGenerationConnectionDocument, options);
}
export function useFetchFileGenerationConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchFileGenerationConnectionDocument, options);
}
export function useFetchFileGenerationConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchFileGenerationConnectionDocument, options);
}
export const FetchGeneratedFileByIdDocument = gql `
    query fetchGeneratedFileById($id: String!) {
  fetchGeneratedFileById(id: $id) {
    ...GeneratedFile
  }
}
    ${GeneratedFileFragmentDoc}`;
export function useFetchGeneratedFileByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchGeneratedFileByIdDocument, options);
}
export function useFetchGeneratedFileByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchGeneratedFileByIdDocument, options);
}
export function useFetchGeneratedFileByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchGeneratedFileByIdDocument, options);
}
export const StartEgressDocument = gql `
    mutation startEgress($input: EgressInput!) {
  startEgress(input: $input)
}
    `;
export function useStartEgressMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(StartEgressDocument, options);
}
export const StartEgressMarketplaceDocument = gql `
    mutation startEgressMarketplace($input: EgressInput!) {
  startEgressMarketplace(input: $input)
}
    `;
export function useStartEgressMarketplaceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(StartEgressMarketplaceDocument, options);
}
export const GenerateFileDocument = gql `
    mutation generateFile($input: InputFileGeneration!) {
  generateFile(input: $input) {
    ...FileGenerationExtended
  }
}
    ${FileGenerationExtendedFragmentDoc}`;
export function useGenerateFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GenerateFileDocument, options);
}
export const VerifyEntitlementAccessKeyDocument = gql `
    query verifyEntitlementAccessKey($input: InputCreateEntitlement!) {
  verifyEntitlementAccessKey(input: $input) {
    ...VerifiedAccessKeyResponse
  }
}
    ${VerifiedAccessKeyResponseFragmentDoc}`;
export function useVerifyEntitlementAccessKeyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(VerifyEntitlementAccessKeyDocument, options);
}
export function useVerifyEntitlementAccessKeyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(VerifyEntitlementAccessKeyDocument, options);
}
export function useVerifyEntitlementAccessKeySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(VerifyEntitlementAccessKeyDocument, options);
}
export const FetchLabAccessKeyExtendedByApiKeyDocument = gql `
    query fetchLabAccessKeyExtendedByApiKey($apiKey: String!) {
  fetchLabAccessKeyExtendedByApiKey(apiKey: $apiKey) {
    ...LabAccessKeyExtended
  }
}
    ${LabAccessKeyExtendedFragmentDoc}`;
export function useFetchLabAccessKeyExtendedByApiKeyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchLabAccessKeyExtendedByApiKeyDocument, options);
}
export function useFetchLabAccessKeyExtendedByApiKeyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchLabAccessKeyExtendedByApiKeyDocument, options);
}
export function useFetchLabAccessKeyExtendedByApiKeySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchLabAccessKeyExtendedByApiKeyDocument, options);
}
export const FetchAllLabAccessKeyExtendedDocument = gql `
    query fetchAllLabAccessKeyExtended($input: InputFetchAllLabAccessKeyExtended) {
  fetchAllLabAccessKeyExtended(input: $input) {
    ...LabAccessKeyExtendedConnection
  }
}
    ${LabAccessKeyExtendedConnectionFragmentDoc}`;
export function useFetchAllLabAccessKeyExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllLabAccessKeyExtendedDocument, options);
}
export function useFetchAllLabAccessKeyExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllLabAccessKeyExtendedDocument, options);
}
export function useFetchAllLabAccessKeyExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllLabAccessKeyExtendedDocument, options);
}
export const FetchDatalabEntitlementByIdDocument = gql `
    query fetchDatalabEntitlementById($id: String!) {
  fetchDatalabEntitlementById(id: $id) {
    ...DatalabEntitlement
  }
}
    ${DatalabEntitlementFragmentDoc}`;
export function useFetchDatalabEntitlementByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatalabEntitlementByIdDocument, options);
}
export function useFetchDatalabEntitlementByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatalabEntitlementByIdDocument, options);
}
export function useFetchDatalabEntitlementByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatalabEntitlementByIdDocument, options);
}
export const DeleteDatalabEntitlementDocument = gql `
    mutation deleteDatalabEntitlement($id: String!) {
  deleteDatalabEntitlement(id: $id) {
    ...DatalabEntitlement
  }
}
    ${DatalabEntitlementFragmentDoc}`;
export function useDeleteDatalabEntitlementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteDatalabEntitlementDocument, options);
}
export const CreateEntitlementDocument = gql `
    mutation createEntitlement($input: InputCreateEntitlement!) {
  createEntitlement(input: $input) {
    ...Entitlement
  }
}
    ${EntitlementFragmentDoc}`;
export function useCreateEntitlementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateEntitlementDocument, options);
}
export const CreateDatasetApiKeyDocument = gql `
    mutation createDatasetApiKey($input: InputGenerateDatasetsApiKey!) {
  createDatasetApiKey(input: $input) {
    ...LabAccessKeyExtended
  }
}
    ${LabAccessKeyExtendedFragmentDoc}`;
export function useCreateDatasetApiKeyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDatasetApiKeyDocument, options);
}
export const UpdateDatasetApiKeyDocument = gql `
    mutation updateDatasetApiKey($input: InputUpdateDatasetApiKey!) {
  updateDatasetApiKey(input: $input) {
    ...LabAccessKeyExtended
  }
}
    ${LabAccessKeyExtendedFragmentDoc}`;
export function useUpdateDatasetApiKeyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateDatasetApiKeyDocument, options);
}
export const GenerateAccessKeyDocument = gql `
    mutation generateAccessKey($input: InputCreateEntitlement!) {
  generateAccessKey(input: $input)
}
    `;
export function useGenerateAccessKeyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GenerateAccessKeyDocument, options);
}
export const SendCustomerAccessKeyDocument = gql `
    mutation sendCustomerAccessKey($input: InputSendAccessKeyEmail!) {
  sendCustomerAccessKey(input: $input)
}
    `;
export function useSendCustomerAccessKeyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SendCustomerAccessKeyDocument, options);
}
export const FetchAllEtlDatasetLocationConnectionDocument = gql `
    query fetchAllEtlDatasetLocationConnection {
  fetchAllEtlDatasetLocationConnection {
    etlDatasetLocations {
      ...EtlDatasetLocation
    }
    count
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useFetchAllEtlDatasetLocationConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllEtlDatasetLocationConnectionDocument, options);
}
export function useFetchAllEtlDatasetLocationConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllEtlDatasetLocationConnectionDocument, options);
}
export function useFetchAllEtlDatasetLocationConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllEtlDatasetLocationConnectionDocument, options);
}
export const FetchOneEtlDatasetLocationExtendedByIdDocument = gql `
    query fetchOneEtlDatasetLocationExtendedById($id: String!) {
  fetchOneEtlDatasetLocationExtendedById(id: $id) {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useFetchOneEtlDatasetLocationExtendedByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneEtlDatasetLocationExtendedByIdDocument, options);
}
export function useFetchOneEtlDatasetLocationExtendedByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneEtlDatasetLocationExtendedByIdDocument, options);
}
export function useFetchOneEtlDatasetLocationExtendedByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneEtlDatasetLocationExtendedByIdDocument, options);
}
export const FetchEtlDatasetLocationByDataSourceIdsDocument = gql `
    query fetchEtlDatasetLocationByDataSourceIds($ids: [String!]!) {
  fetchEtlDatasetLocationByDataSourceIds(ids: $ids) {
    ...DataSourceEtlLocation
  }
}
    ${DataSourceEtlLocationFragmentDoc}`;
export function useFetchEtlDatasetLocationByDataSourceIdsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchEtlDatasetLocationByDataSourceIdsDocument, options);
}
export function useFetchEtlDatasetLocationByDataSourceIdsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchEtlDatasetLocationByDataSourceIdsDocument, options);
}
export function useFetchEtlDatasetLocationByDataSourceIdsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchEtlDatasetLocationByDataSourceIdsDocument, options);
}
export const DecryptCloudCredentialDocument = gql `
    query decryptCloudCredential($hashCredential: String!) {
  decryptCloudCredential(hashCredential: $hashCredential) {
    ...CloudCredentialInfo
  }
}
    ${CloudCredentialInfoFragmentDoc}`;
export function useDecryptCloudCredentialQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(DecryptCloudCredentialDocument, options);
}
export function useDecryptCloudCredentialLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(DecryptCloudCredentialDocument, options);
}
export function useDecryptCloudCredentialSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DecryptCloudCredentialDocument, options);
}
export const CreateMultiEtlDatasetLocationExtendedDocument = gql `
    mutation createMultiEtlDatasetLocationExtended($input: InputCreateEtlDatasetLocationExtended!) {
  createMultiEtlDatasetLocationExtended(input: $input) {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useCreateMultiEtlDatasetLocationExtendedMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateMultiEtlDatasetLocationExtendedDocument, options);
}
export const CreateDatasetAndEtlDatasetLocationsAndTransferFilesDocument = gql `
    mutation createDatasetAndEtlDatasetLocationsAndTransferFiles($input: InputCreateEtlDatasetLocationExtended!) {
  createDatasetAndEtlDatasetLocationsAndTransferFiles(input: $input) {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useCreateDatasetAndEtlDatasetLocationsAndTransferFilesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateDatasetAndEtlDatasetLocationsAndTransferFilesDocument, options);
}
export const DeleteOneEtlDatasetLocationExtendedByIdDocument = gql `
    mutation deleteOneEtlDatasetLocationExtendedById($id: String!) {
  deleteOneEtlDatasetLocationExtendedById(id: $id) {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useDeleteOneEtlDatasetLocationExtendedByIdMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteOneEtlDatasetLocationExtendedByIdDocument, options);
}
export const UpdateEtlDatasetLocationAndIndexDocument = gql `
    mutation updateEtlDatasetLocationAndIndex($input: InputUpdateEtlDatasetLocation!) {
  updateEtlDatasetLocationAndIndex(input: $input) {
    ...EtlDatasetLocation
  }
}
    ${EtlDatasetLocationFragmentDoc}`;
export function useUpdateEtlDatasetLocationAndIndexMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateEtlDatasetLocationAndIndexDocument, options);
}
export const StartEtlDocument = gql `
    mutation startEtl($id: String!) {
  startEtl(id: $id) {
    ...EtlProcess
  }
}
    ${EtlProcessFragmentDoc}`;
export function useStartEtlMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(StartEtlDocument, options);
}
export const FetchEtlInstanceByIdDocument = gql `
    query fetchEtlInstanceById($id: String!) {
  fetchEtlInstanceById(id: $id) {
    ...EtlInstance
  }
}
    ${EtlInstanceFragmentDoc}`;
export function useFetchEtlInstanceByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchEtlInstanceByIdDocument, options);
}
export function useFetchEtlInstanceByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchEtlInstanceByIdDocument, options);
}
export function useFetchEtlInstanceByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchEtlInstanceByIdDocument, options);
}
export const FetchAllEtlInstancesDocument = gql `
    query fetchAllEtlInstances($input: InputFetchAllEtlInstances!) {
  fetchAllEtlInstances(input: $input) {
    ...EtlInstance
  }
}
    ${EtlInstanceFragmentDoc}`;
export function useFetchAllEtlInstancesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllEtlInstancesDocument, options);
}
export function useFetchAllEtlInstancesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllEtlInstancesDocument, options);
}
export function useFetchAllEtlInstancesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllEtlInstancesDocument, options);
}
export const FetchEtlErrorByIdDocument = gql `
    query fetchEtlErrorById($id: String!) {
  fetchEtlErrorById(id: $id) {
    ...EtlError
  }
}
    ${EtlErrorFragmentDoc}`;
export function useFetchEtlErrorByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchEtlErrorByIdDocument, options);
}
export function useFetchEtlErrorByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchEtlErrorByIdDocument, options);
}
export function useFetchEtlErrorByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchEtlErrorByIdDocument, options);
}
export const FetchAllEtlErrorsDocument = gql `
    query fetchAllEtlErrors($input: InputFetchAllEtlErrors!) {
  fetchAllEtlErrors(input: $input) {
    ...EtlError
  }
}
    ${EtlErrorFragmentDoc}`;
export function useFetchAllEtlErrorsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllEtlErrorsDocument, options);
}
export function useFetchAllEtlErrorsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllEtlErrorsDocument, options);
}
export function useFetchAllEtlErrorsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllEtlErrorsDocument, options);
}
export const FetchEtlInstancesByDatasetLocationIdDocument = gql `
    query fetchEtlInstancesByDatasetLocationId($input: InputFetchEtlInstancesByDatasetLocationId!) {
  fetchEtlInstancesByDatasetLocationId(input: $input) {
    ...EtlInstance
  }
}
    ${EtlInstanceFragmentDoc}`;
export function useFetchEtlInstancesByDatasetLocationIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchEtlInstancesByDatasetLocationIdDocument, options);
}
export function useFetchEtlInstancesByDatasetLocationIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchEtlInstancesByDatasetLocationIdDocument, options);
}
export function useFetchEtlInstancesByDatasetLocationIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchEtlInstancesByDatasetLocationIdDocument, options);
}
export const FetchAllExternalCredentialsDocument = gql `
    query fetchAllExternalCredentials {
  fetchAllExternalCredentials {
    ...ExternalCredentialExtended
  }
}
    ${ExternalCredentialExtendedFragmentDoc}`;
export function useFetchAllExternalCredentialsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllExternalCredentialsDocument, options);
}
export function useFetchAllExternalCredentialsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllExternalCredentialsDocument, options);
}
export function useFetchAllExternalCredentialsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllExternalCredentialsDocument, options);
}
export const CreateExternalCredentialDocument = gql `
    mutation createExternalCredential($input: InputCreateExternalCredential!) {
  createExternalCredential(input: $input) {
    ...ExternalCredentialExtended
  }
}
    ${ExternalCredentialExtendedFragmentDoc}`;
export function useCreateExternalCredentialMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateExternalCredentialDocument, options);
}
export const DeleteSampleFileDocument = gql `
    mutation deleteSampleFile($input: DeleteSampleFile!) {
  deleteSampleFile(input: $input) {
    ...DeletedStorageBlob
  }
}
    ${DeletedStorageBlobFragmentDoc}`;
export function useDeleteSampleFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteSampleFileDocument, options);
}
export const DeleteSampleFileFromAzureDocument = gql `
    mutation deleteSampleFileFromAzure($filename: String!) {
  deleteSampleFileFromAzure(filename: $filename) {
    ...DeletedStorageBlob
  }
}
    ${DeletedStorageBlobFragmentDoc}`;
export function useDeleteSampleFileFromAzureMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteSampleFileFromAzureDocument, options);
}
export const CreateInstantOfferDocument = gql `
    mutation createInstantOffer($input: InputCreateInstantOffer!) {
  createInstantOffer(input: $input) {
    ...InstantOffer
  }
}
    ${InstantOfferFragmentDoc}`;
export function useCreateInstantOfferMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateInstantOfferDocument, options);
}
export const FetchInstantOfferExtendedByIdDocument = gql `
    query fetchInstantOfferExtendedById($id: String!) {
  fetchInstantOfferExtendedById(id: $id) {
    ...InstantOfferExtended
  }
}
    ${InstantOfferExtendedFragmentDoc}`;
export function useFetchInstantOfferExtendedByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchInstantOfferExtendedByIdDocument, options);
}
export function useFetchInstantOfferExtendedByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchInstantOfferExtendedByIdDocument, options);
}
export function useFetchInstantOfferExtendedByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchInstantOfferExtendedByIdDocument, options);
}
export const FetchInstantOfferCustomerVariantConnectionDocument = gql `
    query fetchInstantOfferCustomerVariantConnection($input: DataGridFetchInput) {
  fetchInstantOfferCustomerVariantConnection(input: $input) {
    ...InstantOfferCustomerVariantConnection
  }
}
    ${InstantOfferCustomerVariantConnectionFragmentDoc}`;
export function useFetchInstantOfferCustomerVariantConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchInstantOfferCustomerVariantConnectionDocument, options);
}
export function useFetchInstantOfferCustomerVariantConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchInstantOfferCustomerVariantConnectionDocument, options);
}
export function useFetchInstantOfferCustomerVariantConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchInstantOfferCustomerVariantConnectionDocument, options);
}
export const FetchJourneyEventMetaDocument = gql `
    query fetchJourneyEventMeta {
  fetchJourneyEventMeta {
    ...JourneyEventMeta
  }
}
    ${JourneyEventMetaFragmentDoc}`;
export function useFetchJourneyEventMetaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchJourneyEventMetaDocument, options);
}
export function useFetchJourneyEventMetaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchJourneyEventMetaDocument, options);
}
export function useFetchJourneyEventMetaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchJourneyEventMetaDocument, options);
}
export const FetchOneJourneyEventMetaDocument = gql `
    query fetchOneJourneyEventMeta($input: String!) {
  fetchOneJourneyEventMeta(input: $input) {
    ...JourneyEventMeta
  }
}
    ${JourneyEventMetaFragmentDoc}`;
export function useFetchOneJourneyEventMetaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneJourneyEventMetaDocument, options);
}
export function useFetchOneJourneyEventMetaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneJourneyEventMetaDocument, options);
}
export function useFetchOneJourneyEventMetaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneJourneyEventMetaDocument, options);
}
export const EditJourneyEventMetaDocument = gql `
    mutation editJourneyEventMeta($input: EditJourneyEventMeta!) {
  editJourneyEventMeta(input: $input) {
    ...JourneyEventMeta
  }
}
    ${JourneyEventMetaFragmentDoc}`;
export function useEditJourneyEventMetaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditJourneyEventMetaDocument, options);
}
export const FetchOneJourneyRunDocument = gql `
    query fetchOneJourneyRun($input: String!) {
  fetchOneJourneyRun(input: $input) {
    ...JourneyRun
  }
}
    ${JourneyRunFragmentDoc}`;
export function useFetchOneJourneyRunQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneJourneyRunDocument, options);
}
export function useFetchOneJourneyRunLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneJourneyRunDocument, options);
}
export function useFetchOneJourneyRunSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneJourneyRunDocument, options);
}
export const FetchJourneyRunsDocument = gql `
    query fetchJourneyRuns($input: IJourneyRunParams!) {
  fetchJourneyRuns(input: $input) {
    runs {
      ...JourneyRun
    }
    count
  }
}
    ${JourneyRunFragmentDoc}`;
export function useFetchJourneyRunsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchJourneyRunsDocument, options);
}
export function useFetchJourneyRunsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchJourneyRunsDocument, options);
}
export function useFetchJourneyRunsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchJourneyRunsDocument, options);
}
export const FetchJourneyRunStepsDocument = gql `
    query fetchJourneyRunSteps($input: String!) {
  fetchJourneyRunSteps(input: $input) {
    ...JourneyStepRun
  }
}
    ${JourneyStepRunFragmentDoc}`;
export function useFetchJourneyRunStepsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchJourneyRunStepsDocument, options);
}
export function useFetchJourneyRunStepsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchJourneyRunStepsDocument, options);
}
export function useFetchJourneyRunStepsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchJourneyRunStepsDocument, options);
}
export const RerunJourneyRunDocument = gql `
    mutation rerunJourneyRun($input: String!) {
  rerunJourneyRun(input: $input)
}
    `;
export function useRerunJourneyRunMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(RerunJourneyRunDocument, options);
}
export const FetchJourneysStepsDocument = gql `
    query fetchJourneysSteps($input: String!) {
  fetchJourneysSteps(input: $input) {
    ...JourneyStep
  }
}
    ${JourneyStepFragmentDoc}`;
export function useFetchJourneysStepsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchJourneysStepsDocument, options);
}
export function useFetchJourneysStepsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchJourneysStepsDocument, options);
}
export function useFetchJourneysStepsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchJourneysStepsDocument, options);
}
export const AddJourneyStepDocument = gql `
    mutation addJourneyStep($input: AddJourneyStep!) {
  addJourneyStep(input: $input) {
    stepAdded {
      ...JourneyStep
    }
    stepParent {
      ...JourneyStep
    }
    stepChild {
      ...JourneyStep
    }
  }
}
    ${JourneyStepFragmentDoc}`;
export function useAddJourneyStepMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(AddJourneyStepDocument, options);
}
export const EditJourneyStepDocument = gql `
    mutation editJourneyStep($input: EditJourneyStep!) {
  editJourneyStep(input: $input) {
    ...JourneyStep
  }
}
    ${JourneyStepFragmentDoc}`;
export function useEditJourneyStepMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditJourneyStepDocument, options);
}
export const DeleteJourneyStepDocument = gql `
    mutation deleteJourneyStep($input: DeleteStep!) {
  deleteJourneyStep(input: $input) {
    stepDeleted {
      ...JourneyStep
    }
    stepParent {
      ...JourneyStep
    }
    updatedSteps {
      ...JourneyStep
    }
  }
}
    ${JourneyStepFragmentDoc}`;
export function useDeleteJourneyStepMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteJourneyStepDocument, options);
}
export const FetchEventsJourneysDocument = gql `
    query fetchEventsJourneys($input: String!) {
  fetchEventsJourneys(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useFetchEventsJourneysQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchEventsJourneysDocument, options);
}
export function useFetchEventsJourneysLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchEventsJourneysDocument, options);
}
export function useFetchEventsJourneysSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchEventsJourneysDocument, options);
}
export const FetchOneJourneyDocument = gql `
    query fetchOneJourney($input: String!) {
  fetchOneJourney(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useFetchOneJourneyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneJourneyDocument, options);
}
export function useFetchOneJourneyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneJourneyDocument, options);
}
export function useFetchOneJourneySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneJourneyDocument, options);
}
export const CreateJourneyDocument = gql `
    mutation createJourney($input: CreateJourney!) {
  createJourney(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useCreateJourneyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateJourneyDocument, options);
}
export const EditJourneyDocument = gql `
    mutation editJourney($input: EditJourney!) {
  editJourney(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useEditJourneyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditJourneyDocument, options);
}
export const EditActiveJourneyDocument = gql `
    mutation editActiveJourney($input: EditActiveJourney!) {
  editActiveJourney(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useEditActiveJourneyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditActiveJourneyDocument, options);
}
export const DeleteJourneyDocument = gql `
    mutation deleteJourney($input: String!) {
  deleteJourney(input: $input) {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;
export function useDeleteJourneyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteJourneyDocument, options);
}
export const TestJourneyEventDocument = gql `
    mutation testJourneyEvent($input: ITestJourneyEvent!) {
  testJourneyEvent(input: $input)
}
    `;
export function useTestJourneyEventMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(TestJourneyEventDocument, options);
}
export const FetchMapTemplatesDocument = gql `
    query fetchMapTemplates($input: InputMapTemplate!) {
  fetchMapTemplates(input: $input) {
    ...MapTemplate
  }
}
    ${MapTemplateFragmentDoc}`;
export function useFetchMapTemplatesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMapTemplatesDocument, options);
}
export function useFetchMapTemplatesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMapTemplatesDocument, options);
}
export function useFetchMapTemplatesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMapTemplatesDocument, options);
}
export const FetchMapTemplatesExtendedDocument = gql `
    query fetchMapTemplatesExtended($input: InputMapTemplate!) {
  fetchMapTemplatesExtended(input: $input) {
    ...MapTemplateExtended
  }
}
    ${MapTemplateExtendedFragmentDoc}`;
export function useFetchMapTemplatesExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMapTemplatesExtendedDocument, options);
}
export function useFetchMapTemplatesExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMapTemplatesExtendedDocument, options);
}
export function useFetchMapTemplatesExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMapTemplatesExtendedDocument, options);
}
export const FetchMapTemplateDocument = gql `
    query fetchMapTemplate($id: String!) {
  fetchMapTemplate(id: $id) {
    ...MapTemplate
  }
}
    ${MapTemplateFragmentDoc}`;
export function useFetchMapTemplateQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMapTemplateDocument, options);
}
export function useFetchMapTemplateLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMapTemplateDocument, options);
}
export function useFetchMapTemplateSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMapTemplateDocument, options);
}
export const FetchOrCreateGlobalMapTemplateDocument = gql `
    query fetchOrCreateGlobalMapTemplate {
  fetchOrCreateGlobalMapTemplate {
    ...MapTemplate
  }
}
    ${MapTemplateFragmentDoc}`;
export function useFetchOrCreateGlobalMapTemplateQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrCreateGlobalMapTemplateDocument, options);
}
export function useFetchOrCreateGlobalMapTemplateLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrCreateGlobalMapTemplateDocument, options);
}
export function useFetchOrCreateGlobalMapTemplateSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrCreateGlobalMapTemplateDocument, options);
}
export const FetchMapTemplateExtendedDocument = gql `
    query fetchMapTemplateExtended($id: String!) {
  fetchMapTemplateExtended(id: $id) {
    ...MapTemplateExtended
  }
}
    ${MapTemplateExtendedFragmentDoc}`;
export function useFetchMapTemplateExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMapTemplateExtendedDocument, options);
}
export function useFetchMapTemplateExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMapTemplateExtendedDocument, options);
}
export function useFetchMapTemplateExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMapTemplateExtendedDocument, options);
}
export const FetchMapTemplateDatasetsExtendedDocument = gql `
    query fetchMapTemplateDatasetsExtended($input: InputMapTemplateDataset!) {
  fetchMapTemplateDatasetsExtended(input: $input) {
    ...MapTemplateDatasetExtended
  }
}
    ${MapTemplateDatasetExtendedFragmentDoc}`;
export function useFetchMapTemplateDatasetsExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMapTemplateDatasetsExtendedDocument, options);
}
export function useFetchMapTemplateDatasetsExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMapTemplateDatasetsExtendedDocument, options);
}
export function useFetchMapTemplateDatasetsExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMapTemplateDatasetsExtendedDocument, options);
}
export const CreateMapTemplateDocument = gql `
    mutation createMapTemplate($input: InputCreateMapTemplate!) {
  createMapTemplate(input: $input) {
    ...MapTemplateExtended
  }
}
    ${MapTemplateExtendedFragmentDoc}`;
export function useCreateMapTemplateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateMapTemplateDocument, options);
}
export const UpdateMapTemplateDocument = gql `
    mutation updateMapTemplate($input: InputUpdateMapTemplate!) {
  updateMapTemplate(input: $input) {
    ...MapTemplateExtended
  }
}
    ${MapTemplateExtendedFragmentDoc}`;
export function useUpdateMapTemplateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateMapTemplateDocument, options);
}
export const DeleteMapTemplateDocument = gql `
    mutation deleteMapTemplate($id: String!) {
  deleteMapTemplate(id: $id) {
    ...MapTemplate
  }
}
    ${MapTemplateFragmentDoc}`;
export function useDeleteMapTemplateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteMapTemplateDocument, options);
}
export const CreateMapTemplateDatasetsDocument = gql `
    mutation createMapTemplateDatasets($input: [InputCreateMapTemplateDataset!]!) {
  createMapTemplateDatasets(input: $input) {
    ...MapTemplateDatasetExtended
  }
}
    ${MapTemplateDatasetExtendedFragmentDoc}`;
export function useCreateMapTemplateDatasetsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateMapTemplateDatasetsDocument, options);
}
export const UpdateMapTemplateDatasetDocument = gql `
    mutation updateMapTemplateDataset($input: InputUpdateMapTemplateDataset!) {
  updateMapTemplateDataset(input: $input) {
    ...MapTemplateDatasetExtended
  }
}
    ${MapTemplateDatasetExtendedFragmentDoc}`;
export function useUpdateMapTemplateDatasetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateMapTemplateDatasetDocument, options);
}
export const FetchAllBoundariesUnauthedDocument = gql `
    query fetchAllBoundariesUnauthed {
  fetchAllBoundariesUnauthed {
    ...NamedBoundarySet
  }
}
    ${NamedBoundarySetFragmentDoc}`;
export function useFetchAllBoundariesUnauthedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllBoundariesUnauthedDocument, options);
}
export function useFetchAllBoundariesUnauthedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllBoundariesUnauthedDocument, options);
}
export function useFetchAllBoundariesUnauthedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllBoundariesUnauthedDocument, options);
}
export const FetchBoundarySetTableMarketplaceDocument = gql `
    query fetchBoundarySetTableMarketplace($input: InputFetchBoundarySetTable!) {
  fetchBoundarySetTableMarketplace(input: $input) {
    ...BoundarySetTableCountConnection
  }
}
    ${BoundarySetTableCountConnectionFragmentDoc}`;
export function useFetchBoundarySetTableMarketplaceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchBoundarySetTableMarketplaceDocument, options);
}
export function useFetchBoundarySetTableMarketplaceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchBoundarySetTableMarketplaceDocument, options);
}
export function useFetchBoundarySetTableMarketplaceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchBoundarySetTableMarketplaceDocument, options);
}
export const FindBoundarySetDocument = gql `
    query FindBoundarySet($input: FindBoundarySetInput!) {
  findBoundarySet(input: $input) {
    ...NamedBoundarySetResponse
  }
}
    ${NamedBoundarySetResponseFragmentDoc}`;
export function useFindBoundarySetQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FindBoundarySetDocument, options);
}
export function useFindBoundarySetLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FindBoundarySetDocument, options);
}
export function useFindBoundarySetSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FindBoundarySetDocument, options);
}
export const FindBoundaryDocument = gql `
    query FindBoundary($input: FindBoundaryInput!) {
  findBoundary(input: $input) {
    ...NamedBoundaryResponse
  }
}
    ${NamedBoundaryResponseFragmentDoc}`;
export function useFindBoundaryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FindBoundaryDocument, options);
}
export function useFindBoundaryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FindBoundaryDocument, options);
}
export function useFindBoundarySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FindBoundaryDocument, options);
}
export const SuggestDocument = gql `
    query Suggest($input: SuggestInput!) {
  suggest(input: $input) {
    ...NamedBoundarySuggestResponse
  }
}
    ${NamedBoundarySuggestResponseFragmentDoc}`;
export function useSuggestQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(SuggestDocument, options);
}
export function useSuggestLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(SuggestDocument, options);
}
export function useSuggestSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SuggestDocument, options);
}
export const GetBoundariesGeoJsonDocument = gql `
    query GetBoundariesGeoJson($input: GetBoundariesGeoJsonInput!) {
  getBoundariesGeoJson(input: $input) {
    ...GetBoundariesGeoJsonResponse
  }
}
    ${GetBoundariesGeoJsonResponseFragmentDoc}`;
export function useGetBoundariesGeoJsonQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(GetBoundariesGeoJsonDocument, options);
}
export function useGetBoundariesGeoJsonLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(GetBoundariesGeoJsonDocument, options);
}
export function useGetBoundariesGeoJsonSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetBoundariesGeoJsonDocument, options);
}
export const FetchDatalabOnboardingStepsDocument = gql `
    query fetchDatalabOnboardingSteps {
  fetchDatalabOnboardingSteps {
    ...OnboardingStepCompletionsConnection
  }
}
    ${OnboardingStepCompletionsConnectionFragmentDoc}`;
export function useFetchDatalabOnboardingStepsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatalabOnboardingStepsDocument, options);
}
export function useFetchDatalabOnboardingStepsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatalabOnboardingStepsDocument, options);
}
export function useFetchDatalabOnboardingStepsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatalabOnboardingStepsDocument, options);
}
export const CreateOnboardingStepCompletionDocument = gql `
    mutation createOnboardingStepCompletion($input: InputCreateOnboardingStepCompletion!) {
  createOnboardingStepCompletion(input: $input) {
    ...OnboardingStepCompletion
  }
}
    ${OnboardingStepCompletionFragmentDoc}`;
export function useCreateOnboardingStepCompletionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateOnboardingStepCompletionDocument, options);
}
export const FetchAllOrganizationsWithRelationsCountDocument = gql `
    query fetchAllOrganizationsWithRelationsCount($input: DataGridFetchInput!) {
  fetchAllOrganizationsWithRelationsCount(input: $input) {
    ...OrganizationWithRelationsCount
  }
}
    ${OrganizationWithRelationsCountFragmentDoc}`;
export function useFetchAllOrganizationsWithRelationsCountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllOrganizationsWithRelationsCountDocument, options);
}
export function useFetchAllOrganizationsWithRelationsCountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllOrganizationsWithRelationsCountDocument, options);
}
export function useFetchAllOrganizationsWithRelationsCountSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllOrganizationsWithRelationsCountDocument, options);
}
export const FetchMarketplaceProviderDocument = gql `
    query fetchMarketplaceProvider($slug: String!) {
  fetchMarketplaceProvider(slug: $slug) {
    ...SlimDataProvider
  }
}
    ${SlimDataProviderFragmentDoc}`;
export function useFetchMarketplaceProviderQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceProviderDocument, options);
}
export function useFetchMarketplaceProviderLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceProviderDocument, options);
}
export function useFetchMarketplaceProviderSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceProviderDocument, options);
}
export const FetchMarketplaceProvidersDocument = gql `
    query fetchMarketplaceProviders($input: InputDataProvider!) {
  fetchMarketplaceProviders(input: $input) {
    ...SlimDataProvider
  }
}
    ${SlimDataProviderFragmentDoc}`;
export function useFetchMarketplaceProvidersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchMarketplaceProvidersDocument, options);
}
export function useFetchMarketplaceProvidersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchMarketplaceProvidersDocument, options);
}
export function useFetchMarketplaceProvidersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchMarketplaceProvidersDocument, options);
}
export const FetchOrganizationFreeComputeUnitsDocument = gql `
    query fetchOrganizationFreeComputeUnits {
  fetchOrganizationFreeComputeUnits
}
    `;
export function useFetchOrganizationFreeComputeUnitsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationFreeComputeUnitsDocument, options);
}
export function useFetchOrganizationFreeComputeUnitsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationFreeComputeUnitsDocument, options);
}
export function useFetchOrganizationFreeComputeUnitsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationFreeComputeUnitsDocument, options);
}
export const FetchOrganizationsWithProductDocument = gql `
    query fetchOrganizationsWithProduct($input: InputFetchOrganizationsWithProduct!) {
  fetchOrganizationsWithProduct(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOrganizationsWithProductQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsWithProductDocument, options);
}
export function useFetchOrganizationsWithProductLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsWithProductDocument, options);
}
export function useFetchOrganizationsWithProductSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsWithProductDocument, options);
}
export const FetchDatalabOrganizationsDocument = gql `
    query fetchDatalabOrganizations($input: InputFetchDatalabOrganizations!) {
  fetchDatalabOrganizations(input: $input) {
    organizations {
      organization {
        ...Organization
      }
      tier
    }
    count
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchDatalabOrganizationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatalabOrganizationsDocument, options);
}
export function useFetchDatalabOrganizationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatalabOrganizationsDocument, options);
}
export function useFetchDatalabOrganizationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatalabOrganizationsDocument, options);
}
export const FetchAllOrganizationsDocument = gql `
    query fetchAllOrganizations {
  fetchAllOrganizations {
    ...OrganizationExtendedOrganizationUserExtended
  }
}
    ${OrganizationExtendedOrganizationUserExtendedFragmentDoc}`;
export function useFetchAllOrganizationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllOrganizationsDocument, options);
}
export function useFetchAllOrganizationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllOrganizationsDocument, options);
}
export function useFetchAllOrganizationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllOrganizationsDocument, options);
}
export const FetchOrganizationBySlugDocument = gql `
    query fetchOrganizationBySlug($slug: String!) {
  fetchOrganizationBySlug(slug: $slug) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOrganizationBySlugQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationBySlugDocument, options);
}
export function useFetchOrganizationBySlugLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationBySlugDocument, options);
}
export function useFetchOrganizationBySlugSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationBySlugDocument, options);
}
export const FetchOrganizationByIdDocument = gql `
    query fetchOrganizationById($id: String!) {
  fetchOrganizationById(id: $id) {
    ...OrganizationExtendedOrganizationUserExtended
  }
}
    ${OrganizationExtendedOrganizationUserExtendedFragmentDoc}`;
export function useFetchOrganizationByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationByIdDocument, options);
}
export function useFetchOrganizationByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationByIdDocument, options);
}
export function useFetchOrganizationByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationByIdDocument, options);
}
export const FetchOneOrganizationByIdDocument = gql `
    query fetchOneOrganizationById($id: String!) {
  fetchOneOrganizationById(id: $id) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOneOrganizationByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneOrganizationByIdDocument, options);
}
export function useFetchOneOrganizationByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneOrganizationByIdDocument, options);
}
export function useFetchOneOrganizationByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneOrganizationByIdDocument, options);
}
export const FetchAllOrgUserByUserIdDocument = gql `
    query fetchAllOrgUserByUserId($userId: String) {
  fetchAllOrgUserByUserId(userId: $userId) {
    organizationUsers {
      ...OrganizationUserExtended
    }
    count
  }
}
    ${OrganizationUserExtendedFragmentDoc}`;
export function useFetchAllOrgUserByUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllOrgUserByUserIdDocument, options);
}
export function useFetchAllOrgUserByUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllOrgUserByUserIdDocument, options);
}
export function useFetchAllOrgUserByUserIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllOrgUserByUserIdDocument, options);
}
export const FetchAllOrgUsersDocument = gql `
    query fetchAllOrgUsers($fkOrganizationId: String) {
  fetchAllOrgUsers(fkOrganizationId: $fkOrganizationId) {
    ...OrganizationUserExtended
  }
}
    ${OrganizationUserExtendedFragmentDoc}`;
export function useFetchAllOrgUsersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllOrgUsersDocument, options);
}
export function useFetchAllOrgUsersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllOrgUsersDocument, options);
}
export function useFetchAllOrgUsersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllOrgUsersDocument, options);
}
export const FetchOrganizationsDocument = gql `
    query fetchOrganizations {
  fetchOrganizations {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOrganizationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsDocument, options);
}
export function useFetchOrganizationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsDocument, options);
}
export function useFetchOrganizationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsDocument, options);
}
export const FetchOrganizationsWithListingDocument = gql `
    query fetchOrganizationsWithListing {
  fetchOrganizationsWithListing {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOrganizationsWithListingQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsWithListingDocument, options);
}
export function useFetchOrganizationsWithListingLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsWithListingDocument, options);
}
export function useFetchOrganizationsWithListingSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsWithListingDocument, options);
}
export const FetchOrganizationsAndIndustriesWithListingsDocument = gql `
    query fetchOrganizationsAndIndustriesWithListings {
  fetchOrganizationsAndIndustriesWithListings {
    ...OrganizationIndustryListings
  }
}
    ${OrganizationIndustryListingsFragmentDoc}`;
export function useFetchOrganizationsAndIndustriesWithListingsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsAndIndustriesWithListingsDocument, options);
}
export function useFetchOrganizationsAndIndustriesWithListingsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsAndIndustriesWithListingsDocument, options);
}
export function useFetchOrganizationsAndIndustriesWithListingsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsAndIndustriesWithListingsDocument, options);
}
export const FetchOrgUserExtendedDocument = gql `
    query fetchOrgUserExtended($input: InputFetchOrgUser!) {
  fetchOrgUserExtended(input: $input) {
    ...OrganizationUserExtended
  }
}
    ${OrganizationUserExtendedFragmentDoc}`;
export function useFetchOrgUserExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrgUserExtendedDocument, options);
}
export function useFetchOrgUserExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrgUserExtendedDocument, options);
}
export function useFetchOrgUserExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrgUserExtendedDocument, options);
}
export const FetchSimpleOrganizationUsersDocument = gql `
    query fetchSimpleOrganizationUsers($input: InputFetchOrganizationUsers!) {
  fetchSimpleOrganizationUsers(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useFetchSimpleOrganizationUsersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSimpleOrganizationUsersDocument, options);
}
export function useFetchSimpleOrganizationUsersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSimpleOrganizationUsersDocument, options);
}
export function useFetchSimpleOrganizationUsersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSimpleOrganizationUsersDocument, options);
}
export const FetchOrganizationUsersDocument = gql `
    query fetchOrganizationUsers($input: InputFetchOrganizationUsers!) {
  fetchOrganizationUsers(input: $input) {
    ...OrganizationUserExtendedWithUser
  }
}
    ${OrganizationUserExtendedWithUserFragmentDoc}`;
export function useFetchOrganizationUsersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationUsersDocument, options);
}
export function useFetchOrganizationUsersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationUsersDocument, options);
}
export function useFetchOrganizationUsersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationUsersDocument, options);
}
export const FetchOrganizationUsersWithInvitesDocument = gql `
    query fetchOrganizationUsersWithInvites($organizationId: String!) {
  fetchOrganizationUsersWithInvites(organizationId: $organizationId) {
    users {
      ...OrganizationUserExtendedWithUser
    }
    invites {
      ...UserInviteExtended
    }
  }
}
    ${OrganizationUserExtendedWithUserFragmentDoc}
${UserInviteExtendedFragmentDoc}`;
export function useFetchOrganizationUsersWithInvitesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationUsersWithInvitesDocument, options);
}
export function useFetchOrganizationUsersWithInvitesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationUsersWithInvitesDocument, options);
}
export function useFetchOrganizationUsersWithInvitesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationUsersWithInvitesDocument, options);
}
export const FetchOrganizationUserByIdDocument = gql `
    query fetchOrganizationUserById($id: String!) {
  fetchOrganizationUserById(id: $id) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useFetchOrganizationUserByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationUserByIdDocument, options);
}
export function useFetchOrganizationUserByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationUserByIdDocument, options);
}
export function useFetchOrganizationUserByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationUserByIdDocument, options);
}
export const FetchOrganizationsByUserIdDocument = gql `
    query fetchOrganizationsByUserId($input: InputFetchOrgsByUserId!) {
  fetchOrganizationsByUserId(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useFetchOrganizationsByUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsByUserIdDocument, options);
}
export function useFetchOrganizationsByUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsByUserIdDocument, options);
}
export function useFetchOrganizationsByUserIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsByUserIdDocument, options);
}
export const FetchOrganizationUserExtendedWithTeamsByIdDocument = gql `
    query fetchOrganizationUserExtendedWithTeamsById($id: String!) {
  fetchOrganizationUserExtendedWithTeamsById(id: $id) {
    ...OrganizationUserExtendedWithTeamIDs
  }
}
    ${OrganizationUserExtendedWithTeamIDsFragmentDoc}`;
export function useFetchOrganizationUserExtendedWithTeamsByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationUserExtendedWithTeamsByIdDocument, options);
}
export function useFetchOrganizationUserExtendedWithTeamsByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationUserExtendedWithTeamsByIdDocument, options);
}
export function useFetchOrganizationUserExtendedWithTeamsByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationUserExtendedWithTeamsByIdDocument, options);
}
export const FetchOrganizationOwnersDocument = gql `
    query fetchOrganizationOwners($input: InputFetchOrgOwners!) {
  fetchOrganizationOwners(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useFetchOrganizationOwnersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationOwnersDocument, options);
}
export function useFetchOrganizationOwnersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationOwnersDocument, options);
}
export function useFetchOrganizationOwnersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationOwnersDocument, options);
}
export const CreateOrganizationDocument = gql `
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useCreateOrganizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateOrganizationDocument, options);
}
export const CreateOrganizationUserDocument = gql `
    mutation createOrganizationUser($input: CreateOrganizationUserInput!) {
  createOrganizationUser(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useCreateOrganizationUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateOrganizationUserDocument, options);
}
export const UpdateOrganizationDocument = gql `
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export function useUpdateOrganizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateOrganizationDocument, options);
}
export const EditOrganizationUserDocument = gql `
    mutation editOrganizationUser($input: EditOrganizationUserForm!) {
  editOrganizationUser(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useEditOrganizationUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditOrganizationUserDocument, options);
}
export const AssignOwnerDocument = gql `
    mutation assignOwner($input: AssignOwnerInput!) {
  assignOwner(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useAssignOwnerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(AssignOwnerDocument, options);
}
export const AssignOrganizationOwnersDocument = gql `
    mutation assignOrganizationOwners($input: AssignOrganizationOwnersInput!) {
  assignOrganizationOwners(input: $input) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useAssignOrganizationOwnersMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(AssignOrganizationOwnersDocument, options);
}
export const DeleteOrganizationUserDocument = gql `
    mutation deleteOrganizationUser($orgUserId: String!) {
  deleteOrganizationUser(orgUserId: $orgUserId) {
    ...OrganizationUser
  }
}
    ${OrganizationUserFragmentDoc}`;
export function useDeleteOrganizationUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteOrganizationUserDocument, options);
}
export const FetchSubscriptionInvoicesDocument = gql `
    query fetchSubscriptionInvoices($input: String!) {
  fetchSubscriptionInvoices(input: $input) {
    invoices {
      ...StripeInvoice
    }
    hasMore
  }
}
    ${StripeInvoiceFragmentDoc}`;
export function useFetchSubscriptionInvoicesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSubscriptionInvoicesDocument, options);
}
export function useFetchSubscriptionInvoicesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSubscriptionInvoicesDocument, options);
}
export function useFetchSubscriptionInvoicesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSubscriptionInvoicesDocument, options);
}
export const FetchOrganizationsStripeInvoicesDocument = gql `
    query fetchOrganizationsStripeInvoices($afterId: String) {
  fetchOrganizationsStripeInvoices(afterId: $afterId) {
    invoices {
      ...StripeInvoice
    }
    hasMore
  }
}
    ${StripeInvoiceFragmentDoc}`;
export function useFetchOrganizationsStripeInvoicesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsStripeInvoicesDocument, options);
}
export function useFetchOrganizationsStripeInvoicesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsStripeInvoicesDocument, options);
}
export function useFetchOrganizationsStripeInvoicesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsStripeInvoicesDocument, options);
}
export const FetchOrganizationsStripePaymentMethodsDocument = gql `
    query fetchOrganizationsStripePaymentMethods {
  fetchOrganizationsStripePaymentMethods {
    cards {
      ...StripePaymentMethodCard
    }
    links {
      ...StripePaymentMethodLink
    }
  }
}
    ${StripePaymentMethodCardFragmentDoc}
${StripePaymentMethodLinkFragmentDoc}`;
export function useFetchOrganizationsStripePaymentMethodsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOrganizationsStripePaymentMethodsDocument, options);
}
export function useFetchOrganizationsStripePaymentMethodsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOrganizationsStripePaymentMethodsDocument, options);
}
export function useFetchOrganizationsStripePaymentMethodsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOrganizationsStripePaymentMethodsDocument, options);
}
export const RemoveStripePaymentMethodDocument = gql `
    mutation removeStripePaymentMethod($paymentMethodId: String!) {
  removeStripePaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export function useRemoveStripePaymentMethodMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(RemoveStripePaymentMethodDocument, options);
}
export const FetchUserPlatformNotificationsCountDocument = gql `
    query fetchUserPlatformNotificationsCount($userId: String) {
  fetchUserPlatformNotificationsCount(userId: $userId)
}
    `;
export function useFetchUserPlatformNotificationsCountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserPlatformNotificationsCountDocument, options);
}
export function useFetchUserPlatformNotificationsCountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserPlatformNotificationsCountDocument, options);
}
export function useFetchUserPlatformNotificationsCountSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserPlatformNotificationsCountDocument, options);
}
export const FetchUserPlatformNotificationsDocument = gql `
    query fetchUserPlatformNotifications($input: InputPlatformNotification) {
  fetchUserPlatformNotifications(input: $input) {
    ...PlatformNotificationExtended
  }
}
    ${PlatformNotificationExtendedFragmentDoc}`;
export function useFetchUserPlatformNotificationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserPlatformNotificationsDocument, options);
}
export function useFetchUserPlatformNotificationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserPlatformNotificationsDocument, options);
}
export function useFetchUserPlatformNotificationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserPlatformNotificationsDocument, options);
}
export const UpdatePlatformNotificationDocument = gql `
    mutation updatePlatformNotification($input: UpdatePlatformNotification!) {
  updatePlatformNotification(input: $input) {
    ...PlatformNotification
  }
}
    ${PlatformNotificationFragmentDoc}`;
export function useUpdatePlatformNotificationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdatePlatformNotificationDocument, options);
}
export const FetchProductDocument = gql `
    query fetchProduct($input: InputProduct!) {
  fetchProduct(input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export function useFetchProductQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchProductDocument, options);
}
export function useFetchProductLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchProductDocument, options);
}
export function useFetchProductSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchProductDocument, options);
}
export const FetchAllProductsDocument = gql `
    query fetchAllProducts($input: InputFetchProducts!) {
  fetchAllProducts(input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export function useFetchAllProductsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllProductsDocument, options);
}
export function useFetchAllProductsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllProductsDocument, options);
}
export function useFetchAllProductsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllProductsDocument, options);
}
export const FetchProductExtendedByIdDocument = gql `
    query fetchProductExtendedById($id: String!) {
  fetchProductExtendedById(id: $id) {
    ...ProductExtendedProductUserExtended
  }
}
    ${ProductExtendedProductUserExtendedFragmentDoc}`;
export function useFetchProductExtendedByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchProductExtendedByIdDocument, options);
}
export function useFetchProductExtendedByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchProductExtendedByIdDocument, options);
}
export function useFetchProductExtendedByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchProductExtendedByIdDocument, options);
}
export const FetchProductUserExtendedDocument = gql `
    query fetchProductUserExtended($id: String!) {
  fetchProductUserExtended(id: $id) {
    ...ProductUserExtended
  }
}
    ${ProductUserExtendedFragmentDoc}`;
export function useFetchProductUserExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchProductUserExtendedDocument, options);
}
export function useFetchProductUserExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchProductUserExtendedDocument, options);
}
export function useFetchProductUserExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchProductUserExtendedDocument, options);
}
export const FetchAllProductExtendedProductUserExtendedDocument = gql `
    query fetchAllProductExtendedProductUserExtended($input: InputFetchProducts!) {
  fetchAllProductExtendedProductUserExtended(input: $input) {
    ...ProductExtendedProductUserExtended
  }
}
    ${ProductExtendedProductUserExtendedFragmentDoc}`;
export function useFetchAllProductExtendedProductUserExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllProductExtendedProductUserExtendedDocument, options);
}
export function useFetchAllProductExtendedProductUserExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllProductExtendedProductUserExtendedDocument, options);
}
export function useFetchAllProductExtendedProductUserExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllProductExtendedProductUserExtendedDocument, options);
}
export const FetchProductsByOrganizationUserIdDocument = gql `
    query fetchProductsByOrganizationUserId($input: InputProductUser) {
  fetchProductsByOrganizationUserId(input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export function useFetchProductsByOrganizationUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchProductsByOrganizationUserIdDocument, options);
}
export function useFetchProductsByOrganizationUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchProductsByOrganizationUserIdDocument, options);
}
export function useFetchProductsByOrganizationUserIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchProductsByOrganizationUserIdDocument, options);
}
export const FetchAllSpaceTeamMembersDocument = gql `
    query fetchAllSpaceTeamMembers($input: InputSpaceTeamMember) {
  fetchAllSpaceTeamMembers(input: $input) {
    ...SpaceTeamMember
  }
}
    ${SpaceTeamMemberFragmentDoc}`;
export function useFetchAllSpaceTeamMembersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllSpaceTeamMembersDocument, options);
}
export function useFetchAllSpaceTeamMembersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllSpaceTeamMembersDocument, options);
}
export function useFetchAllSpaceTeamMembersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllSpaceTeamMembersDocument, options);
}
export const CreateProductDocument = gql `
    mutation createProduct($input: InputCreateProduct!) {
  createProduct(input: $input) {
    ...ProductExtendedProductUserExtended
  }
}
    ${ProductExtendedProductUserExtendedFragmentDoc}`;
export function useCreateProductMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateProductDocument, options);
}
export const CreateProductUserDocument = gql `
    mutation createProductUser($input: CreateProductUser!) {
  createProductUser(input: $input) {
    ...ProductUser
  }
}
    ${ProductUserFragmentDoc}`;
export function useCreateProductUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateProductUserDocument, options);
}
export const DeleteProductUserDocument = gql `
    mutation deleteProductUser($id: String!) {
  deleteProductUser(id: $id) {
    ...ProductUser
  }
}
    ${ProductUserFragmentDoc}`;
export function useDeleteProductUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteProductUserDocument, options);
}
export const UpdateProductDocument = gql `
    mutation updateProduct($input: InputEditProduct!) {
  updateProduct(input: $input) {
    ...ProductExtendedProductUserExtended
  }
}
    ${ProductExtendedProductUserExtendedFragmentDoc}`;
export function useUpdateProductMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateProductDocument, options);
}
export const DeleteProductDocument = gql `
    mutation deleteProduct($input: InputDeleteProduct!) {
  deleteProduct(input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export function useDeleteProductMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteProductDocument, options);
}
export const FetchQuoteSampleDocument = gql `
    query fetchQuoteSample($input: InputQuoteLink!) {
  fetchQuoteSample(input: $input) {
    ...SampleDataSourceExtended
  }
}
    ${SampleDataSourceExtendedFragmentDoc}`;
export function useFetchQuoteSampleQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchQuoteSampleDocument, options);
}
export function useFetchQuoteSampleLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchQuoteSampleDocument, options);
}
export function useFetchQuoteSampleSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchQuoteSampleDocument, options);
}
export const FetchQuoteLinkUnauthedDocument = gql `
    query fetchQuoteLinkUnauthed($input: InputQuoteLink!) {
  fetchQuoteLinkUnauthed(input: $input) {
    ...QuoteLink
  }
}
    ${QuoteLinkFragmentDoc}`;
export function useFetchQuoteLinkUnauthedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchQuoteLinkUnauthedDocument, options);
}
export function useFetchQuoteLinkUnauthedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchQuoteLinkUnauthedDocument, options);
}
export function useFetchQuoteLinkUnauthedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchQuoteLinkUnauthedDocument, options);
}
export const FetchQuoteExtendedByIdDocument = gql `
    query fetchQuoteExtendedById($id: String!) {
  fetchQuoteExtendedById(id: $id) {
    ...QuoteExtended
  }
}
    ${QuoteExtendedFragmentDoc}`;
export function useFetchQuoteExtendedByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchQuoteExtendedByIdDocument, options);
}
export function useFetchQuoteExtendedByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchQuoteExtendedByIdDocument, options);
}
export function useFetchQuoteExtendedByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchQuoteExtendedByIdDocument, options);
}
export const FetchQuoteCustomerVariantConnectionDocument = gql `
    query fetchQuoteCustomerVariantConnection($input: DataGridFetchInput) {
  fetchQuoteCustomerVariantConnection(input: $input) {
    ...QuoteCustomerVariantConnection
  }
}
    ${QuoteCustomerVariantConnectionFragmentDoc}`;
export function useFetchQuoteCustomerVariantConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchQuoteCustomerVariantConnectionDocument, options);
}
export function useFetchQuoteCustomerVariantConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchQuoteCustomerVariantConnectionDocument, options);
}
export function useFetchQuoteCustomerVariantConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchQuoteCustomerVariantConnectionDocument, options);
}
export const PurchaseQuoteDocument = gql `
    mutation purchaseQuote($input: InputPurchaseQuote!) {
  purchaseQuote(input: $input) {
    ...DataSourcePermission
  }
}
    ${DataSourcePermissionFragmentDoc}`;
export function usePurchaseQuoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(PurchaseQuoteDocument, options);
}
export const DeleteQuoteDocument = gql `
    mutation deleteQuote($id: String!) {
  deleteQuote(id: $id) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;
export function useDeleteQuoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteQuoteDocument, options);
}
export const CreateQuoteDocument = gql `
    mutation createQuote($input: InputCreateQuote!) {
  createQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;
export function useCreateQuoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateQuoteDocument, options);
}
export const UpdateQuoteDocument = gql `
    mutation updateQuote($input: InputUpdateQuote!) {
  updateQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;
export function useUpdateQuoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateQuoteDocument, options);
}
export const FetchSavedViewDatasetsDocument = gql `
    query fetchSavedViewDatasets($id: String!) {
  fetchSavedViewDatasets(id: $id) {
    ...SavedViewDatasetExtended
  }
}
    ${SavedViewDatasetExtendedFragmentDoc}`;
export function useFetchSavedViewDatasetsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedViewDatasetsDocument, options);
}
export function useFetchSavedViewDatasetsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedViewDatasetsDocument, options);
}
export function useFetchSavedViewDatasetsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedViewDatasetsDocument, options);
}
export const FetchSavedViewExtendedDocument = gql `
    query fetchSavedViewExtended($id: String!, $withDatasets: Boolean) {
  fetchSavedViewExtended(id: $id, withDatasets: $withDatasets) {
    ...SavedViewExtended
  }
}
    ${SavedViewExtendedFragmentDoc}`;
export function useFetchSavedViewExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedViewExtendedDocument, options);
}
export function useFetchSavedViewExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedViewExtendedDocument, options);
}
export function useFetchSavedViewExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedViewExtendedDocument, options);
}
export const FetchSavedViewDocument = gql `
    query fetchSavedView($input: InputSavedView!) {
  fetchSavedView(input: $input) {
    ...SavedView
  }
}
    ${SavedViewFragmentDoc}`;
export function useFetchSavedViewQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedViewDocument, options);
}
export function useFetchSavedViewLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedViewDocument, options);
}
export function useFetchSavedViewSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedViewDocument, options);
}
export const FetchSavedViewsDocument = gql `
    query fetchSavedViews($input: InputSavedView!) {
  fetchSavedViews(input: $input) {
    ...SavedView
  }
}
    ${SavedViewFragmentDoc}`;
export function useFetchSavedViewsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSavedViewsDocument, options);
}
export function useFetchSavedViewsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSavedViewsDocument, options);
}
export function useFetchSavedViewsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSavedViewsDocument, options);
}
export const CreateSavedViewDocument = gql `
    mutation createSavedView($input: InputCreateSavedView!) {
  createSavedView(input: $input) {
    ...SavedView
  }
}
    ${SavedViewFragmentDoc}`;
export function useCreateSavedViewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateSavedViewDocument, options);
}
export const UpdateSavedViewDocument = gql `
    mutation updateSavedView($input: InputUpdateSavedView!) {
  updateSavedView(input: $input) {
    ...SavedView
  }
}
    ${SavedViewFragmentDoc}`;
export function useUpdateSavedViewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateSavedViewDocument, options);
}
export const DeleteSavedViewDocument = gql `
    mutation deleteSavedView($id: String!) {
  deleteSavedView(id: $id) {
    ...SavedView
  }
}
    ${SavedViewFragmentDoc}`;
export function useDeleteSavedViewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteSavedViewDocument, options);
}
export const FetchSendGridTemplatesDocument = gql `
    query fetchSendGridTemplates {
  fetchSendGridTemplates {
    templates {
      ...SendGridTemplate
    }
    count
  }
}
    ${SendGridTemplateFragmentDoc}`;
export function useFetchSendGridTemplatesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSendGridTemplatesDocument, options);
}
export function useFetchSendGridTemplatesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSendGridTemplatesDocument, options);
}
export function useFetchSendGridTemplatesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSendGridTemplatesDocument, options);
}
export const FetchSlackChannelsDocument = gql `
    query fetchSlackChannels {
  fetchSlackChannels {
    ...SlackChannel
  }
}
    ${SlackChannelFragmentDoc}`;
export function useFetchSlackChannelsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchSlackChannelsDocument, options);
}
export function useFetchSlackChannelsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchSlackChannelsDocument, options);
}
export function useFetchSlackChannelsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchSlackChannelsDocument, options);
}
export const ListenToComputeChangesDocument = gql `
    subscription listenToComputeChanges($channel: String!) {
  listenToComputeChanges(channel: $channel) {
    ...ComputeChanges
  }
}
    ${ComputeChangesFragmentDoc}`;
export function useListenToComputeChangesSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToComputeChangesDocument, options);
}
export const ListenToServerChangesDocument = gql `
    subscription listenToServerChanges($channel: String!) {
  listenToServerChanges(channel: $channel) {
    ...ServerChanges
  }
}
    ${ServerChangesFragmentDoc}`;
export function useListenToServerChangesSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToServerChangesDocument, options);
}
export const ListenToEtlProcessDocument = gql `
    subscription listenToEtlProcess($channel: String!) {
  listenToEtlProcess(channel: $channel) {
    datasetLocationId
    status
    count
    message
    type
  }
}
    `;
export function useListenToEtlProcessSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToEtlProcessDocument, options);
}
export const ListenToEtlOriginalSourcesProcessDocument = gql `
    subscription listenToEtlOriginalSourcesProcess($channel: String!) {
  listenToEtlOriginalSourcesProcess(channel: $channel) {
    ...EtlOriginalSourcesProcess
  }
}
    ${EtlOriginalSourcesProcessFragmentDoc}`;
export function useListenToEtlOriginalSourcesProcessSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToEtlOriginalSourcesProcessDocument, options);
}
export const ListenToComputeStatusDocument = gql `
    subscription listenToComputeStatus($channel: String!) {
  listenToComputeStatus(channel: $channel) {
    dataSource {
      ...DataSourceStudio
    }
    configuration {
      ...DataSourceConfiguration
    }
  }
}
    ${DataSourceStudioFragmentDoc}
${DataSourceConfigurationFragmentDoc}`;
export function useListenToComputeStatusSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToComputeStatusDocument, options);
}
export const ListenToFullEgressStatusDocument = gql `
    subscription listenToFullEgressStatus($channel: String!) {
  listenToFullEgressStatus(channel: $channel) {
    ...EgressSubscriptionReturn
  }
}
    ${EgressSubscriptionReturnFragmentDoc}`;
export function useListenToFullEgressStatusSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(ListenToFullEgressStatusDocument, options);
}
export const FetchTeamsDocument = gql `
    query fetchTeams($fkOrganizationId: String) {
  fetchTeams(fkOrganizationId: $fkOrganizationId) {
    ...TeamExtended
  }
}
    ${TeamExtendedFragmentDoc}`;
export function useFetchTeamsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchTeamsDocument, options);
}
export function useFetchTeamsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchTeamsDocument, options);
}
export function useFetchTeamsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchTeamsDocument, options);
}
export const FetchOneTeamDocument = gql `
    query fetchOneTeam($input: FetchOneTeamInput!) {
  fetchOneTeam(input: $input) {
    ...TeamExtended
  }
}
    ${TeamExtendedFragmentDoc}`;
export function useFetchOneTeamQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneTeamDocument, options);
}
export function useFetchOneTeamLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneTeamDocument, options);
}
export function useFetchOneTeamSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneTeamDocument, options);
}
export const FetchTeamMembersDocument = gql `
    query fetchTeamMembers($fkOrganizationId: String!) {
  fetchTeamMembers(fkOrganizationId: $fkOrganizationId) {
    ...TeamMemberExtendedWithUserAndTeam
  }
}
    ${TeamMemberExtendedWithUserAndTeamFragmentDoc}`;
export function useFetchTeamMembersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchTeamMembersDocument, options);
}
export function useFetchTeamMembersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchTeamMembersDocument, options);
}
export function useFetchTeamMembersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchTeamMembersDocument, options);
}
export const FetchTeamMembersByTeamDocument = gql `
    query fetchTeamMembersByTeam($input: FetchTeamMembersByTeamInput!) {
  fetchTeamMembersByTeam(input: $input) {
    ...TeamMemberExtendedWithUser
  }
}
    ${TeamMemberExtendedWithUserFragmentDoc}`;
export function useFetchTeamMembersByTeamQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchTeamMembersByTeamDocument, options);
}
export function useFetchTeamMembersByTeamLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchTeamMembersByTeamDocument, options);
}
export function useFetchTeamMembersByTeamSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchTeamMembersByTeamDocument, options);
}
export const FetchTeamsByOrgUserIdDocument = gql `
    query fetchTeamsByOrgUserId($fkOrganizationUserId: String!) {
  fetchTeamsByOrgUserId(fkOrganizationUserId: $fkOrganizationUserId) {
    ...TeamMemberExtendedWithUserAndTeam
  }
}
    ${TeamMemberExtendedWithUserAndTeamFragmentDoc}`;
export function useFetchTeamsByOrgUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchTeamsByOrgUserIdDocument, options);
}
export function useFetchTeamsByOrgUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchTeamsByOrgUserIdDocument, options);
}
export function useFetchTeamsByOrgUserIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchTeamsByOrgUserIdDocument, options);
}
export const FetchTeamMembersByOrgUserIdDocument = gql `
    query fetchTeamMembersByOrgUserId($fkOrganizationUserId: String!) {
  fetchTeamsByOrgUserId(fkOrganizationUserId: $fkOrganizationUserId) {
    ...TeamMemberExtendedWithUserAndTeam
  }
}
    ${TeamMemberExtendedWithUserAndTeamFragmentDoc}`;
export function useFetchTeamMembersByOrgUserIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchTeamMembersByOrgUserIdDocument, options);
}
export function useFetchTeamMembersByOrgUserIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchTeamMembersByOrgUserIdDocument, options);
}
export function useFetchTeamMembersByOrgUserIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchTeamMembersByOrgUserIdDocument, options);
}
export const CreateTeamDocument = gql `
    mutation createTeam($input: CreateTeamForm!) {
  createTeam(input: $input) {
    ...Team
  }
}
    ${TeamFragmentDoc}`;
export function useCreateTeamMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateTeamDocument, options);
}
export const EditTeamDocument = gql `
    mutation editTeam($input: EditTeamForm!) {
  editTeam(input: $input) {
    ...Team
  }
}
    ${TeamFragmentDoc}`;
export function useEditTeamMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(EditTeamDocument, options);
}
export const DeleteTeamDocument = gql `
    mutation deleteTeam($input: DeleteTeamForm!) {
  deleteTeam(input: $input) {
    ...Team
  }
}
    ${TeamFragmentDoc}`;
export function useDeleteTeamMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeleteTeamDocument, options);
}
export const FetchUserDataSamplesDocument = gql `
    query fetchUserDataSamples {
  fetchUserDataSamples {
    ...SampleDataSourceExtended
  }
}
    ${SampleDataSourceExtendedFragmentDoc}`;
export function useFetchUserDataSamplesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserDataSamplesDocument, options);
}
export function useFetchUserDataSamplesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserDataSamplesDocument, options);
}
export function useFetchUserDataSamplesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserDataSamplesDocument, options);
}
export const FetchDatascapeDataSourcesDocument = gql `
    query fetchDatascapeDataSources($input: InputDatascapeDataSource!) {
  fetchDatascapeDataSources(input: $input) {
    ...DataSourceWithConfigAndEtlConnection
  }
}
    ${DataSourceWithConfigAndEtlConnectionFragmentDoc}`;
export function useFetchDatascapeDataSourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchDatascapeDataSourcesDocument, options);
}
export function useFetchDatascapeDataSourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchDatascapeDataSourcesDocument, options);
}
export function useFetchDatascapeDataSourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchDatascapeDataSourcesDocument, options);
}
export const FetchAllUserSegmentsDocument = gql `
    query fetchAllUserSegments {
  fetchAllUserSegments {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export function useFetchAllUserSegmentsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAllUserSegmentsDocument, options);
}
export function useFetchAllUserSegmentsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAllUserSegmentsDocument, options);
}
export function useFetchAllUserSegmentsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAllUserSegmentsDocument, options);
}
export const FetchUserSegmentDocument = gql `
    query fetchUserSegment($id: String!) {
  fetchUserSegment(id: $id) {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export function useFetchUserSegmentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserSegmentDocument, options);
}
export function useFetchUserSegmentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserSegmentDocument, options);
}
export function useFetchUserSegmentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserSegmentDocument, options);
}
export const CreateEditUserSegmentDocument = gql `
    mutation createEditUserSegment($input: CreateEditUserSegmentInput!) {
  createEditUserSegment(input: $input) {
    ...UserSegment
  }
}
    ${UserSegmentFragmentDoc}`;
export function useCreateEditUserSegmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateEditUserSegmentDocument, options);
}
export const FetchUserSegmentUsersDocument = gql `
    query fetchUserSegmentUsers($input: IFetchUserSegmentUsersInput!) {
  fetchUserSegmentUsers(input: $input) {
    ...UserSegmentUsersConnection
  }
}
    ${UserSegmentUsersConnectionFragmentDoc}`;
export function useFetchUserSegmentUsersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserSegmentUsersDocument, options);
}
export function useFetchUserSegmentUsersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserSegmentUsersDocument, options);
}
export function useFetchUserSegmentUsersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserSegmentUsersDocument, options);
}
export const FetchAdminUsersDocument = gql `
    query fetchAdminUsers {
  fetchAdminUsers {
    ...User
  }
}
    ${UserFragmentDoc}`;
export function useFetchAdminUsersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchAdminUsersDocument, options);
}
export function useFetchAdminUsersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchAdminUsersDocument, options);
}
export function useFetchAdminUsersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchAdminUsersDocument, options);
}
export const FetchUserInvitesDocument = gql `
    query fetchUserInvites($input: InputFetchUserInvites!) {
  fetchUserInvites(input: $input) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useFetchUserInvitesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserInvitesDocument, options);
}
export function useFetchUserInvitesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserInvitesDocument, options);
}
export function useFetchUserInvitesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserInvitesDocument, options);
}
export const FetchUserInviteDocument = gql `
    query fetchUserInvite($input: InputFetchUserInvites!) {
  fetchUserInvite(input: $input) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useFetchUserInviteQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserInviteDocument, options);
}
export function useFetchUserInviteLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserInviteDocument, options);
}
export function useFetchUserInviteSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserInviteDocument, options);
}
export const FetchUserInviteByIdDocument = gql `
    query fetchUserInviteById($id: String!) {
  fetchUserInviteById(id: $id) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useFetchUserInviteByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserInviteByIdDocument, options);
}
export function useFetchUserInviteByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserInviteByIdDocument, options);
}
export function useFetchUserInviteByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserInviteByIdDocument, options);
}
export const FetchUserInviteExtendedDocument = gql `
    query fetchUserInviteExtended($input: InputFetchUserInvites!) {
  fetchUserInviteExtended(input: $input) {
    ...UserInviteExtended
  }
}
    ${UserInviteExtendedFragmentDoc}`;
export function useFetchUserInviteExtendedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserInviteExtendedDocument, options);
}
export function useFetchUserInviteExtendedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserInviteExtendedDocument, options);
}
export function useFetchUserInviteExtendedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserInviteExtendedDocument, options);
}
export const FetchOneUserDocument = gql `
    query fetchOneUser($userId: String) {
  fetchOneUser(userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export function useFetchOneUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchOneUserDocument, options);
}
export function useFetchOneUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchOneUserDocument, options);
}
export function useFetchOneUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchOneUserDocument, options);
}
export const FetchUserConnectionDocument = gql `
    query fetchUserConnection($input: InputFetchUserConnection!) {
  fetchUserConnection(input: $input) {
    ...UserConnection
  }
}
    ${UserConnectionFragmentDoc}`;
export function useFetchUserConnectionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteQuery(FetchUserConnectionDocument, options);
}
export function useFetchUserConnectionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteLazyQuery(FetchUserConnectionDocument, options);
}
export function useFetchUserConnectionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken
        ? baseOptions
        : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FetchUserConnectionDocument, options);
}
export const SignUpOrganizationUserDocument = gql `
    mutation signUpOrganizationUser($input: InputSignUpOrgUser!) {
  signUpOrganizationUser(input: $input) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useSignUpOrganizationUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SignUpOrganizationUserDocument, options);
}
export const ProvideAdminAccessDocument = gql `
    mutation provideAdminAccess($email: String!) {
  provideAdminAccess(email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export function useProvideAdminAccessMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ProvideAdminAccessDocument, options);
}
export const RemoveAdminAccessDocument = gql `
    mutation removeAdminAccess($email: String!) {
  removeAdminAccess(email: $email) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export function useRemoveAdminAccessMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(RemoveAdminAccessDocument, options);
}
export const CreateUserInviteDocument = gql `
    mutation createUserInvite($input: CreateUserInvite!) {
  createUserInvite(input: $input) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useCreateUserInviteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateUserInviteDocument, options);
}
export const UpdateUserInviteDocument = gql `
    mutation updateUserInvite($input: UpdateUserInvite!) {
  updateUserInvite(input: $input) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useUpdateUserInviteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateUserInviteDocument, options);
}
export const DeclineUserInviteDocument = gql `
    mutation declineUserInvite($input: UpdateUserInvite!) {
  declineUserInvite(input: $input) {
    ...UserInvite
  }
}
    ${UserInviteFragmentDoc}`;
export function useDeclineUserInviteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(DeclineUserInviteDocument, options);
}
export const SendUserInviteDocument = gql `
    mutation sendUserInvite($input: InputSendUserInvite!) {
  sendUserInvite(input: $input)
}
    `;
export function useSendUserInviteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SendUserInviteDocument, options);
}
export const CreateUserConnectionDocument = gql `
    mutation createUserConnection($input: InputCreateUserConnection!) {
  createUserConnection(input: $input) {
    ...UserConnection
  }
}
    ${UserConnectionFragmentDoc}`;
export function useCreateUserConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(CreateUserConnectionDocument, options);
}
export const GenerateTokenByEmailDocument = gql `
    mutation generateTokenByEmail($email: String!) {
  generateTokenByEmail(email: $email) {
    ...EmailVerifyResponse
  }
}
    ${EmailVerifyResponseFragmentDoc}`;
export function useGenerateTokenByEmailMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GenerateTokenByEmailDocument, options);
}
export const GenerateSignUpTokenByEmailDocument = gql `
    mutation generateSignUpTokenByEmail($email: String!) {
  generateSignUpTokenByEmail(email: $email) {
    ...EmailVerifyResponse
  }
}
    ${EmailVerifyResponseFragmentDoc}`;
export function useGenerateSignUpTokenByEmailMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(GenerateSignUpTokenByEmailDocument, options);
}
export const UpdateUserDocument = gql `
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export function useUpdateUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(UpdateUserDocument, options);
}
export const ValidateJwtDocument = gql `
    mutation validateJwt {
  validateJwt {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useValidateJwtMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ValidateJwtDocument, options);
}
export const ValidateUserWithTokenDocument = gql `
    mutation validateUserWithToken($input: CredentialsInput!) {
  validateUserWithToken(input: $input) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useValidateUserWithTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ValidateUserWithTokenDocument, options);
}
export const ValidatePossibleProductUserDocument = gql `
    mutation validatePossibleProductUser($organizationId: String!, $productPermission: ProductPermission!, $isSupport: Boolean) {
  validatePossibleProductUser(
    organizationId: $organizationId
    productPermission: $productPermission
    isSupport: $isSupport
  ) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useValidatePossibleProductUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ValidatePossibleProductUserDocument, options);
}
export const SwapProductAuthenticationDocument = gql `
    mutation swapProductAuthentication($productId: String!, $isSupport: Boolean) {
  swapProductAuthentication(productId: $productId, isSupport: $isSupport) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useSwapProductAuthenticationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SwapProductAuthenticationDocument, options);
}
export const SwapProductAuthenticationWithProductIdDocument = gql `
    mutation swapProductAuthenticationWithProductId($productId: String!) {
  swapProductAuthenticationWithProductId(productId: $productId) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useSwapProductAuthenticationWithProductIdMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SwapProductAuthenticationWithProductIdDocument, options);
}
export const SwapProductAuthenticationWithOrgIdDocument = gql `
    mutation swapProductAuthenticationWithOrgId($organizationId: String!, $productPermission: ProductPermission!) {
  swapProductAuthenticationWithOrgId(
    organizationId: $organizationId
    productPermission: $productPermission
  ) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useSwapProductAuthenticationWithOrgIdMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SwapProductAuthenticationWithOrgIdDocument, options);
}
export const SwapOrgAuthenticationDocument = gql `
    mutation swapOrgAuthentication($organizationId: String!) {
  swapOrgAuthentication(organizationId: $organizationId) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useSwapOrgAuthenticationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SwapOrgAuthenticationDocument, options);
}
export const ValidateInvitedUserWithTokenDocument = gql `
    mutation validateInvitedUserWithToken($input: InviteCredentialsInput!) {
  validateInvitedUserWithToken(input: $input) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useValidateInvitedUserWithTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ValidateInvitedUserWithTokenDocument, options);
}
export const SignInOrganizationSupportUserDocument = gql `
    mutation signInOrganizationSupportUser($fkOrganizationId: String!) {
  signInOrganizationSupportUser(fkOrganizationId: $fkOrganizationId) {
    organizationUserId
    token
    url
  }
}
    `;
export function useSignInOrganizationSupportUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(SignInOrganizationSupportUserDocument, options);
}
export const ValidateOrganizationSupportUserDocument = gql `
    mutation validateOrganizationSupportUser($token: String!) {
  validateOrganizationSupportUser(token: $token) {
    ...AuthenticatedUser
  }
}
    ${AuthenticatedUserFragmentDoc}`;
export function useValidateOrganizationSupportUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return useRemoteMutation(ValidateOrganizationSupportUserDocument, options);
}
//# sourceMappingURL=graphql.js.map